// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!../node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!../node_modules/tippy.js/dist/tippy.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%234caf50%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%275%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23343a40%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f44336%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f44336%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27101%27 height=%27101%27 view-box=%270 0 101 101%27 preserveAspectRatio=%27none%27%3e%3cpath fill=%27black%27 opacity=%27.3%27 d=%27M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27101%27 height=%27101%27 view-box=%270 0 101 101%27 preserveAspectRatio=%27none%27%3e%3cpath fill=%27black%27 d=%27M51 1l25 23 24 22H1l25-22z%27/%3e%3cpath fill=%27black%27 opacity=%27.3%27 d=%27M51 101l25-23 24-22H1l25 22z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27101%27 height=%27101%27 view-box=%270 0 101 101%27 preserveAspectRatio=%27none%27%3e%3cpath fill=%27black%27 opacity=%27.3%27 d=%27M51 1l25 23 24 22H1l25-22z%27/%3e%3cpath fill=%27black%27 d=%27M51 101l25-23 24-22H1l25 22z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27101%27 height=%27101%27 view-box=%270 0 101 101%27 preserveAspectRatio=%27none%27%3e%3cpath fill=%27white%27 opacity=%27.3%27 d=%27M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27101%27 height=%27101%27 view-box=%270 0 101 101%27 preserveAspectRatio=%27none%27%3e%3cpath fill=%27white%27 d=%27M51 1l25 23 24 22H1l25-22z%27/%3e%3cpath fill=%27white%27 opacity=%27.3%27 d=%27M51 101l25-23 24-22H1l25 22z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27101%27 height=%27101%27 view-box=%270 0 101 101%27 preserveAspectRatio=%27none%27%3e%3cpath fill=%27white%27 opacity=%27.3%27 d=%27M51 1l25 23 24 22H1l25-22z%27/%3e%3cpath fill=%27white%27 d=%27M51 101l25-23 24-22H1l25 22z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/***********************************************
Colors
***********************************************/
/***** Brand *****/
:root {
  /* Infinity brand colors */
  --color-brand: #e73389;
  --color-brand-dark: #af2769;
  --color-brand-light: #f29dc3;
  --color-brand-picker: #e73389;
  /* Infinity brand colors */
  --color-headerBg: #0a3749;
  --color-headerTxt: #ffffff;
  /* Infinity playback colors */
  --color-brandPlyr: #e73389;
  --color-brand-darkPlyr: #af2769;
  --color-brand-lightPlyr: #f29dc3;
  font-size: 14px;
}

/***** Infinity *****/
/***** Positive *****/
/***** Warning *****/
/***** Negative *****/
/***** Information *****/
/***** Royal *****/
/***** Sun *****/
/***** Slates *****/
/*slate*/
/*stone*/
/*silver*/
/***** Blacks *****/
/*black*/
/***** Grays *****/
/***** Brand greyout set *****/
/***** Brand greyout set *****/
/***********************************************
Colors
***********************************************/
/***** Brand *****/
:root {
  /* Infinity brand colors */
  --color-brand: #e73389;
  --color-brand-dark: #af2769;
  --color-brand-light: #f29dc3;
  --color-brand-picker: #e73389;
  /* Infinity brand colors */
  --color-headerBg: #0a3749;
  --color-headerTxt: #ffffff;
  /* Infinity playback colors */
  --color-brandPlyr: #e73389;
  --color-brand-darkPlyr: #af2769;
  --color-brand-lightPlyr: #f29dc3;
  font-size: 14px;
}

/***** Infinity *****/
/***** Positive *****/
/***** Warning *****/
/***** Negative *****/
/***** Information *****/
/***** Royal *****/
/***** Sun *****/
/***** Slates *****/
/*slate*/
/*stone*/
/*silver*/
/***** Blacks *****/
/*black*/
/***** Grays *****/
/***** Brand greyout set *****/
/***** Brand greyout set *****/
*,
*::before,
*::after {
  box-sizing: border-box;
}
html, #app {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}
body, #app {
  margin: 0;
  font-family: "Open Sans", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.2;
  color: #6c8892;
  text-align: left;
  background-color: #f0f2f4;
}
[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}
hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}
h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}
p {
  margin-top: 0;
  margin-bottom: 1rem;
}
abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  -webkit-text-decoration-skip-ink: none;
          text-decoration-skip-ink: none;
}
address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}
ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}
dt {
  font-weight: 700;
}
dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}
blockquote {
  margin: 0 0 1rem;
}
b,
strong {
  font-weight: bolder;
}
small {
  font-size: 80%;
}
sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
a {
  color: #2196f3;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: rgb(10.2307692308, 109.9807692308, 189.2692307692);
  text-decoration: underline;
}
a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}
pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}
pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}
figure {
  margin: 0 0 1rem;
}
img {
  vertical-align: middle;
  border-style: none;
}
svg {
  overflow: hidden;
  vertical-align: middle;
}
table {
  border-collapse: collapse;
}
caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}
th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}
label {
  display: inline-block;
  margin-bottom: 0.5rem;
}
button {
  border-radius: 0;
}
button:focus:not(:focus-visible) {
  outline: 0;
}
input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
button,
input {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
[role=button] {
  cursor: pointer;
}
select {
  word-wrap: normal;
}
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}
button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}
textarea {
  overflow: auto;
  resize: vertical;
}
fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}
progress {
  vertical-align: baseline;
}
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}
[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}
output {
  display: inline-block;
}
summary {
  display: list-item;
  cursor: pointer;
}
template {
  display: none;
}
[hidden] {
  display: none !important;
}
h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: #0a3749;
}
h1, .h1 {
  font-size: 2.5rem;
}
h2, .h2 {
  font-size: 2rem;
}
h3, .h3 {
  font-size: 1.75rem;
}
h4, .h4 {
  font-size: 1.5rem;
}
h5, .h5 {
  font-size: 1.25rem;
}
h6, .h6 {
  font-size: 1rem;
}
.lead {
  font-size: 1.25rem;
  font-weight: 300;
}
.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}
.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}
.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}
.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}
hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
small,
.small {
  font-size: 0.875em;
  font-weight: 400;
}
mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}
.list-unstyled {
  padding-left: 0;
  list-style: none;
}
.list-inline {
  padding-left: 0;
  list-style: none;
}
.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}
.initialism {
  font-size: 90%;
  text-transform: uppercase;
}
.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote-footer {
  display: block;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}
.img-fluid {
  max-width: 100%;
  height: auto;
}
.img-thumbnail {
  padding: 0.25rem;
  background-color: #f0f2f4;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}
.figure {
  display: inline-block;
}
.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}
.figure-caption {
  font-size: 90%;
  color: #6c757d;
}
code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}
kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #212529;
  border-radius: 0.15rem;
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}
pre {
  display: block;
  font-size: 87.5%;
  color: #212529;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}
.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}
.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
.container-sm, .container {
    max-width: 540px;
}
}
@media (min-width: 768px) {
.container-md, .container-sm, .container {
    max-width: 720px;
}
}
@media (min-width: 992px) {
.container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
}
}
@media (min-width: 1200px) {
.container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
}
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}
.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}
.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}
.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}
.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}
.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}
.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}
.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}
.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}
.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}
.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}
.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}
.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}
.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}
.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}
.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}
.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}
.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}
.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}
.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}
.order-first {
  order: -1;
}
.order-last {
  order: 13;
}
.order-0 {
  order: 0;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.order-4 {
  order: 4;
}
.order-5 {
  order: 5;
}
.order-6 {
  order: 6;
}
.order-7 {
  order: 7;
}
.order-8 {
  order: 8;
}
.order-9 {
  order: 9;
}
.order-10 {
  order: 10;
}
.order-11 {
  order: 11;
}
.order-12 {
  order: 12;
}
.offset-1 {
  margin-left: 8.33333333%;
}
.offset-2 {
  margin-left: 16.66666667%;
}
.offset-3 {
  margin-left: 25%;
}
.offset-4 {
  margin-left: 33.33333333%;
}
.offset-5 {
  margin-left: 41.66666667%;
}
.offset-6 {
  margin-left: 50%;
}
.offset-7 {
  margin-left: 58.33333333%;
}
.offset-8 {
  margin-left: 66.66666667%;
}
.offset-9 {
  margin-left: 75%;
}
.offset-10 {
  margin-left: 83.33333333%;
}
.offset-11 {
  margin-left: 91.66666667%;
}
@media (min-width: 576px) {
.col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
}
.row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
}
.row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
}
.row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
}
.row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
}
.row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
}
.row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
}
.col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
}
.col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
}
.col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
}
.col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
}
.col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
}
.col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
}
.col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
}
.col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
}
.col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
}
.col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
}
.col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
}
.col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
}
.col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
}
.order-sm-first {
    order: -1;
}
.order-sm-last {
    order: 13;
}
.order-sm-0 {
    order: 0;
}
.order-sm-1 {
    order: 1;
}
.order-sm-2 {
    order: 2;
}
.order-sm-3 {
    order: 3;
}
.order-sm-4 {
    order: 4;
}
.order-sm-5 {
    order: 5;
}
.order-sm-6 {
    order: 6;
}
.order-sm-7 {
    order: 7;
}
.order-sm-8 {
    order: 8;
}
.order-sm-9 {
    order: 9;
}
.order-sm-10 {
    order: 10;
}
.order-sm-11 {
    order: 11;
}
.order-sm-12 {
    order: 12;
}
.offset-sm-0 {
    margin-left: 0;
}
.offset-sm-1 {
    margin-left: 8.33333333%;
}
.offset-sm-2 {
    margin-left: 16.66666667%;
}
.offset-sm-3 {
    margin-left: 25%;
}
.offset-sm-4 {
    margin-left: 33.33333333%;
}
.offset-sm-5 {
    margin-left: 41.66666667%;
}
.offset-sm-6 {
    margin-left: 50%;
}
.offset-sm-7 {
    margin-left: 58.33333333%;
}
.offset-sm-8 {
    margin-left: 66.66666667%;
}
.offset-sm-9 {
    margin-left: 75%;
}
.offset-sm-10 {
    margin-left: 83.33333333%;
}
.offset-sm-11 {
    margin-left: 91.66666667%;
}
}
@media (min-width: 768px) {
.col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
}
.row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
}
.row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
}
.row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
}
.row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
}
.row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
}
.row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
}
.col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
}
.col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
}
.col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
}
.col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
}
.col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
}
.col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
}
.col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
}
.col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
}
.col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
}
.col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
}
.col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
}
.col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
}
.col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
}
.order-md-first {
    order: -1;
}
.order-md-last {
    order: 13;
}
.order-md-0 {
    order: 0;
}
.order-md-1 {
    order: 1;
}
.order-md-2 {
    order: 2;
}
.order-md-3 {
    order: 3;
}
.order-md-4 {
    order: 4;
}
.order-md-5 {
    order: 5;
}
.order-md-6 {
    order: 6;
}
.order-md-7 {
    order: 7;
}
.order-md-8 {
    order: 8;
}
.order-md-9 {
    order: 9;
}
.order-md-10 {
    order: 10;
}
.order-md-11 {
    order: 11;
}
.order-md-12 {
    order: 12;
}
.offset-md-0 {
    margin-left: 0;
}
.offset-md-1 {
    margin-left: 8.33333333%;
}
.offset-md-2 {
    margin-left: 16.66666667%;
}
.offset-md-3 {
    margin-left: 25%;
}
.offset-md-4 {
    margin-left: 33.33333333%;
}
.offset-md-5 {
    margin-left: 41.66666667%;
}
.offset-md-6 {
    margin-left: 50%;
}
.offset-md-7 {
    margin-left: 58.33333333%;
}
.offset-md-8 {
    margin-left: 66.66666667%;
}
.offset-md-9 {
    margin-left: 75%;
}
.offset-md-10 {
    margin-left: 83.33333333%;
}
.offset-md-11 {
    margin-left: 91.66666667%;
}
}
@media (min-width: 992px) {
.col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
}
.row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
}
.row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
}
.row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
}
.row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
}
.row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
}
.row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
}
.col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
}
.col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
}
.col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
}
.col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
}
.col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
}
.col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
}
.col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
}
.col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
}
.col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
}
.col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
}
.col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
}
.col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
}
.col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
}
.order-lg-first {
    order: -1;
}
.order-lg-last {
    order: 13;
}
.order-lg-0 {
    order: 0;
}
.order-lg-1 {
    order: 1;
}
.order-lg-2 {
    order: 2;
}
.order-lg-3 {
    order: 3;
}
.order-lg-4 {
    order: 4;
}
.order-lg-5 {
    order: 5;
}
.order-lg-6 {
    order: 6;
}
.order-lg-7 {
    order: 7;
}
.order-lg-8 {
    order: 8;
}
.order-lg-9 {
    order: 9;
}
.order-lg-10 {
    order: 10;
}
.order-lg-11 {
    order: 11;
}
.order-lg-12 {
    order: 12;
}
.offset-lg-0 {
    margin-left: 0;
}
.offset-lg-1 {
    margin-left: 8.33333333%;
}
.offset-lg-2 {
    margin-left: 16.66666667%;
}
.offset-lg-3 {
    margin-left: 25%;
}
.offset-lg-4 {
    margin-left: 33.33333333%;
}
.offset-lg-5 {
    margin-left: 41.66666667%;
}
.offset-lg-6 {
    margin-left: 50%;
}
.offset-lg-7 {
    margin-left: 58.33333333%;
}
.offset-lg-8 {
    margin-left: 66.66666667%;
}
.offset-lg-9 {
    margin-left: 75%;
}
.offset-lg-10 {
    margin-left: 83.33333333%;
}
.offset-lg-11 {
    margin-left: 91.66666667%;
}
}
@media (min-width: 1200px) {
.col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
}
.row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
}
.row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
}
.row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
}
.row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
}
.row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
}
.row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
}
.col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
}
.col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
}
.col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
}
.col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
}
.col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
}
.col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
}
.col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
}
.col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
}
.col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
}
.col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
}
.col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
}
.col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
}
.col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
}
.order-xl-first {
    order: -1;
}
.order-xl-last {
    order: 13;
}
.order-xl-0 {
    order: 0;
}
.order-xl-1 {
    order: 1;
}
.order-xl-2 {
    order: 2;
}
.order-xl-3 {
    order: 3;
}
.order-xl-4 {
    order: 4;
}
.order-xl-5 {
    order: 5;
}
.order-xl-6 {
    order: 6;
}
.order-xl-7 {
    order: 7;
}
.order-xl-8 {
    order: 8;
}
.order-xl-9 {
    order: 9;
}
.order-xl-10 {
    order: 10;
}
.order-xl-11 {
    order: 11;
}
.order-xl-12 {
    order: 12;
}
.offset-xl-0 {
    margin-left: 0;
}
.offset-xl-1 {
    margin-left: 8.33333333%;
}
.offset-xl-2 {
    margin-left: 16.66666667%;
}
.offset-xl-3 {
    margin-left: 25%;
}
.offset-xl-4 {
    margin-left: 33.33333333%;
}
.offset-xl-5 {
    margin-left: 41.66666667%;
}
.offset-xl-6 {
    margin-left: 50%;
}
.offset-xl-7 {
    margin-left: 58.33333333%;
}
.offset-xl-8 {
    margin-left: 66.66666667%;
}
.offset-xl-9 {
    margin-left: 75%;
}
.offset-xl-10 {
    margin-left: 83.33333333%;
}
.offset-xl-11 {
    margin-left: 91.66666667%;
}
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #6c8892;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
}
.table tbody + tbody {
  border-top: 2px solid #dee2e6;
}
.table-sm th,
.table-sm td {
  padding: 0.3rem;
}
.table-bordered {
  border: 1px solid #dee2e6;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}
.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
.table-hover tbody tr:hover {
  color: #6c8892;
  background-color: rgba(0, 0, 0, 0.075);
}
.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: rgb(192.84, 225.6, 251.64);
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: rgb(139.56, 200.4, 248.76);
}
.table-hover .table-primary:hover {
  background-color: rgb(168.6476923077, 214.1576923077, 250.3323076923);
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: rgb(168.6476923077, 214.1576923077, 250.3323076923);
}
.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: rgb(213.84, 216.36, 218.6);
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: rgb(178.56, 183.24, 187.4);
}
.table-hover .table-secondary:hover {
  background-color: rgb(200.3075090253, 203.6560288809, 206.6324909747);
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: rgb(200.3075090253, 203.6560288809, 206.6324909747);
}
.table-success,
.table-success > th,
.table-success > td {
  background-color: rgb(204.88, 232.6, 206);
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: rgb(161.92, 213.4, 164);
}
.table-hover .table-success:hover {
  background-color: rgb(187.2564478764, 224.7235521236, 188.7702702703);
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: rgb(187.2564478764, 224.7235521236, 188.7702702703);
}
.table-info,
.table-info > th,
.table-info > td {
  background-color: rgb(192.84, 225.6, 251.64);
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: rgb(139.56, 200.4, 248.76);
}
.table-hover .table-info:hover {
  background-color: rgb(168.6476923077, 214.1576923077, 250.3323076923);
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: rgb(168.6476923077, 214.1576923077, 250.3323076923);
}
.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: rgb(255, 237.64, 185.56);
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: rgb(255, 222.76, 126.04);
}
.table-hover .table-warning:hover {
  background-color: rgb(255, 231.265, 160.06);
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: rgb(255, 231.265, 160.06);
}
.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: rgb(251.92, 202.36, 198.72);
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: rgb(249.28, 157.24, 150.48);
}
.table-hover .table-danger:hover {
  background-color: rgb(250.5968867925, 179.7467924528, 174.5431132075);
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: rgb(250.5968867925, 179.7467924528, 174.5431132075);
}
.table-light,
.table-light > th,
.table-light > td {
  background-color: rgb(253.04, 253.32, 253.6);
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: rgb(251.36, 251.88, 252.4);
}
.table-hover .table-light:hover {
  background-color: rgb(238.165, 240.57, 242.975);
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: rgb(238.165, 240.57, 242.975);
}
.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: rgb(198.16, 199.84, 201.52);
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: rgb(149.44, 152.56, 155.68);
}
.table-hover .table-dark:hover {
  background-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.table-infinity,
.table-infinity > th,
.table-infinity > td {
  background-color: rgb(248.28, 197.88, 221.96);
}
.table-infinity th,
.table-infinity td,
.table-infinity thead th,
.table-infinity tbody + tbody {
  border-color: rgb(242.52, 148.92, 193.64);
}
.table-hover .table-infinity:hover {
  background-color: rgb(245.5957894737, 175.0642105263, 208.7626315789);
}
.table-hover .table-infinity:hover > td,
.table-hover .table-infinity:hover > th {
  background-color: rgb(245.5957894737, 175.0642105263, 208.7626315789);
}
.table-infinityDark,
.table-infinityDark > th,
.table-infinityDark > td {
  background-color: rgb(232.6, 194.52, 213);
}
.table-infinityDark th,
.table-infinityDark td,
.table-infinityDark thead th,
.table-infinityDark tbody + tbody {
  border-color: rgb(213.4, 142.68, 177);
}
.table-hover .table-infinityDark:hover {
  background-color: rgb(225.7081081081, 175.9118918919, 200.0777027027);
}
.table-hover .table-infinityDark:hover > td,
.table-hover .table-infinityDark:hover > th {
  background-color: rgb(225.7081081081, 175.9118918919, 200.0777027027);
}
.table-silver,
.table-silver > th,
.table-silver > td {
  background-color: rgb(235.96, 235.96, 235.96);
}
.table-silver th,
.table-silver td,
.table-silver thead th,
.table-silver tbody + tbody {
  border-color: rgb(219.64, 219.64, 219.64);
}
.table-hover .table-silver:hover {
  background-color: rgb(223.21, 223.21, 223.21);
}
.table-hover .table-silver:hover > td,
.table-hover .table-silver:hover > th {
  background-color: rgb(223.21, 223.21, 223.21);
}
.table-whale,
.table-whale > th,
.table-whale > td {
  background-color: rgb(186.4, 199, 204.04);
}
.table-whale th,
.table-whale td,
.table-whale thead th,
.table-whale tbody + tbody {
  border-color: rgb(127.6, 151, 160.36);
}
.table-hover .table-whale:hover {
  background-color: rgb(171.768852459, 187.056206089, 193.171147541);
}
.table-hover .table-whale:hover > td,
.table-hover .table-whale:hover > th {
  background-color: rgb(171.768852459, 187.056206089, 193.171147541);
}
.table-cello,
.table-cello > th,
.table-cello > td {
  background-color: rgb(199, 204.32, 208.24);
}
.table-cello th,
.table-cello td,
.table-cello thead th,
.table-cello tbody + tbody {
  border-color: rgb(151, 160.88, 168.16);
}
.table-hover .table-cello:hover {
  background-color: rgb(185.1035422343, 191.7437057221, 196.6364577657);
}
.table-hover .table-cello:hover > td,
.table-hover .table-cello:hover > th {
  background-color: rgb(185.1035422343, 191.7437057221, 196.6364577657);
}
.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}
.table-hover .table-active:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(0, 0, 0, 0.075);
}
.table .thead-dark th {
  color: #fff;
  background-color: #343a40;
  border-color: rgb(69.1465517241, 77.125, 85.1034482759);
}
.table .thead-light th {
  color: #495057;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.table-dark {
  color: #fff;
  background-color: #343a40;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: rgb(69.1465517241, 77.125, 85.1034482759);
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}
@media (max-width: 575.98px) {
.table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
.table-responsive-sm > .table-bordered {
    border: 0;
}
}
@media (max-width: 767.98px) {
.table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
.table-responsive-md > .table-bordered {
    border: 0;
}
}
@media (max-width: 991.98px) {
.table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
.table-responsive-lg > .table-bordered {
    border: 0;
}
}
@media (max-width: 1199.98px) {
.table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}
.table-responsive-xl > .table-bordered {
    border: 0;
}
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}
.form-control {
  display: block;
  width: 100%;
  height: calc(1.2em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.2;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
.form-control {
    transition: none;
}
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(153.9615384615, 207.2115384615, 249.5384615385);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}
.form-control::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}
select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}
.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.2;
}
.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}
.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}
.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.2;
  color: #6c8892;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}
.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.15rem;
}
.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.5rem;
}
select.form-control[size], select.form-control[multiple] {
  height: auto;
}
textarea.form-control {
  height: auto;
}
.form-group {
  margin-bottom: 1rem;
}
.form-text {
  display: block;
  margin-top: 0.25rem;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}
.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}
.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}
.form-check-label {
  margin-bottom: 0;
}
.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}
.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #4caf50;
}
.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.2;
  color: #fff;
  background-color: rgba(76, 175, 80, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .valid-tooltip, .form-row > [class*=col-] > .valid-tooltip {
  left: 5px;
}
.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #4caf50;
  padding-right: calc(1.2em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.3em + 0.1875rem) center;
  background-size: calc(0.6em + 0.375rem) calc(0.6em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #4caf50;
  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.25);
}
.was-validated select.form-control:valid, select.form-control.is-valid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}
.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.2em + 0.75rem);
  background-position: top calc(0.3em + 0.1875rem) right calc(0.3em + 0.1875rem);
}
.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #4caf50;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center right 1.75rem/calc(0.6em + 0.375rem) calc(0.6em + 0.375rem) no-repeat;
}
.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
  border-color: #4caf50;
  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #4caf50;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #4caf50;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #4caf50;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: rgb(109.9800796813, 192.0199203187, 113.2948207171);
  background-color: rgb(109.9800796813, 192.0199203187, 113.2948207171);
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.25);
}
.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #4caf50;
}
.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #4caf50;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #4caf50;
  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.25);
}
.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #f44336;
}
.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1.2;
  color: #fff;
  background-color: rgba(244, 67, 54, 0.9);
  border-radius: 0.25rem;
}
.form-row > .col > .invalid-tooltip, .form-row > [class*=col-] > .invalid-tooltip {
  left: 5px;
}
.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #f44336;
  padding-right: calc(1.2em + 0.75rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.3em + 0.1875rem) center;
  background-size: calc(0.6em + 0.375rem) calc(0.6em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #f44336;
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.25);
}
.was-validated select.form-control:invalid, select.form-control.is-invalid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}
.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.2em + 0.75rem);
  background-position: top calc(0.3em + 0.1875rem) right calc(0.3em + 0.1875rem);
}
.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #f44336;
  padding-right: calc(0.75em + 2.3125rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat, #fff url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center right 1.75rem/calc(0.6em + 0.375rem) calc(0.6em + 0.375rem) no-repeat;
}
.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
  border-color: #f44336;
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #f44336;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #f44336;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #f44336;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: rgb(246.6462264151, 112.2264150943, 102.3537735849);
  background-color: rgb(246.6462264151, 112.2264150943, 102.3537735849);
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.25);
}
.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #f44336;
}
.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #f44336;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #f44336;
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.25);
}
.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
.form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
}
.form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
}
.form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
}
.form-inline .form-control-plaintext {
    display: inline-block;
}
.form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
}
.form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
}
.form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
}
.form-inline .custom-control {
    align-items: center;
    justify-content: center;
}
.form-inline .custom-control-label {
    margin-bottom: 0;
}
}
.btn {
  display: inline-block;
  font-weight: 400;
  color: #6c8892;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.2;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
.btn {
    transition: none;
}
}
.btn:hover {
  color: #6c8892;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}
.btn-primary {
  color: #fff;
  background-color: #2196f3;
  border-color: #2196f3;
}
.btn-primary:hover {
  color: #fff;
  background-color: rgb(12.1923076923, 131.0673076923, 225.5576923077);
  border-color: rgb(11.5384615385, 124.0384615385, 213.4615384615);
}
.btn-primary:focus, .btn-primary.focus {
  color: #fff;
  background-color: rgb(12.1923076923, 131.0673076923, 225.5576923077);
  border-color: rgb(11.5384615385, 124.0384615385, 213.4615384615);
  box-shadow: 0 0 0 0 rgba(66.3, 165.75, 244.8, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #2196f3;
  border-color: #2196f3;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(11.5384615385, 124.0384615385, 213.4615384615);
  border-color: rgb(10.8846153846, 117.0096153846, 201.3653846154);
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(66.3, 165.75, 244.8, 0.5);
}
.btn-secondary {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:hover {
  color: #fff;
  background-color: rgb(90.2703862661, 97.7929184549, 104.4796137339);
  border-color: rgb(84.3605150215, 91.3905579399, 97.6394849785);
}
.btn-secondary:focus, .btn-secondary.focus {
  color: #fff;
  background-color: rgb(90.2703862661, 97.7929184549, 104.4796137339);
  border-color: rgb(84.3605150215, 91.3905579399, 97.6394849785);
  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(84.3605150215, 91.3905579399, 97.6394849785);
  border-color: rgb(78.4506437768, 84.9881974249, 90.7993562232);
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(130.05, 137.7, 144.5, 0.5);
}
.btn-success {
  color: #fff;
  background-color: #4caf50;
  border-color: #4caf50;
}
.btn-success:hover {
  color: #fff;
  background-color: rgb(64.4183266932, 148.3316733068, 67.8087649402);
  border-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
}
.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: rgb(64.4183266932, 148.3316733068, 67.8087649402);
  border-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
  box-shadow: 0 0 0 0 rgba(102.85, 187, 106.25, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #4caf50;
  border-color: #4caf50;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
  border-color: rgb(56.6972111554, 130.5527888446, 59.6812749004);
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(102.85, 187, 106.25, 0.5);
}
.btn-info {
  color: #fff;
  background-color: #2196f3;
  border-color: #2196f3;
}
.btn-info:hover {
  color: #fff;
  background-color: rgb(12.1923076923, 131.0673076923, 225.5576923077);
  border-color: rgb(11.5384615385, 124.0384615385, 213.4615384615);
}
.btn-info:focus, .btn-info.focus {
  color: #fff;
  background-color: rgb(12.1923076923, 131.0673076923, 225.5576923077);
  border-color: rgb(11.5384615385, 124.0384615385, 213.4615384615);
  box-shadow: 0 0 0 0 rgba(66.3, 165.75, 244.8, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #2196f3;
  border-color: #2196f3;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(11.5384615385, 124.0384615385, 213.4615384615);
  border-color: rgb(10.8846153846, 117.0096153846, 201.3653846154);
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(66.3, 165.75, 244.8, 0.5);
}
.btn-warning {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-warning:hover {
  color: #212529;
  background-color: rgb(223.75, 167.8125, 0);
  border-color: rgb(211, 158.25, 0);
}
.btn-warning:focus, .btn-warning.focus {
  color: #212529;
  background-color: rgb(223.75, 167.8125, 0);
  border-color: rgb(211, 158.25, 0);
  box-shadow: 0 0 0 0 rgba(221.7, 169.6, 12.1, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #212529;
  background-color: rgb(211, 158.25, 0);
  border-color: rgb(198.25, 148.6875, 0);
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(221.7, 169.6, 12.1, 0.5);
}
.btn-danger {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.btn-danger:hover {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
.btn-danger:focus, .btn-danger.focus {
  color: #fff;
  background-color: rgb(242.0153301887, 33.0801886792, 17.7346698113);
  border-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  box-shadow: 0 0 0 0 rgba(245.65, 95.2, 84.15, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
  border-color: rgb(222.0955188679, 26.5188679245, 12.1544811321);
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(245.65, 95.2, 84.15, 0.5);
}
.btn-light {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:hover {
  color: #212529;
  background-color: rgb(225.6875, 229.875, 234.0625);
  border-color: rgb(218.25, 223.5, 228.75);
}
.btn-light:focus, .btn-light.focus {
  color: #212529;
  background-color: rgb(225.6875, 229.875, 234.0625);
  border-color: rgb(218.25, 223.5, 228.75);
  box-shadow: 0 0 0 0 rgba(215.75, 217.2, 218.65, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #212529;
  background-color: rgb(218.25, 223.5, 228.75);
  border-color: rgb(210.8125, 217.125, 223.4375);
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(215.75, 217.2, 218.65, 0.5);
}
.btn-dark {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:hover {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
.btn-dark:focus, .btn-dark.focus {
  color: #fff;
  background-color: rgb(34.8534482759, 38.875, 42.8965517241);
  border-color: rgb(29.1379310345, 32.5, 35.8620689655);
  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
  border-color: rgb(23.4224137931, 26.125, 28.8275862069);
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(82.45, 87.55, 92.65, 0.5);
}
.btn-infinity {
  color: #fff;
  background-color: #e73389;
  border-color: #e73389;
}
.btn-infinity:hover {
  color: #fff;
  background-color: rgb(218.0921052632, 25.6578947368, 117.5986842105);
  border-color: rgb(206.6842105263, 24.3157894737, 111.4473684211);
}
.btn-infinity:focus, .btn-infinity.focus {
  color: #fff;
  background-color: rgb(218.0921052632, 25.6578947368, 117.5986842105);
  border-color: rgb(206.6842105263, 24.3157894737, 111.4473684211);
  box-shadow: 0 0 0 0 rgba(234.6, 81.6, 154.7, 0.5);
}
.btn-infinity.disabled, .btn-infinity:disabled {
  color: #fff;
  background-color: #e73389;
  border-color: #e73389;
}
.btn-infinity:not(:disabled):not(.disabled):active, .btn-infinity:not(:disabled):not(.disabled).active, .show > .btn-infinity.dropdown-toggle {
  color: #fff;
  background-color: rgb(206.6842105263, 24.3157894737, 111.4473684211);
  border-color: rgb(195.2763157895, 22.9736842105, 105.2960526316);
}
.btn-infinity:not(:disabled):not(.disabled):active:focus, .btn-infinity:not(:disabled):not(.disabled).active:focus, .show > .btn-infinity.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(234.6, 81.6, 154.7, 0.5);
}
.btn-infinityDark {
  color: #fff;
  background-color: #af2769;
  border-color: #af2769;
}
.btn-infinityDark:hover {
  color: #fff;
  background-color: rgb(143.7207943925, 32.0292056075, 86.2324766355);
  border-color: rgb(133.2943925234, 29.7056074766, 79.976635514);
}
.btn-infinityDark:focus, .btn-infinityDark.focus {
  color: #fff;
  background-color: rgb(143.7207943925, 32.0292056075, 86.2324766355);
  border-color: rgb(133.2943925234, 29.7056074766, 79.976635514);
  box-shadow: 0 0 0 0 rgba(187, 71.4, 127.5, 0.5);
}
.btn-infinityDark.disabled, .btn-infinityDark:disabled {
  color: #fff;
  background-color: #af2769;
  border-color: #af2769;
}
.btn-infinityDark:not(:disabled):not(.disabled):active, .btn-infinityDark:not(:disabled):not(.disabled).active, .show > .btn-infinityDark.dropdown-toggle {
  color: #fff;
  background-color: rgb(133.2943925234, 29.7056074766, 79.976635514);
  border-color: rgb(122.8679906542, 27.3820093458, 73.7207943925);
}
.btn-infinityDark:not(:disabled):not(.disabled):active:focus, .btn-infinityDark:not(:disabled):not(.disabled).active:focus, .show > .btn-infinityDark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(187, 71.4, 127.5, 0.5);
}
.btn-silver {
  color: #212529;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}
.btn-silver:hover {
  color: #212529;
  background-color: rgb(167.875, 167.875, 167.875);
  border-color: rgb(161.5, 161.5, 161.5);
}
.btn-silver:focus, .btn-silver.focus {
  color: #212529;
  background-color: rgb(167.875, 167.875, 167.875);
  border-color: rgb(161.5, 161.5, 161.5);
  box-shadow: 0 0 0 0 rgba(163.9, 164.5, 165.1, 0.5);
}
.btn-silver.disabled, .btn-silver:disabled {
  color: #212529;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}
.btn-silver:not(:disabled):not(.disabled):active, .btn-silver:not(:disabled):not(.disabled).active, .show > .btn-silver.dropdown-toggle {
  color: #212529;
  background-color: rgb(161.5, 161.5, 161.5);
  border-color: rgb(155.125, 155.125, 155.125);
}
.btn-silver:not(:disabled):not(.disabled):active:focus, .btn-silver:not(:disabled):not(.disabled).active:focus, .show > .btn-silver.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(163.9, 164.5, 165.1, 0.5);
}
.btn-whale {
  color: #fff;
  background-color: #0a3749;
  border-color: #0a3749;
}
.btn-whale:hover {
  color: #fff;
  background-color: rgb(5.3915662651, 29.6536144578, 39.3584337349);
  border-color: rgb(3.8554216867, 21.2048192771, 28.1445783133);
}
.btn-whale:focus, .btn-whale.focus {
  color: #fff;
  background-color: rgb(5.3915662651, 29.6536144578, 39.3584337349);
  border-color: rgb(3.8554216867, 21.2048192771, 28.1445783133);
  box-shadow: 0 0 0 0 rgba(46.75, 85, 100.3, 0.5);
}
.btn-whale.disabled, .btn-whale:disabled {
  color: #fff;
  background-color: #0a3749;
  border-color: #0a3749;
}
.btn-whale:not(:disabled):not(.disabled):active, .btn-whale:not(:disabled):not(.disabled).active, .show > .btn-whale.dropdown-toggle {
  color: #fff;
  background-color: rgb(3.8554216867, 21.2048192771, 28.1445783133);
  border-color: rgb(2.3192771084, 12.7560240964, 16.9307228916);
}
.btn-whale:not(:disabled):not(.disabled):active:focus, .btn-whale:not(:disabled):not(.disabled).active:focus, .show > .btn-whale.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(46.75, 85, 100.3, 0.5);
}
.btn-cello {
  color: #fff;
  background-color: #374a58;
  border-color: #374a58;
}
.btn-cello:hover {
  color: #fff;
  background-color: rgb(40.2884615385, 54.2062937063, 64.4615384615);
  border-color: rgb(35.3846153846, 47.6083916084, 56.6153846154);
}
.btn-cello:focus, .btn-cello.focus {
  color: #fff;
  background-color: rgb(40.2884615385, 54.2062937063, 64.4615384615);
  border-color: rgb(35.3846153846, 47.6083916084, 56.6153846154);
  box-shadow: 0 0 0 0 rgba(85, 101.15, 113.05, 0.5);
}
.btn-cello.disabled, .btn-cello:disabled {
  color: #fff;
  background-color: #374a58;
  border-color: #374a58;
}
.btn-cello:not(:disabled):not(.disabled):active, .btn-cello:not(:disabled):not(.disabled).active, .show > .btn-cello.dropdown-toggle {
  color: #fff;
  background-color: rgb(35.3846153846, 47.6083916084, 56.6153846154);
  border-color: rgb(30.4807692308, 41.0104895105, 48.7692307692);
}
.btn-cello:not(:disabled):not(.disabled):active:focus, .btn-cello:not(:disabled):not(.disabled).active:focus, .show > .btn-cello.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(85, 101.15, 113.05, 0.5);
}
.btn-outline-primary {
  color: #2196f3;
  border-color: #2196f3;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #2196f3;
  border-color: #2196f3;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #2196f3;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #2196f3;
  border-color: #2196f3;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.5);
}
.btn-outline-secondary {
  color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #6c757d;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #6c757d;
  border-color: #6c757d;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(108, 117, 125, 0.5);
}
.btn-outline-success {
  color: #4caf50;
  border-color: #4caf50;
}
.btn-outline-success:hover {
  color: #fff;
  background-color: #4caf50;
  border-color: #4caf50;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #4caf50;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #4caf50;
  border-color: #4caf50;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.5);
}
.btn-outline-info {
  color: #2196f3;
  border-color: #2196f3;
}
.btn-outline-info:hover {
  color: #fff;
  background-color: #2196f3;
  border-color: #2196f3;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #2196f3;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #2196f3;
  border-color: #2196f3;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.5);
}
.btn-outline-warning {
  color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:hover {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #ffc107;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #212529;
  background-color: #ffc107;
  border-color: #ffc107;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.5);
}
.btn-outline-danger {
  color: #f44336;
  border-color: #f44336;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #f44336;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #f44336;
  border-color: #f44336;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.5);
}
.btn-outline-light {
  color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:hover {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0 rgba(248, 249, 250, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #f8f9fa;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #212529;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(248, 249, 250, 0.5);
}
.btn-outline-dark {
  color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:hover {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #343a40;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #343a40;
  border-color: #343a40;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(52, 58, 64, 0.5);
}
.btn-outline-infinity {
  color: #e73389;
  border-color: #e73389;
}
.btn-outline-infinity:hover {
  color: #fff;
  background-color: #e73389;
  border-color: #e73389;
}
.btn-outline-infinity:focus, .btn-outline-infinity.focus {
  box-shadow: 0 0 0 0 rgba(231, 51, 137, 0.5);
}
.btn-outline-infinity.disabled, .btn-outline-infinity:disabled {
  color: #e73389;
  background-color: transparent;
}
.btn-outline-infinity:not(:disabled):not(.disabled):active, .btn-outline-infinity:not(:disabled):not(.disabled).active, .show > .btn-outline-infinity.dropdown-toggle {
  color: #fff;
  background-color: #e73389;
  border-color: #e73389;
}
.btn-outline-infinity:not(:disabled):not(.disabled):active:focus, .btn-outline-infinity:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-infinity.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(231, 51, 137, 0.5);
}
.btn-outline-infinityDark {
  color: #af2769;
  border-color: #af2769;
}
.btn-outline-infinityDark:hover {
  color: #fff;
  background-color: #af2769;
  border-color: #af2769;
}
.btn-outline-infinityDark:focus, .btn-outline-infinityDark.focus {
  box-shadow: 0 0 0 0 rgba(175, 39, 105, 0.5);
}
.btn-outline-infinityDark.disabled, .btn-outline-infinityDark:disabled {
  color: #af2769;
  background-color: transparent;
}
.btn-outline-infinityDark:not(:disabled):not(.disabled):active, .btn-outline-infinityDark:not(:disabled):not(.disabled).active, .show > .btn-outline-infinityDark.dropdown-toggle {
  color: #fff;
  background-color: #af2769;
  border-color: #af2769;
}
.btn-outline-infinityDark:not(:disabled):not(.disabled):active:focus, .btn-outline-infinityDark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-infinityDark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(175, 39, 105, 0.5);
}
.btn-outline-silver {
  color: #bbbbbb;
  border-color: #bbbbbb;
}
.btn-outline-silver:hover {
  color: #212529;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}
.btn-outline-silver:focus, .btn-outline-silver.focus {
  box-shadow: 0 0 0 0 rgba(187, 187, 187, 0.5);
}
.btn-outline-silver.disabled, .btn-outline-silver:disabled {
  color: #bbbbbb;
  background-color: transparent;
}
.btn-outline-silver:not(:disabled):not(.disabled):active, .btn-outline-silver:not(:disabled):not(.disabled).active, .show > .btn-outline-silver.dropdown-toggle {
  color: #212529;
  background-color: #bbbbbb;
  border-color: #bbbbbb;
}
.btn-outline-silver:not(:disabled):not(.disabled):active:focus, .btn-outline-silver:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-silver.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(187, 187, 187, 0.5);
}
.btn-outline-whale {
  color: #0a3749;
  border-color: #0a3749;
}
.btn-outline-whale:hover {
  color: #fff;
  background-color: #0a3749;
  border-color: #0a3749;
}
.btn-outline-whale:focus, .btn-outline-whale.focus {
  box-shadow: 0 0 0 0 rgba(10, 55, 73, 0.5);
}
.btn-outline-whale.disabled, .btn-outline-whale:disabled {
  color: #0a3749;
  background-color: transparent;
}
.btn-outline-whale:not(:disabled):not(.disabled):active, .btn-outline-whale:not(:disabled):not(.disabled).active, .show > .btn-outline-whale.dropdown-toggle {
  color: #fff;
  background-color: #0a3749;
  border-color: #0a3749;
}
.btn-outline-whale:not(:disabled):not(.disabled):active:focus, .btn-outline-whale:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-whale.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(10, 55, 73, 0.5);
}
.btn-outline-cello {
  color: #374a58;
  border-color: #374a58;
}
.btn-outline-cello:hover {
  color: #fff;
  background-color: #374a58;
  border-color: #374a58;
}
.btn-outline-cello:focus, .btn-outline-cello.focus {
  box-shadow: 0 0 0 0 rgba(55, 74, 88, 0.5);
}
.btn-outline-cello.disabled, .btn-outline-cello:disabled {
  color: #374a58;
  background-color: transparent;
}
.btn-outline-cello:not(:disabled):not(.disabled):active, .btn-outline-cello:not(:disabled):not(.disabled).active, .show > .btn-outline-cello.dropdown-toggle {
  color: #fff;
  background-color: #374a58;
  border-color: #374a58;
}
.btn-outline-cello:not(:disabled):not(.disabled):active:focus, .btn-outline-cello:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-cello.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 rgba(55, 74, 88, 0.5);
}
.btn-link {
  font-weight: 400;
  color: #2196f3;
  text-decoration: none;
}
.btn-link:hover {
  color: rgb(10.2307692308, 109.9807692308, 189.2692307692);
  text-decoration: underline;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
}
.btn-link:disabled, .btn-link.disabled {
  color: #6c757d;
  pointer-events: none;
}
.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.5rem;
}
.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.15rem;
}
.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}
input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}
.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
.fade {
    transition: none;
}
}
.fade:not(.show) {
  opacity: 0;
}
.collapse:not(.show) {
  display: none;
}
.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
.collapsing {
    transition: none;
}
}
.collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
.collapsing.width {
    transition: none;
}
}
.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}
.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #6c8892;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}
.dropdown-menu-left {
  right: auto;
  left: 0;
}
.dropdown-menu-right {
  right: 0;
  left: auto;
}
@media (min-width: 576px) {
.dropdown-menu-sm-left {
    right: auto;
    left: 0;
}
.dropdown-menu-sm-right {
    right: 0;
    left: auto;
}
}
@media (min-width: 768px) {
.dropdown-menu-md-left {
    right: auto;
    left: 0;
}
.dropdown-menu-md-right {
    right: 0;
    left: auto;
}
}
@media (min-width: 992px) {
.dropdown-menu-lg-left {
    right: auto;
    left: 0;
}
.dropdown-menu-lg-right {
    right: 0;
    left: auto;
}
}
@media (min-width: 1200px) {
.dropdown-menu-xl-left {
    right: auto;
    left: 0;
}
.dropdown-menu-xl-right {
    right: 0;
    left: auto;
}
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropright .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}
.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropleft .dropdown-toggle::after {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropleft .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}
.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}
.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}
.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: rgb(21.6283783784, 24.25, 26.8716216216);
  text-decoration: none;
  background-color: #e9ecef;
}
.dropdown-item.active, .dropdown-item:active {
  color: #fff;
  text-decoration: none;
  background-color: #2196f3;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #adb5bd;
  pointer-events: none;
  background-color: transparent;
}
.dropdown-menu.show {
  display: block;
}
.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #6c757d;
  white-space: nowrap;
}
.dropdown-item-text {
  display: block;
  padding: 0.25rem 1.5rem;
  color: #212529;
}
.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}
.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}
.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}
.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}
.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > .form-control:nth-last-child(n+3),
.input-group.has-validation > .custom-select:nth-last-child(n+3),
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}
.input-group-prepend {
  margin-right: -1px;
}
.input-group-append {
  margin-left: -1px;
}
.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.2;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}
.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px);
}
.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.5rem;
}
.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}
.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.15rem;
}
.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}
.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.2rem;
  padding-left: 1.5rem;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}
.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.1rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #2196f3;
  background-color: #2196f3;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: rgb(153.9615384615, 207.2115384615, 249.5384615385);
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: rgb(202.3461538462, 230.0961538462, 252.1538461538);
  border-color: rgb(202.3461538462, 230.0961538462, 252.1538461538);
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #6c757d;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #e9ecef;
}
.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.1rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: 1px solid #adb5bd;
}
.custom-control-label::after {
  position: absolute;
  top: 0.1rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}
.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #2196f3;
  background-color: #2196f3;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(33, 150, 243, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(33, 150, 243, 0.5);
}
.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(33, 150, 243, 0.5);
}
.custom-switch {
  padding-left: 2.25rem;
}
.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.1rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #adb5bd;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
.custom-switch .custom-control-label::after {
    transition: none;
}
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(33, 150, 243, 0.5);
}
.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.2em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.2;
  color: #495057;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.custom-select:focus {
  border-color: rgb(153.9615384615, 207.2115384615, 249.5384615385);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}
.custom-select:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #6c757d;
  background-color: #e9ecef;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #495057;
}
.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}
.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
}
.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.2em + 0.75rem + 2px);
  margin-bottom: 0;
}
.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.2em + 0.75rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: rgb(153.9615384615, 207.2115384615, 249.5384615385);
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: #e9ecef;
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}
.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.2em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.2;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.2em + 0.75rem);
  padding: 0.375rem 0.75rem;
  line-height: 1.2;
  color: #495057;
  content: "Browse";
  background-color: #e9ecef;
  border-left: inherit;
  border-radius: 0 0.25rem 0.25rem 0;
}
.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.custom-range:focus {
  outline: 0;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f0f2f4, 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f0f2f4, 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #f0f2f4, 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #2196f3;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
.custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
}
}
.custom-range::-webkit-slider-thumb {
  -webkit-appearance: none;
          appearance: none;
}
.custom-range::-webkit-slider-thumb:active {
  background-color: rgb(202.3461538462, 230.0961538462, 252.1538461538);
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #2196f3;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
.custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
}
}
.custom-range::-moz-range-thumb {
  -moz-appearance: none;
       appearance: none;
}
.custom-range::-moz-range-thumb:active {
  background-color: rgb(202.3461538462, 230.0961538462, 252.1538461538);
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #dee2e6;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #2196f3;
  border: 0;
  border-radius: 1rem;
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
.custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
}
}
.custom-range::-ms-thumb {
  appearance: none;
}
.custom-range::-ms-thumb:active {
  background-color: rgb(202.3461538462, 230.0961538462, 252.1538461538);
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
.custom-range::-ms-fill-lower {
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #dee2e6;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #adb5bd;
}
.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
.custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
}
}
.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #6c757d;
  pointer-events: none;
  cursor: default;
}
.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #e9ecef #e9ecef #dee2e6;
}
.nav-tabs .nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #f0f2f4;
  border-color: #dee2e6 #dee2e6 #f0f2f4;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.25rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #2196f3;
}
.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}
.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}
.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}
.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.35rem;
  padding-bottom: 0.35rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}
.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}
.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}
.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}
.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}
.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}
@media (max-width: 575.98px) {
.navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
}
}
@media (min-width: 576px) {
.navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
}
.navbar-expand-sm .navbar-nav {
    flex-direction: row;
}
.navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
}
.navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
}
.navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
}
.navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
}
.navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
}
.navbar-expand-sm .navbar-toggler {
    display: none;
}
}
@media (max-width: 767.98px) {
.navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
}
}
@media (min-width: 768px) {
.navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
}
.navbar-expand-md .navbar-nav {
    flex-direction: row;
}
.navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
}
.navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
}
.navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
}
.navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
}
.navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
}
.navbar-expand-md .navbar-toggler {
    display: none;
}
}
@media (max-width: 991.98px) {
.navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
}
}
@media (min-width: 992px) {
.navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
}
.navbar-expand-lg .navbar-nav {
    flex-direction: row;
}
.navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
}
.navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
}
.navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
}
.navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
}
.navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
}
.navbar-expand-lg .navbar-toggler {
    display: none;
}
}
@media (max-width: 1199.98px) {
.navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
}
}
@media (min-width: 1200px) {
.navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
}
.navbar-expand-xl .navbar-nav {
    flex-direction: row;
}
.navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
}
.navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
}
.navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
}
.navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
}
.navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
}
.navbar-expand-xl .navbar-toggler {
    display: none;
}
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #fff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fff;
}
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}
.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}
.card-title {
  margin-bottom: 0.75rem;
}
.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}
.card-text:last-child {
  margin-bottom: 0;
}
.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.25rem;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}
.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.25rem - 1px) calc(0.25rem - 1px);
}
.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}
.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}
.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.25rem - 1px);
}
.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}
.card-img,
.card-img-top {
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.card-deck .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
.card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
}
.card-deck .card {
    flex: 1 0 0%;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
}
}
.card-group > .card {
  margin-bottom: 15px;
}
@media (min-width: 576px) {
.card-group {
    display: flex;
    flex-flow: row wrap;
}
.card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
}
.card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
}
.card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
}
.card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
}
.card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
}
.card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
}
}
.card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
.card-columns {
    -moz-column-count: 3;
         column-count: 3;
    -moz-column-gap: 1.25rem;
         column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
}
.card-columns .card {
    display: inline-block;
    width: 100%;
}
}
.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -1px;
}
.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}
.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #6c757d;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #6c757d;
}
.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.25rem;
}
.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #2196f3;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  z-index: 2;
  color: rgb(10.2307692308, 109.9807692308, 189.2692307692);
  text-decoration: none;
  background-color: #e9ecef;
  border-color: #dee2e6;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}
.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #2196f3;
  border-color: #2196f3;
}
.page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #dee2e6;
}
.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.15rem;
  border-bottom-left-radius: 0.15rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.15rem;
  border-bottom-right-radius: 0.15rem;
}
.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
.badge {
    transition: none;
}
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}
.badge:empty {
  display: none;
}
.btn .badge {
  position: relative;
  top: -1px;
}
.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}
.badge-primary {
  color: #fff;
  background-color: #2196f3;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #fff;
  background-color: rgb(11.5384615385, 124.0384615385, 213.4615384615);
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.5);
}
.badge-secondary {
  color: #fff;
  background-color: #6c757d;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #fff;
  background-color: rgb(84.3605150215, 91.3905579399, 97.6394849785);
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(108, 117, 125, 0.5);
}
.badge-success {
  color: #fff;
  background-color: #4caf50;
}
a.badge-success:hover, a.badge-success:focus {
  color: #fff;
  background-color: rgb(60.5577689243, 139.4422310757, 63.7450199203);
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.5);
}
.badge-info {
  color: #fff;
  background-color: #2196f3;
}
a.badge-info:hover, a.badge-info:focus {
  color: #fff;
  background-color: rgb(11.5384615385, 124.0384615385, 213.4615384615);
}
a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.5);
}
.badge-warning {
  color: #212529;
  background-color: #ffc107;
}
a.badge-warning:hover, a.badge-warning:focus {
  color: #212529;
  background-color: rgb(211, 158.25, 0);
}
a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}
.badge-danger {
  color: #fff;
  background-color: #f44336;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #fff;
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358);
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.5);
}
.badge-light {
  color: #212529;
  background-color: #f8f9fa;
}
a.badge-light:hover, a.badge-light:focus {
  color: #212529;
  background-color: rgb(218.25, 223.5, 228.75);
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(248, 249, 250, 0.5);
}
.badge-dark {
  color: #fff;
  background-color: #343a40;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #fff;
  background-color: rgb(29.1379310345, 32.5, 35.8620689655);
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(52, 58, 64, 0.5);
}
.badge-infinity {
  color: #fff;
  background-color: #e73389;
}
a.badge-infinity:hover, a.badge-infinity:focus {
  color: #fff;
  background-color: rgb(206.6842105263, 24.3157894737, 111.4473684211);
}
a.badge-infinity:focus, a.badge-infinity.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(231, 51, 137, 0.5);
}
.badge-infinityDark {
  color: #fff;
  background-color: #af2769;
}
a.badge-infinityDark:hover, a.badge-infinityDark:focus {
  color: #fff;
  background-color: rgb(133.2943925234, 29.7056074766, 79.976635514);
}
a.badge-infinityDark:focus, a.badge-infinityDark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(175, 39, 105, 0.5);
}
.badge-silver {
  color: #212529;
  background-color: #bbbbbb;
}
a.badge-silver:hover, a.badge-silver:focus {
  color: #212529;
  background-color: rgb(161.5, 161.5, 161.5);
}
a.badge-silver:focus, a.badge-silver.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(187, 187, 187, 0.5);
}
.badge-whale {
  color: #fff;
  background-color: #0a3749;
}
a.badge-whale:hover, a.badge-whale:focus {
  color: #fff;
  background-color: rgb(3.8554216867, 21.2048192771, 28.1445783133);
}
a.badge-whale:focus, a.badge-whale.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(10, 55, 73, 0.5);
}
.badge-cello {
  color: #fff;
  background-color: #374a58;
}
a.badge-cello:hover, a.badge-cello:focus {
  color: #fff;
  background-color: rgb(35.3846153846, 47.6083916084, 56.6153846154);
}
a.badge-cello:focus, a.badge-cello.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 74, 88, 0.5);
}
.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #e9ecef;
  border-radius: 0.5rem;
}
@media (min-width: 576px) {
.jumbotron {
    padding: 4rem 2rem;
}
}
.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.alert-heading {
  color: inherit;
}
.alert-link {
  font-weight: 700;
}
.alert-dismissible {
  padding-right: 4rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.75rem 1.25rem;
  color: inherit;
}
.alert-primary {
  color: rgb(17.16, 78, 126.36);
  background-color: rgb(210.6, 234, 252.6);
  border-color: rgb(192.84, 225.6, 251.64);
}
.alert-primary hr {
  border-top-color: rgb(168.6476923077, 214.1576923077, 250.3323076923);
}
.alert-primary .alert-link {
  color: rgb(11.062173913, 50.2826086957, 81.457826087);
}
.alert-secondary {
  color: rgb(56.16, 60.84, 65);
  background-color: rgb(225.6, 227.4, 229);
  border-color: rgb(213.84, 216.36, 218.6);
}
.alert-secondary hr {
  border-top-color: rgb(200.3075090253, 203.6560288809, 206.6324909747);
}
.alert-secondary .alert-link {
  color: rgb(32.5205150215, 35.2305579399, 37.6394849785);
}
.alert-success {
  color: rgb(39.52, 91, 41.6);
  background-color: rgb(219.2, 239, 220);
  border-color: rgb(204.88, 232.6, 206);
}
.alert-success hr {
  border-top-color: rgb(187.2564478764, 224.7235521236, 188.7702702703);
}
.alert-success .alert-link {
  color: rgb(24.0777689243, 55.4422310757, 25.3450199203);
}
.alert-info {
  color: rgb(17.16, 78, 126.36);
  background-color: rgb(210.6, 234, 252.6);
  border-color: rgb(192.84, 225.6, 251.64);
}
.alert-info hr {
  border-top-color: rgb(168.6476923077, 214.1576923077, 250.3323076923);
}
.alert-info .alert-link {
  color: rgb(11.062173913, 50.2826086957, 81.457826087);
}
.alert-warning {
  color: rgb(132.6, 100.36, 3.64);
  background-color: rgb(255, 242.6, 205.4);
  border-color: rgb(255, 237.64, 185.56);
}
.alert-warning hr {
  border-top-color: rgb(255, 231.265, 160.06);
}
.alert-warning .alert-link {
  color: rgb(82.9625954198, 62.7912977099, 2.2774045802);
}
.alert-danger {
  color: rgb(126.88, 34.84, 28.08);
  background-color: rgb(252.8, 217.4, 214.8);
  border-color: rgb(251.92, 202.36, 198.72);
}
.alert-danger hr {
  border-top-color: rgb(250.5968867925, 179.7467924528, 174.5431132075);
}
.alert-danger .alert-link {
  color: rgb(85.1216107383, 23.373557047, 18.8383892617);
}
.alert-light {
  color: rgb(128.96, 129.48, 130);
  background-color: rgb(253.6, 253.8, 254);
  border-color: rgb(253.04, 253.32, 253.6);
}
.alert-light hr {
  border-top-color: rgb(238.165, 240.57, 242.975);
}
.alert-light .alert-link {
  color: rgb(103.5492351816, 103.98, 104.4107648184);
}
.alert-dark {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgb(214.4, 215.6, 216.8);
  border-color: rgb(198.16, 199.84, 201.52);
}
.alert-dark hr {
  border-top-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.alert-dark .alert-link {
  color: rgb(4.1779310345, 4.66, 5.1420689655);
}
.alert-infinity {
  color: rgb(120.12, 26.52, 71.24);
  background-color: rgb(250.2, 214.2, 231.4);
  border-color: rgb(248.28, 197.88, 221.96);
}
.alert-infinity hr {
  border-top-color: rgb(245.5957894737, 175.0642105263, 208.7626315789);
}
.alert-infinity .alert-link {
  color: rgb(78.3434042553, 17.2965957447, 46.4634042553);
}
.alert-infinityDark {
  color: rgb(91, 20.28, 54.6);
  background-color: rgb(239, 211.8, 225);
  border-color: rgb(232.6, 194.52, 213);
}
.alert-infinityDark hr {
  border-top-color: rgb(225.7081081081, 175.9118918919, 200.0777027027);
}
.alert-infinityDark .alert-link {
  color: rgb(49.2943925234, 10.9856074766, 29.576635514);
}
.alert-silver {
  color: rgb(97.24, 97.24, 97.24);
  background-color: rgb(241.4, 241.4, 241.4);
  border-color: rgb(235.96, 235.96, 235.96);
}
.alert-silver hr {
  border-top-color: rgb(223.21, 223.21, 223.21);
}
.alert-silver .alert-link {
  color: rgb(71.74, 71.74, 71.74);
}
.alert-whale {
  color: rgb(5.2, 28.6, 37.96);
  background-color: rgb(206, 215, 218.6);
  border-color: rgb(186.4, 199, 204.04);
}
.alert-whale hr {
  border-top-color: rgb(171.768852459, 187.056206089, 193.171147541);
}
.alert-whale .alert-link {
  color: black;
}
.alert-cello {
  color: rgb(28.6, 38.48, 45.76);
  background-color: rgb(215, 218.8, 221.6);
  border-color: rgb(199, 204.32, 208.24);
}
.alert-cello hr {
  border-top-color: rgb(185.1035422343, 191.7437057221, 196.6364577657);
}
.alert-cello .alert-link {
  color: rgb(8.9846153846, 12.0883916084, 14.3753846154);
}
@keyframes progress-bar-stripes {
from {
    background-position: 1rem 0;
}
to {
    background-position: 0 0;
}
}
.progress {
  display: flex;
  height: 1rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.25rem;
}
.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #2196f3;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
.progress-bar {
    transition: none;
}
}
.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 1rem 1rem;
}
.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
.progress-bar-animated {
    animation: none;
}
}
.media {
  display: flex;
  align-items: flex-start;
}
.media-body {
  flex: 1;
}
.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}
.list-group-item-action {
  width: 100%;
  color: #495057;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}
.list-group-item-action:active {
  color: #6c8892;
  background-color: #e9ecef;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #2196f3;
  border-color: #2196f3;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}
.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.25rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}
@media (min-width: 576px) {
.list-group-horizontal-sm {
    flex-direction: row;
}
.list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
}
.list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
}
.list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
}
.list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
}
.list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
}
}
@media (min-width: 768px) {
.list-group-horizontal-md {
    flex-direction: row;
}
.list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
}
.list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
}
.list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
}
.list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
}
.list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
}
}
@media (min-width: 992px) {
.list-group-horizontal-lg {
    flex-direction: row;
}
.list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
}
.list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
}
.list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
}
.list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
}
.list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
}
}
@media (min-width: 1200px) {
.list-group-horizontal-xl {
    flex-direction: row;
}
.list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.25rem;
    border-top-right-radius: 0;
}
.list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-left-radius: 0;
}
.list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
}
.list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
}
.list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
}
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}
.list-group-item-primary {
  color: rgb(17.16, 78, 126.36);
  background-color: rgb(192.84, 225.6, 251.64);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(17.16, 78, 126.36);
  background-color: rgb(168.6476923077, 214.1576923077, 250.3323076923);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(17.16, 78, 126.36);
  border-color: rgb(17.16, 78, 126.36);
}
.list-group-item-secondary {
  color: rgb(56.16, 60.84, 65);
  background-color: rgb(213.84, 216.36, 218.6);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(56.16, 60.84, 65);
  background-color: rgb(200.3075090253, 203.6560288809, 206.6324909747);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(56.16, 60.84, 65);
  border-color: rgb(56.16, 60.84, 65);
}
.list-group-item-success {
  color: rgb(39.52, 91, 41.6);
  background-color: rgb(204.88, 232.6, 206);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(39.52, 91, 41.6);
  background-color: rgb(187.2564478764, 224.7235521236, 188.7702702703);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(39.52, 91, 41.6);
  border-color: rgb(39.52, 91, 41.6);
}
.list-group-item-info {
  color: rgb(17.16, 78, 126.36);
  background-color: rgb(192.84, 225.6, 251.64);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(17.16, 78, 126.36);
  background-color: rgb(168.6476923077, 214.1576923077, 250.3323076923);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(17.16, 78, 126.36);
  border-color: rgb(17.16, 78, 126.36);
}
.list-group-item-warning {
  color: rgb(132.6, 100.36, 3.64);
  background-color: rgb(255, 237.64, 185.56);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(132.6, 100.36, 3.64);
  background-color: rgb(255, 231.265, 160.06);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(132.6, 100.36, 3.64);
  border-color: rgb(132.6, 100.36, 3.64);
}
.list-group-item-danger {
  color: rgb(126.88, 34.84, 28.08);
  background-color: rgb(251.92, 202.36, 198.72);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(126.88, 34.84, 28.08);
  background-color: rgb(250.5968867925, 179.7467924528, 174.5431132075);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(126.88, 34.84, 28.08);
  border-color: rgb(126.88, 34.84, 28.08);
}
.list-group-item-light {
  color: rgb(128.96, 129.48, 130);
  background-color: rgb(253.04, 253.32, 253.6);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(128.96, 129.48, 130);
  background-color: rgb(238.165, 240.57, 242.975);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(128.96, 129.48, 130);
  border-color: rgb(128.96, 129.48, 130);
}
.list-group-item-dark {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgb(198.16, 199.84, 201.52);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgb(185.0216751269, 187.09, 189.1583248731);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(27.04, 30.16, 33.28);
  border-color: rgb(27.04, 30.16, 33.28);
}
.list-group-item-infinity {
  color: rgb(120.12, 26.52, 71.24);
  background-color: rgb(248.28, 197.88, 221.96);
}
.list-group-item-infinity.list-group-item-action:hover, .list-group-item-infinity.list-group-item-action:focus {
  color: rgb(120.12, 26.52, 71.24);
  background-color: rgb(245.5957894737, 175.0642105263, 208.7626315789);
}
.list-group-item-infinity.list-group-item-action.active {
  color: #fff;
  background-color: rgb(120.12, 26.52, 71.24);
  border-color: rgb(120.12, 26.52, 71.24);
}
.list-group-item-infinityDark {
  color: rgb(91, 20.28, 54.6);
  background-color: rgb(232.6, 194.52, 213);
}
.list-group-item-infinityDark.list-group-item-action:hover, .list-group-item-infinityDark.list-group-item-action:focus {
  color: rgb(91, 20.28, 54.6);
  background-color: rgb(225.7081081081, 175.9118918919, 200.0777027027);
}
.list-group-item-infinityDark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(91, 20.28, 54.6);
  border-color: rgb(91, 20.28, 54.6);
}
.list-group-item-silver {
  color: rgb(97.24, 97.24, 97.24);
  background-color: rgb(235.96, 235.96, 235.96);
}
.list-group-item-silver.list-group-item-action:hover, .list-group-item-silver.list-group-item-action:focus {
  color: rgb(97.24, 97.24, 97.24);
  background-color: rgb(223.21, 223.21, 223.21);
}
.list-group-item-silver.list-group-item-action.active {
  color: #fff;
  background-color: rgb(97.24, 97.24, 97.24);
  border-color: rgb(97.24, 97.24, 97.24);
}
.list-group-item-whale {
  color: rgb(5.2, 28.6, 37.96);
  background-color: rgb(186.4, 199, 204.04);
}
.list-group-item-whale.list-group-item-action:hover, .list-group-item-whale.list-group-item-action:focus {
  color: rgb(5.2, 28.6, 37.96);
  background-color: rgb(171.768852459, 187.056206089, 193.171147541);
}
.list-group-item-whale.list-group-item-action.active {
  color: #fff;
  background-color: rgb(5.2, 28.6, 37.96);
  border-color: rgb(5.2, 28.6, 37.96);
}
.list-group-item-cello {
  color: rgb(28.6, 38.48, 45.76);
  background-color: rgb(199, 204.32, 208.24);
}
.list-group-item-cello.list-group-item-action:hover, .list-group-item-cello.list-group-item-action:focus {
  color: rgb(28.6, 38.48, 45.76);
  background-color: rgb(185.1035422343, 191.7437057221, 196.6364577657);
}
.list-group-item-cello.list-group-item-action.active {
  color: #fff;
  background-color: rgb(28.6, 38.48, 45.76);
  border-color: rgb(28.6, 38.48, 45.76);
}
.close {
  float: right;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
.close:hover {
  color: #000;
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}
button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}
a.close.disabled {
  pointer-events: none;
}
.toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem;
}
.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}
.toast.showing {
  opacity: 1;
}
.toast.show {
  display: block;
  opacity: 1;
}
.toast.hide {
  display: none;
}
.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #6c757d;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.toast-body {
  padding: 0.75rem;
}
.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}
.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
.modal.fade .modal-dialog {
    transition: none;
}
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}
.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}
.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: -moz-min-content;
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}
.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.5rem;
  outline: 0;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}
.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.5rem - 1px);
  border-top-right-radius: calc(0.5rem - 1px);
}
.modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}
.modal-title {
  margin-bottom: 0;
  line-height: 1.2;
}
.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}
.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.5rem - 1px);
  border-bottom-left-radius: calc(0.5rem - 1px);
}
.modal-footer > * {
  margin: 0.25rem;
}
.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}
@media (min-width: 576px) {
.modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
}
.modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
}
.modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
}
.modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
}
.modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: -moz-min-content;
    height: min-content;
}
.modal-sm {
    max-width: 300px;
}
}
@media (min-width: 992px) {
.modal-lg,
  .modal-xl {
    max-width: 800px;
}
}
@media (min-width: 1200px) {
.modal-xl {
    max-width: 1140px;
}
}
.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.2;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.5rem;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.5rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}
.bs-popover-top, .b-popover-cello.bs-popover-auto[x-placement^=top], .b-popover-whale.bs-popover-auto[x-placement^=top], .b-popover-silver.bs-popover-auto[x-placement^=top], .b-popover-infinityDark.bs-popover-auto[x-placement^=top], .b-popover-infinity.bs-popover-auto[x-placement^=top], .b-popover-dark.bs-popover-auto[x-placement^=top], .b-popover-light.bs-popover-auto[x-placement^=top], .b-popover-danger.bs-popover-auto[x-placement^=top], .b-popover-warning.bs-popover-auto[x-placement^=top], .b-popover-info.bs-popover-auto[x-placement^=top], .b-popover-success.bs-popover-auto[x-placement^=top], .b-popover-secondary.bs-popover-auto[x-placement^=top], .b-popover-primary.bs-popover-auto[x-placement^=top], .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}
.bs-popover-right, .b-popover-cello.bs-popover-auto[x-placement^=right], .b-popover-whale.bs-popover-auto[x-placement^=right], .b-popover-silver.bs-popover-auto[x-placement^=right], .b-popover-infinityDark.bs-popover-auto[x-placement^=right], .b-popover-infinity.bs-popover-auto[x-placement^=right], .b-popover-dark.bs-popover-auto[x-placement^=right], .b-popover-light.bs-popover-auto[x-placement^=right], .b-popover-danger.bs-popover-auto[x-placement^=right], .b-popover-warning.bs-popover-auto[x-placement^=right], .b-popover-info.bs-popover-auto[x-placement^=right], .b-popover-success.bs-popover-auto[x-placement^=right], .b-popover-secondary.bs-popover-auto[x-placement^=right], .b-popover-primary.bs-popover-auto[x-placement^=right], .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.5rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}
.bs-popover-bottom, .b-popover-cello.bs-popover-auto[x-placement^=bottom], .b-popover-whale.bs-popover-auto[x-placement^=bottom], .b-popover-silver.bs-popover-auto[x-placement^=bottom], .b-popover-infinityDark.bs-popover-auto[x-placement^=bottom], .b-popover-infinity.bs-popover-auto[x-placement^=bottom], .b-popover-dark.bs-popover-auto[x-placement^=bottom], .b-popover-light.bs-popover-auto[x-placement^=bottom], .b-popover-danger.bs-popover-auto[x-placement^=bottom], .b-popover-warning.bs-popover-auto[x-placement^=bottom], .b-popover-info.bs-popover-auto[x-placement^=bottom], .b-popover-success.bs-popover-auto[x-placement^=bottom], .b-popover-secondary.bs-popover-auto[x-placement^=bottom], .b-popover-primary.bs-popover-auto[x-placement^=bottom], .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid rgb(247.35, 247.35, 247.35);
}
.bs-popover-left, .b-popover-cello.bs-popover-auto[x-placement^=left], .b-popover-whale.bs-popover-auto[x-placement^=left], .b-popover-silver.bs-popover-auto[x-placement^=left], .b-popover-infinityDark.bs-popover-auto[x-placement^=left], .b-popover-infinity.bs-popover-auto[x-placement^=left], .b-popover-dark.bs-popover-auto[x-placement^=left], .b-popover-light.bs-popover-auto[x-placement^=left], .b-popover-danger.bs-popover-auto[x-placement^=left], .b-popover-warning.bs-popover-auto[x-placement^=left], .b-popover-info.bs-popover-auto[x-placement^=left], .b-popover-success.bs-popover-auto[x-placement^=left], .b-popover-secondary.bs-popover-auto[x-placement^=left], .b-popover-primary.bs-popover-auto[x-placement^=left], .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.5rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.25);
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}
.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: #0a3749;
  background-color: rgb(247.35, 247.35, 247.35);
  border-bottom: 1px solid rgb(234.6, 234.6, 234.6);
  border-top-left-radius: calc(0.5rem - 1px);
  border-top-right-radius: calc(0.5rem - 1px);
}
.popover-header:empty {
  display: none;
}
.popover-body {
  padding: 0.5rem 0.75rem;
  color: #6c8892;
}
.carousel {
  position: relative;
}
.carousel.pointer-event {
  touch-action: pan-y;
}
.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}
.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
.carousel-item {
    transition: none;
}
}
.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}
.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}
.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}
.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
.carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
}
}
.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
.carousel-control-prev,
  .carousel-control-next {
    transition: none;
}
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}
.carousel-control-prev {
  left: 0;
}
.carousel-control-next {
  right: 0;
}
.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}
.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
.carousel-indicators li {
    transition: none;
}
}
.carousel-indicators .active {
  opacity: 1;
}
.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}
@keyframes spinner-border {
to {
    transform: rotate(360deg);
}
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}
@keyframes spinner-grow {
0% {
    transform: scale(0);
}
50% {
    opacity: 1;
    transform: none;
}
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}
.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}
@media (prefers-reduced-motion: reduce) {
.spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
}
}
.align-baseline {
  vertical-align: baseline !important;
}
.align-top {
  vertical-align: top !important;
}
.align-middle {
  vertical-align: middle !important;
}
.align-bottom {
  vertical-align: bottom !important;
}
.align-text-bottom {
  vertical-align: text-bottom !important;
}
.align-text-top {
  vertical-align: text-top !important;
}
.bg-primary {
  background-color: #2196f3 !important;
}
a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: rgb(11.5384615385, 124.0384615385, 213.4615384615) !important;
}
.bg-secondary {
  background-color: #6c757d !important;
}
a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: rgb(84.3605150215, 91.3905579399, 97.6394849785) !important;
}
.bg-success {
  background-color: #4caf50 !important;
}
a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: rgb(60.5577689243, 139.4422310757, 63.7450199203) !important;
}
.bg-info {
  background-color: #2196f3 !important;
}
a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: rgb(11.5384615385, 124.0384615385, 213.4615384615) !important;
}
.bg-warning {
  background-color: #ffc107 !important;
}
a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: rgb(211, 158.25, 0) !important;
}
.bg-danger {
  background-color: #f44336 !important;
}
a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: rgb(234.1839622642, 27.9622641509, 12.8160377358) !important;
}
.bg-light {
  background-color: #f8f9fa !important;
}
a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: rgb(218.25, 223.5, 228.75) !important;
}
.bg-dark {
  background-color: #343a40 !important;
}
a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: rgb(29.1379310345, 32.5, 35.8620689655) !important;
}
.bg-infinity {
  background-color: #e73389 !important;
}
a.bg-infinity:hover, a.bg-infinity:focus,
button.bg-infinity:hover,
button.bg-infinity:focus {
  background-color: rgb(206.6842105263, 24.3157894737, 111.4473684211) !important;
}
.bg-infinityDark {
  background-color: #af2769 !important;
}
a.bg-infinityDark:hover, a.bg-infinityDark:focus,
button.bg-infinityDark:hover,
button.bg-infinityDark:focus {
  background-color: rgb(133.2943925234, 29.7056074766, 79.976635514) !important;
}
.bg-silver {
  background-color: #bbbbbb !important;
}
a.bg-silver:hover, a.bg-silver:focus,
button.bg-silver:hover,
button.bg-silver:focus {
  background-color: rgb(161.5, 161.5, 161.5) !important;
}
.bg-whale {
  background-color: #0a3749 !important;
}
a.bg-whale:hover, a.bg-whale:focus,
button.bg-whale:hover,
button.bg-whale:focus {
  background-color: rgb(3.8554216867, 21.2048192771, 28.1445783133) !important;
}
.bg-cello {
  background-color: #374a58 !important;
}
a.bg-cello:hover, a.bg-cello:focus,
button.bg-cello:hover,
button.bg-cello:focus {
  background-color: rgb(35.3846153846, 47.6083916084, 56.6153846154) !important;
}
.bg-white {
  background-color: #fff !important;
}
.bg-transparent {
  background-color: transparent !important;
}
.border {
  border: 1px solid #dee2e6 !important;
}
.border-top {
  border-top: 1px solid #dee2e6 !important;
}
.border-right {
  border-right: 1px solid #dee2e6 !important;
}
.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}
.border-left {
  border-left: 1px solid #dee2e6 !important;
}
.border-0 {
  border: 0 !important;
}
.border-top-0 {
  border-top: 0 !important;
}
.border-right-0 {
  border-right: 0 !important;
}
.border-bottom-0 {
  border-bottom: 0 !important;
}
.border-left-0 {
  border-left: 0 !important;
}
.border-primary {
  border-color: #2196f3 !important;
}
.border-secondary {
  border-color: #6c757d !important;
}
.border-success {
  border-color: #4caf50 !important;
}
.border-info {
  border-color: #2196f3 !important;
}
.border-warning {
  border-color: #ffc107 !important;
}
.border-danger {
  border-color: #f44336 !important;
}
.border-light {
  border-color: #f8f9fa !important;
}
.border-dark {
  border-color: #343a40 !important;
}
.border-infinity {
  border-color: #e73389 !important;
}
.border-infinityDark {
  border-color: #af2769 !important;
}
.border-silver {
  border-color: #bbbbbb !important;
}
.border-whale {
  border-color: #0a3749 !important;
}
.border-cello {
  border-color: #374a58 !important;
}
.border-white {
  border-color: #fff !important;
}
.rounded-sm {
  border-radius: 0.15rem !important;
}
.rounded {
  border-radius: 0.25rem !important;
}
.rounded-top {
  border-top-left-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
}
.rounded-right {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}
.rounded-bottom {
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
.rounded-left {
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
.rounded-lg {
  border-radius: 0.5rem !important;
}
.rounded-circle {
  border-radius: 50% !important;
}
.rounded-pill {
  border-radius: 50rem !important;
}
.rounded-0 {
  border-radius: 0 !important;
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}
.d-none {
  display: none !important;
}
.d-inline {
  display: inline !important;
}
.d-inline-block {
  display: inline-block !important;
}
.d-block {
  display: block !important;
}
.d-table {
  display: table !important;
}
.d-table-row {
  display: table-row !important;
}
.d-table-cell {
  display: table-cell !important;
}
.d-flex {
  display: flex !important;
}
.d-inline-flex {
  display: inline-flex !important;
}
@media (min-width: 576px) {
.d-sm-none {
    display: none !important;
}
.d-sm-inline {
    display: inline !important;
}
.d-sm-inline-block {
    display: inline-block !important;
}
.d-sm-block {
    display: block !important;
}
.d-sm-table {
    display: table !important;
}
.d-sm-table-row {
    display: table-row !important;
}
.d-sm-table-cell {
    display: table-cell !important;
}
.d-sm-flex {
    display: flex !important;
}
.d-sm-inline-flex {
    display: inline-flex !important;
}
}
@media (min-width: 768px) {
.d-md-none {
    display: none !important;
}
.d-md-inline {
    display: inline !important;
}
.d-md-inline-block {
    display: inline-block !important;
}
.d-md-block {
    display: block !important;
}
.d-md-table {
    display: table !important;
}
.d-md-table-row {
    display: table-row !important;
}
.d-md-table-cell {
    display: table-cell !important;
}
.d-md-flex {
    display: flex !important;
}
.d-md-inline-flex {
    display: inline-flex !important;
}
}
@media (min-width: 992px) {
.d-lg-none {
    display: none !important;
}
.d-lg-inline {
    display: inline !important;
}
.d-lg-inline-block {
    display: inline-block !important;
}
.d-lg-block {
    display: block !important;
}
.d-lg-table {
    display: table !important;
}
.d-lg-table-row {
    display: table-row !important;
}
.d-lg-table-cell {
    display: table-cell !important;
}
.d-lg-flex {
    display: flex !important;
}
.d-lg-inline-flex {
    display: inline-flex !important;
}
}
@media (min-width: 1200px) {
.d-xl-none {
    display: none !important;
}
.d-xl-inline {
    display: inline !important;
}
.d-xl-inline-block {
    display: inline-block !important;
}
.d-xl-block {
    display: block !important;
}
.d-xl-table {
    display: table !important;
}
.d-xl-table-row {
    display: table-row !important;
}
.d-xl-table-cell {
    display: table-cell !important;
}
.d-xl-flex {
    display: flex !important;
}
.d-xl-inline-flex {
    display: inline-flex !important;
}
}
@media print {
.d-print-none {
    display: none !important;
}
.d-print-inline {
    display: inline !important;
}
.d-print-inline-block {
    display: inline-block !important;
}
.d-print-block {
    display: block !important;
}
.d-print-table {
    display: table !important;
}
.d-print-table-row {
    display: table-row !important;
}
.d-print-table-cell {
    display: table-cell !important;
}
.d-print-flex {
    display: flex !important;
}
.d-print-inline-flex {
    display: inline-flex !important;
}
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}
.embed-responsive-16by9::before {
  padding-top: 56.25%;
}
.embed-responsive-4by3::before {
  padding-top: 75%;
}
.embed-responsive-1by1::before {
  padding-top: 100%;
}
.flex-row {
  flex-direction: row !important;
}
.flex-column {
  flex-direction: column !important;
}
.flex-row-reverse {
  flex-direction: row-reverse !important;
}
.flex-column-reverse {
  flex-direction: column-reverse !important;
}
.flex-wrap {
  flex-wrap: wrap !important;
}
.flex-nowrap {
  flex-wrap: nowrap !important;
}
.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}
.flex-fill {
  flex: 1 1 auto !important;
}
.flex-grow-0 {
  flex-grow: 0 !important;
}
.flex-grow-1 {
  flex-grow: 1 !important;
}
.flex-shrink-0 {
  flex-shrink: 0 !important;
}
.flex-shrink-1 {
  flex-shrink: 1 !important;
}
.justify-content-start {
  justify-content: flex-start !important;
}
.justify-content-end {
  justify-content: flex-end !important;
}
.justify-content-center {
  justify-content: center !important;
}
.justify-content-between {
  justify-content: space-between !important;
}
.justify-content-around {
  justify-content: space-around !important;
}
.align-items-start {
  align-items: flex-start !important;
}
.align-items-end {
  align-items: flex-end !important;
}
.align-items-center {
  align-items: center !important;
}
.align-items-baseline {
  align-items: baseline !important;
}
.align-items-stretch {
  align-items: stretch !important;
}
.align-content-start {
  align-content: flex-start !important;
}
.align-content-end {
  align-content: flex-end !important;
}
.align-content-center {
  align-content: center !important;
}
.align-content-between {
  align-content: space-between !important;
}
.align-content-around {
  align-content: space-around !important;
}
.align-content-stretch {
  align-content: stretch !important;
}
.align-self-auto {
  align-self: auto !important;
}
.align-self-start {
  align-self: flex-start !important;
}
.align-self-end {
  align-self: flex-end !important;
}
.align-self-center {
  align-self: center !important;
}
.align-self-baseline {
  align-self: baseline !important;
}
.align-self-stretch {
  align-self: stretch !important;
}
@media (min-width: 576px) {
.flex-sm-row {
    flex-direction: row !important;
}
.flex-sm-column {
    flex-direction: column !important;
}
.flex-sm-row-reverse {
    flex-direction: row-reverse !important;
}
.flex-sm-column-reverse {
    flex-direction: column-reverse !important;
}
.flex-sm-wrap {
    flex-wrap: wrap !important;
}
.flex-sm-nowrap {
    flex-wrap: nowrap !important;
}
.flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
}
.flex-sm-fill {
    flex: 1 1 auto !important;
}
.flex-sm-grow-0 {
    flex-grow: 0 !important;
}
.flex-sm-grow-1 {
    flex-grow: 1 !important;
}
.flex-sm-shrink-0 {
    flex-shrink: 0 !important;
}
.flex-sm-shrink-1 {
    flex-shrink: 1 !important;
}
.justify-content-sm-start {
    justify-content: flex-start !important;
}
.justify-content-sm-end {
    justify-content: flex-end !important;
}
.justify-content-sm-center {
    justify-content: center !important;
}
.justify-content-sm-between {
    justify-content: space-between !important;
}
.justify-content-sm-around {
    justify-content: space-around !important;
}
.align-items-sm-start {
    align-items: flex-start !important;
}
.align-items-sm-end {
    align-items: flex-end !important;
}
.align-items-sm-center {
    align-items: center !important;
}
.align-items-sm-baseline {
    align-items: baseline !important;
}
.align-items-sm-stretch {
    align-items: stretch !important;
}
.align-content-sm-start {
    align-content: flex-start !important;
}
.align-content-sm-end {
    align-content: flex-end !important;
}
.align-content-sm-center {
    align-content: center !important;
}
.align-content-sm-between {
    align-content: space-between !important;
}
.align-content-sm-around {
    align-content: space-around !important;
}
.align-content-sm-stretch {
    align-content: stretch !important;
}
.align-self-sm-auto {
    align-self: auto !important;
}
.align-self-sm-start {
    align-self: flex-start !important;
}
.align-self-sm-end {
    align-self: flex-end !important;
}
.align-self-sm-center {
    align-self: center !important;
}
.align-self-sm-baseline {
    align-self: baseline !important;
}
.align-self-sm-stretch {
    align-self: stretch !important;
}
}
@media (min-width: 768px) {
.flex-md-row {
    flex-direction: row !important;
}
.flex-md-column {
    flex-direction: column !important;
}
.flex-md-row-reverse {
    flex-direction: row-reverse !important;
}
.flex-md-column-reverse {
    flex-direction: column-reverse !important;
}
.flex-md-wrap {
    flex-wrap: wrap !important;
}
.flex-md-nowrap {
    flex-wrap: nowrap !important;
}
.flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
}
.flex-md-fill {
    flex: 1 1 auto !important;
}
.flex-md-grow-0 {
    flex-grow: 0 !important;
}
.flex-md-grow-1 {
    flex-grow: 1 !important;
}
.flex-md-shrink-0 {
    flex-shrink: 0 !important;
}
.flex-md-shrink-1 {
    flex-shrink: 1 !important;
}
.justify-content-md-start {
    justify-content: flex-start !important;
}
.justify-content-md-end {
    justify-content: flex-end !important;
}
.justify-content-md-center {
    justify-content: center !important;
}
.justify-content-md-between {
    justify-content: space-between !important;
}
.justify-content-md-around {
    justify-content: space-around !important;
}
.align-items-md-start {
    align-items: flex-start !important;
}
.align-items-md-end {
    align-items: flex-end !important;
}
.align-items-md-center {
    align-items: center !important;
}
.align-items-md-baseline {
    align-items: baseline !important;
}
.align-items-md-stretch {
    align-items: stretch !important;
}
.align-content-md-start {
    align-content: flex-start !important;
}
.align-content-md-end {
    align-content: flex-end !important;
}
.align-content-md-center {
    align-content: center !important;
}
.align-content-md-between {
    align-content: space-between !important;
}
.align-content-md-around {
    align-content: space-around !important;
}
.align-content-md-stretch {
    align-content: stretch !important;
}
.align-self-md-auto {
    align-self: auto !important;
}
.align-self-md-start {
    align-self: flex-start !important;
}
.align-self-md-end {
    align-self: flex-end !important;
}
.align-self-md-center {
    align-self: center !important;
}
.align-self-md-baseline {
    align-self: baseline !important;
}
.align-self-md-stretch {
    align-self: stretch !important;
}
}
@media (min-width: 992px) {
.flex-lg-row {
    flex-direction: row !important;
}
.flex-lg-column {
    flex-direction: column !important;
}
.flex-lg-row-reverse {
    flex-direction: row-reverse !important;
}
.flex-lg-column-reverse {
    flex-direction: column-reverse !important;
}
.flex-lg-wrap {
    flex-wrap: wrap !important;
}
.flex-lg-nowrap {
    flex-wrap: nowrap !important;
}
.flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
}
.flex-lg-fill {
    flex: 1 1 auto !important;
}
.flex-lg-grow-0 {
    flex-grow: 0 !important;
}
.flex-lg-grow-1 {
    flex-grow: 1 !important;
}
.flex-lg-shrink-0 {
    flex-shrink: 0 !important;
}
.flex-lg-shrink-1 {
    flex-shrink: 1 !important;
}
.justify-content-lg-start {
    justify-content: flex-start !important;
}
.justify-content-lg-end {
    justify-content: flex-end !important;
}
.justify-content-lg-center {
    justify-content: center !important;
}
.justify-content-lg-between {
    justify-content: space-between !important;
}
.justify-content-lg-around {
    justify-content: space-around !important;
}
.align-items-lg-start {
    align-items: flex-start !important;
}
.align-items-lg-end {
    align-items: flex-end !important;
}
.align-items-lg-center {
    align-items: center !important;
}
.align-items-lg-baseline {
    align-items: baseline !important;
}
.align-items-lg-stretch {
    align-items: stretch !important;
}
.align-content-lg-start {
    align-content: flex-start !important;
}
.align-content-lg-end {
    align-content: flex-end !important;
}
.align-content-lg-center {
    align-content: center !important;
}
.align-content-lg-between {
    align-content: space-between !important;
}
.align-content-lg-around {
    align-content: space-around !important;
}
.align-content-lg-stretch {
    align-content: stretch !important;
}
.align-self-lg-auto {
    align-self: auto !important;
}
.align-self-lg-start {
    align-self: flex-start !important;
}
.align-self-lg-end {
    align-self: flex-end !important;
}
.align-self-lg-center {
    align-self: center !important;
}
.align-self-lg-baseline {
    align-self: baseline !important;
}
.align-self-lg-stretch {
    align-self: stretch !important;
}
}
@media (min-width: 1200px) {
.flex-xl-row {
    flex-direction: row !important;
}
.flex-xl-column {
    flex-direction: column !important;
}
.flex-xl-row-reverse {
    flex-direction: row-reverse !important;
}
.flex-xl-column-reverse {
    flex-direction: column-reverse !important;
}
.flex-xl-wrap {
    flex-wrap: wrap !important;
}
.flex-xl-nowrap {
    flex-wrap: nowrap !important;
}
.flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
}
.flex-xl-fill {
    flex: 1 1 auto !important;
}
.flex-xl-grow-0 {
    flex-grow: 0 !important;
}
.flex-xl-grow-1 {
    flex-grow: 1 !important;
}
.flex-xl-shrink-0 {
    flex-shrink: 0 !important;
}
.flex-xl-shrink-1 {
    flex-shrink: 1 !important;
}
.justify-content-xl-start {
    justify-content: flex-start !important;
}
.justify-content-xl-end {
    justify-content: flex-end !important;
}
.justify-content-xl-center {
    justify-content: center !important;
}
.justify-content-xl-between {
    justify-content: space-between !important;
}
.justify-content-xl-around {
    justify-content: space-around !important;
}
.align-items-xl-start {
    align-items: flex-start !important;
}
.align-items-xl-end {
    align-items: flex-end !important;
}
.align-items-xl-center {
    align-items: center !important;
}
.align-items-xl-baseline {
    align-items: baseline !important;
}
.align-items-xl-stretch {
    align-items: stretch !important;
}
.align-content-xl-start {
    align-content: flex-start !important;
}
.align-content-xl-end {
    align-content: flex-end !important;
}
.align-content-xl-center {
    align-content: center !important;
}
.align-content-xl-between {
    align-content: space-between !important;
}
.align-content-xl-around {
    align-content: space-around !important;
}
.align-content-xl-stretch {
    align-content: stretch !important;
}
.align-self-xl-auto {
    align-self: auto !important;
}
.align-self-xl-start {
    align-self: flex-start !important;
}
.align-self-xl-end {
    align-self: flex-end !important;
}
.align-self-xl-center {
    align-self: center !important;
}
.align-self-xl-baseline {
    align-self: baseline !important;
}
.align-self-xl-stretch {
    align-self: stretch !important;
}
}
.float-left {
  float: left !important;
}
.float-right {
  float: right !important;
}
.float-none {
  float: none !important;
}
@media (min-width: 576px) {
.float-sm-left {
    float: left !important;
}
.float-sm-right {
    float: right !important;
}
.float-sm-none {
    float: none !important;
}
}
@media (min-width: 768px) {
.float-md-left {
    float: left !important;
}
.float-md-right {
    float: right !important;
}
.float-md-none {
    float: none !important;
}
}
@media (min-width: 992px) {
.float-lg-left {
    float: left !important;
}
.float-lg-right {
    float: right !important;
}
.float-lg-none {
    float: none !important;
}
}
@media (min-width: 1200px) {
.float-xl-left {
    float: left !important;
}
.float-xl-right {
    float: right !important;
}
.float-xl-none {
    float: none !important;
}
}
.user-select-all {
  -webkit-user-select: all !important;
     -moz-user-select: all !important;
          user-select: all !important;
}
.user-select-auto {
  -webkit-user-select: auto !important;
     -moz-user-select: auto !important;
          user-select: auto !important;
}
.user-select-none {
  -webkit-user-select: none !important;
     -moz-user-select: none !important;
          user-select: none !important;
}
.overflow-auto {
  overflow: auto !important;
}
.overflow-hidden {
  overflow: hidden !important;
}
.position-static {
  position: static !important;
}
.position-relative {
  position: relative !important;
}
.position-absolute {
  position: absolute !important;
}
.position-fixed {
  position: fixed !important;
}
.position-sticky {
  position: sticky !important;
}
.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}
@supports (position: sticky) {
.sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
}
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}
.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}
.shadow-none {
  box-shadow: none !important;
}
.w-25 {
  width: 25% !important;
}
.w-50 {
  width: 50% !important;
}
.w-75 {
  width: 75% !important;
}
.w-100 {
  width: 100% !important;
}
.w-auto {
  width: auto !important;
}
.h-25 {
  height: 25% !important;
}
.h-50 {
  height: 50% !important;
}
.h-75 {
  height: 75% !important;
}
.h-100 {
  height: 100% !important;
}
.h-auto {
  height: auto !important;
}
.mw-100 {
  max-width: 100% !important;
}
.mh-100 {
  max-height: 100% !important;
}
.min-vw-100 {
  min-width: 100vw !important;
}
.min-vh-100 {
  min-height: 100vh !important;
}
.vw-100 {
  width: 100vw !important;
}
.vh-100 {
  height: 100vh !important;
}
.m-0 {
  margin: 0 !important;
}
.mt-0,
.my-0 {
  margin-top: 0 !important;
}
.mr-0,
.mx-0 {
  margin-right: 0 !important;
}
.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}
.ml-0,
.mx-0 {
  margin-left: 0 !important;
}
.m-1 {
  margin: 0.25rem !important;
}
.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}
.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}
.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}
.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}
.m-2 {
  margin: 0.5rem !important;
}
.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}
.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}
.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}
.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}
.m-3 {
  margin: 1rem !important;
}
.mt-3,
.my-3 {
  margin-top: 1rem !important;
}
.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}
.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}
.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}
.m-4 {
  margin: 1.5rem !important;
}
.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}
.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}
.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}
.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}
.m-5 {
  margin: 3rem !important;
}
.mt-5,
.my-5 {
  margin-top: 3rem !important;
}
.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}
.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}
.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}
.p-0 {
  padding: 0 !important;
}
.pt-0,
.py-0 {
  padding-top: 0 !important;
}
.pr-0,
.px-0 {
  padding-right: 0 !important;
}
.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}
.pl-0,
.px-0 {
  padding-left: 0 !important;
}
.p-1 {
  padding: 0.25rem !important;
}
.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}
.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}
.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}
.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}
.p-2 {
  padding: 0.5rem !important;
}
.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}
.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}
.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}
.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}
.p-3 {
  padding: 1rem !important;
}
.pt-3,
.py-3 {
  padding-top: 1rem !important;
}
.pr-3,
.px-3 {
  padding-right: 1rem !important;
}
.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}
.pl-3,
.px-3 {
  padding-left: 1rem !important;
}
.p-4 {
  padding: 1.5rem !important;
}
.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}
.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}
.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}
.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}
.p-5 {
  padding: 3rem !important;
}
.pt-5,
.py-5 {
  padding-top: 3rem !important;
}
.pr-5,
.px-5 {
  padding-right: 3rem !important;
}
.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}
.pl-5,
.px-5 {
  padding-left: 3rem !important;
}
.m-n1 {
  margin: -0.25rem !important;
}
.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}
.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}
.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}
.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}
.m-n2 {
  margin: -0.5rem !important;
}
.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}
.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}
.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}
.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}
.m-n3 {
  margin: -1rem !important;
}
.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}
.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}
.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}
.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}
.m-n4 {
  margin: -1.5rem !important;
}
.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}
.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}
.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}
.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}
.m-n5 {
  margin: -3rem !important;
}
.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}
.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}
.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}
.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}
.m-auto {
  margin: auto !important;
}
.mt-auto,
.my-auto {
  margin-top: auto !important;
}
.mr-auto,
.mx-auto {
  margin-right: auto !important;
}
.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}
.ml-auto,
.mx-auto {
  margin-left: auto !important;
}
@media (min-width: 576px) {
.m-sm-0 {
    margin: 0 !important;
}
.mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
}
.mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
}
.mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
}
.ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
}
.m-sm-1 {
    margin: 0.25rem !important;
}
.mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
}
.mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
}
.mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
}
.ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
}
.m-sm-2 {
    margin: 0.5rem !important;
}
.mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
}
.mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
}
.mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
}
.ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
}
.m-sm-3 {
    margin: 1rem !important;
}
.mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
}
.mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
}
.mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
}
.ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
}
.m-sm-4 {
    margin: 1.5rem !important;
}
.mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
}
.mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
}
.mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
}
.ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
}
.m-sm-5 {
    margin: 3rem !important;
}
.mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
}
.mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
}
.mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
}
.ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
}
.p-sm-0 {
    padding: 0 !important;
}
.pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
}
.pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
}
.pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
}
.pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
}
.p-sm-1 {
    padding: 0.25rem !important;
}
.pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
}
.pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
}
.pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
}
.pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
}
.p-sm-2 {
    padding: 0.5rem !important;
}
.pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
}
.pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
}
.pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
}
.pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
}
.p-sm-3 {
    padding: 1rem !important;
}
.pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
}
.pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
}
.pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
}
.pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
}
.p-sm-4 {
    padding: 1.5rem !important;
}
.pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
}
.pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
}
.pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
}
.pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
}
.p-sm-5 {
    padding: 3rem !important;
}
.pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
}
.pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
}
.pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
}
.pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
}
.m-sm-n1 {
    margin: -0.25rem !important;
}
.mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
}
.mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
}
.mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
}
.ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
}
.m-sm-n2 {
    margin: -0.5rem !important;
}
.mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
}
.mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
}
.mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
}
.ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
}
.m-sm-n3 {
    margin: -1rem !important;
}
.mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
}
.mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
}
.mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
}
.ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
}
.m-sm-n4 {
    margin: -1.5rem !important;
}
.mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
}
.mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
}
.mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
}
.ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
}
.m-sm-n5 {
    margin: -3rem !important;
}
.mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
}
.mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
}
.mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
}
.ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
}
.m-sm-auto {
    margin: auto !important;
}
.mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
}
.mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
}
.mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
}
.ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
}
}
@media (min-width: 768px) {
.m-md-0 {
    margin: 0 !important;
}
.mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
}
.mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
}
.mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
}
.ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
}
.m-md-1 {
    margin: 0.25rem !important;
}
.mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
}
.mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
}
.mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
}
.ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
}
.m-md-2 {
    margin: 0.5rem !important;
}
.mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
}
.mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
}
.mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
}
.ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
}
.m-md-3 {
    margin: 1rem !important;
}
.mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
}
.mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
}
.mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
}
.ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
}
.m-md-4 {
    margin: 1.5rem !important;
}
.mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
}
.mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
}
.mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
}
.ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
}
.m-md-5 {
    margin: 3rem !important;
}
.mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
}
.mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
}
.mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
}
.ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
}
.p-md-0 {
    padding: 0 !important;
}
.pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
}
.pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
}
.pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
}
.pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
}
.p-md-1 {
    padding: 0.25rem !important;
}
.pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
}
.pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
}
.pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
}
.pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
}
.p-md-2 {
    padding: 0.5rem !important;
}
.pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
}
.pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
}
.pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
}
.pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
}
.p-md-3 {
    padding: 1rem !important;
}
.pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
}
.pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
}
.pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
}
.pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
}
.p-md-4 {
    padding: 1.5rem !important;
}
.pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
}
.pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
}
.pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
}
.pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
}
.p-md-5 {
    padding: 3rem !important;
}
.pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
}
.pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
}
.pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
}
.pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
}
.m-md-n1 {
    margin: -0.25rem !important;
}
.mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
}
.mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
}
.mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
}
.ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
}
.m-md-n2 {
    margin: -0.5rem !important;
}
.mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
}
.mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
}
.mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
}
.ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
}
.m-md-n3 {
    margin: -1rem !important;
}
.mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
}
.mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
}
.mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
}
.ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
}
.m-md-n4 {
    margin: -1.5rem !important;
}
.mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
}
.mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
}
.mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
}
.ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
}
.m-md-n5 {
    margin: -3rem !important;
}
.mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
}
.mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
}
.mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
}
.ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
}
.m-md-auto {
    margin: auto !important;
}
.mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
}
.mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
}
.mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
}
.ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
}
}
@media (min-width: 992px) {
.m-lg-0 {
    margin: 0 !important;
}
.mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
}
.mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
}
.mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
}
.ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
}
.m-lg-1 {
    margin: 0.25rem !important;
}
.mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
}
.mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
}
.mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
}
.ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
}
.m-lg-2 {
    margin: 0.5rem !important;
}
.mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
}
.mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
}
.mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
}
.ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
}
.m-lg-3 {
    margin: 1rem !important;
}
.mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
}
.mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
}
.mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
}
.ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
}
.m-lg-4 {
    margin: 1.5rem !important;
}
.mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
}
.mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
}
.mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
}
.ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
}
.m-lg-5 {
    margin: 3rem !important;
}
.mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
}
.mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
}
.mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
}
.ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
}
.p-lg-0 {
    padding: 0 !important;
}
.pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
}
.pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
}
.pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
}
.pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
}
.p-lg-1 {
    padding: 0.25rem !important;
}
.pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
}
.pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
}
.pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
}
.pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
}
.p-lg-2 {
    padding: 0.5rem !important;
}
.pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
}
.pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
}
.pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
}
.pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
}
.p-lg-3 {
    padding: 1rem !important;
}
.pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
}
.pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
}
.pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
}
.pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
}
.p-lg-4 {
    padding: 1.5rem !important;
}
.pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
}
.pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
}
.pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
}
.pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
}
.p-lg-5 {
    padding: 3rem !important;
}
.pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
}
.pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
}
.pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
}
.pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
}
.m-lg-n1 {
    margin: -0.25rem !important;
}
.mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
}
.mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
}
.mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
}
.ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
}
.m-lg-n2 {
    margin: -0.5rem !important;
}
.mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
}
.mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
}
.mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
}
.ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
}
.m-lg-n3 {
    margin: -1rem !important;
}
.mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
}
.mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
}
.mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
}
.ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
}
.m-lg-n4 {
    margin: -1.5rem !important;
}
.mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
}
.mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
}
.mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
}
.ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
}
.m-lg-n5 {
    margin: -3rem !important;
}
.mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
}
.mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
}
.mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
}
.ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
}
.m-lg-auto {
    margin: auto !important;
}
.mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
}
.mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
}
.mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
}
.ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
}
}
@media (min-width: 1200px) {
.m-xl-0 {
    margin: 0 !important;
}
.mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
}
.mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
}
.mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
}
.ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
}
.m-xl-1 {
    margin: 0.25rem !important;
}
.mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
}
.mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
}
.mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
}
.ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
}
.m-xl-2 {
    margin: 0.5rem !important;
}
.mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
}
.mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
}
.mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
}
.ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
}
.m-xl-3 {
    margin: 1rem !important;
}
.mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
}
.mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
}
.mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
}
.ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
}
.m-xl-4 {
    margin: 1.5rem !important;
}
.mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
}
.mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
}
.mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
}
.ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
}
.m-xl-5 {
    margin: 3rem !important;
}
.mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
}
.mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
}
.mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
}
.ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
}
.p-xl-0 {
    padding: 0 !important;
}
.pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
}
.pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
}
.pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
}
.pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
}
.p-xl-1 {
    padding: 0.25rem !important;
}
.pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
}
.pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
}
.pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
}
.pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
}
.p-xl-2 {
    padding: 0.5rem !important;
}
.pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
}
.pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
}
.pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
}
.pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
}
.p-xl-3 {
    padding: 1rem !important;
}
.pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
}
.pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
}
.pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
}
.pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
}
.p-xl-4 {
    padding: 1.5rem !important;
}
.pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
}
.pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
}
.pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
}
.pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
}
.p-xl-5 {
    padding: 3rem !important;
}
.pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
}
.pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
}
.pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
}
.pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
}
.m-xl-n1 {
    margin: -0.25rem !important;
}
.mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
}
.mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
}
.mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
}
.ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
}
.m-xl-n2 {
    margin: -0.5rem !important;
}
.mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
}
.mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
}
.mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
}
.ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
}
.m-xl-n3 {
    margin: -1rem !important;
}
.mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
}
.mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
}
.mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
}
.ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
}
.m-xl-n4 {
    margin: -1.5rem !important;
}
.mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
}
.mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
}
.mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
}
.ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
}
.m-xl-n5 {
    margin: -3rem !important;
}
.mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
}
.mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
}
.mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
}
.ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
}
.m-xl-auto {
    margin: auto !important;
}
.mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
}
.mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
}
.mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
}
.ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
}
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}
.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}
.text-justify {
  text-align: justify !important;
}
.text-wrap {
  white-space: normal !important;
}
.text-nowrap {
  white-space: nowrap !important;
}
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}
@media (min-width: 576px) {
.text-sm-left {
    text-align: left !important;
}
.text-sm-right {
    text-align: right !important;
}
.text-sm-center {
    text-align: center !important;
}
}
@media (min-width: 768px) {
.text-md-left {
    text-align: left !important;
}
.text-md-right {
    text-align: right !important;
}
.text-md-center {
    text-align: center !important;
}
}
@media (min-width: 992px) {
.text-lg-left {
    text-align: left !important;
}
.text-lg-right {
    text-align: right !important;
}
.text-lg-center {
    text-align: center !important;
}
}
@media (min-width: 1200px) {
.text-xl-left {
    text-align: left !important;
}
.text-xl-right {
    text-align: right !important;
}
.text-xl-center {
    text-align: center !important;
}
}
.text-lowercase {
  text-transform: lowercase !important;
}
.text-uppercase {
  text-transform: uppercase !important;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.font-weight-light {
  font-weight: 300 !important;
}
.font-weight-lighter {
  font-weight: lighter !important;
}
.font-weight-normal {
  font-weight: 400 !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.font-weight-bolder {
  font-weight: bolder !important;
}
.font-italic {
  font-style: italic !important;
}
.text-white {
  color: #fff !important;
}
.text-primary {
  color: #2196f3 !important;
}
a.text-primary:hover, a.text-primary:focus {
  color: rgb(10.2307692308, 109.9807692308, 189.2692307692) !important;
}
.text-secondary {
  color: #6c757d !important;
}
a.text-secondary:hover, a.text-secondary:focus {
  color: rgb(72.5407725322, 78.5858369099, 83.9592274678) !important;
}
.text-success {
  color: #4caf50 !important;
}
a.text-success:hover, a.text-success:focus {
  color: rgb(52.8366533865, 121.6633466135, 55.6175298805) !important;
}
.text-info {
  color: #2196f3 !important;
}
a.text-info:hover, a.text-info:focus {
  color: rgb(10.2307692308, 109.9807692308, 189.2692307692) !important;
}
.text-warning {
  color: #ffc107 !important;
}
a.text-warning:hover, a.text-warning:focus {
  color: rgb(185.5, 139.125, 0) !important;
}
.text-danger {
  color: #f44336 !important;
}
a.text-danger:hover, a.text-danger:focus {
  color: rgb(210.0070754717, 25.0754716981, 11.4929245283) !important;
}
.text-light {
  color: #f8f9fa !important;
}
a.text-light:hover, a.text-light:focus {
  color: rgb(203.375, 210.75, 218.125) !important;
}
.text-dark {
  color: #343a40 !important;
}
a.text-dark:hover, a.text-dark:focus {
  color: rgb(17.7068965517, 19.75, 21.7931034483) !important;
}
.text-infinity {
  color: #e73389 !important;
}
a.text-infinity:hover, a.text-infinity:focus {
  color: rgb(183.8684210526, 21.6315789474, 99.1447368421) !important;
}
.text-infinityDark {
  color: #af2769 !important;
}
a.text-infinityDark:hover, a.text-infinityDark:focus {
  color: rgb(112.441588785, 25.058411215, 67.464953271) !important;
}
.text-silver {
  color: #bbbbbb !important;
}
a.text-silver:hover, a.text-silver:focus {
  color: rgb(148.75, 148.75, 148.75) !important;
}
.text-whale {
  color: #0a3749 !important;
}
a.text-whale:hover, a.text-whale:focus {
  color: rgb(0.7831325301, 4.3072289157, 5.7168674699) !important;
}
.text-cello {
  color: #374a58 !important;
}
a.text-cello:hover, a.text-cello:focus {
  color: rgb(25.5769230769, 34.4125874126, 40.9230769231) !important;
}
.text-body {
  color: #6c8892 !important;
}
.text-muted {
  color: #6c757d !important;
}
.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}
.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}
.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}
.text-decoration-none {
  text-decoration: none !important;
}
.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}
.text-reset {
  color: inherit !important;
}
.visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden !important;
}
@media print {
*,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
}
a:not(.btn) {
    text-decoration: underline;
}
abbr[title]::after {
    content: " (" attr(title) ")";
}
pre {
    white-space: pre-wrap !important;
}
pre,
  blockquote {
    border: 1px solid #adb5bd;
    page-break-inside: avoid;
}
tr,
  img {
    page-break-inside: avoid;
}
p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
}
h2,
  h3 {
    page-break-after: avoid;
}
@page {
    size: a3;
}
body, #app {
    min-width: 992px !important;
}
.container {
    min-width: 992px !important;
}
.navbar {
    display: none;
}
.badge {
    border: 1px solid #000;
}
.table {
    border-collapse: collapse !important;
}
.table td,
  .table th {
    background-color: #fff !important;
}
.table-bordered th,
  .table-bordered td {
    border: 1px solid #dee2e6 !important;
}
.table-dark {
    color: inherit;
}
.table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #dee2e6;
}
.table .thead-dark th {
    color: inherit;
    border-color: #dee2e6;
}
}
.bv-no-focus-ring:focus {
  outline: none;
}
@media (max-width: 575.98px) {
.bv-d-xs-down-none {
    display: none !important;
}
}
@media (max-width: 767.98px) {
.bv-d-sm-down-none {
    display: none !important;
}
}
@media (max-width: 991.98px) {
.bv-d-md-down-none {
    display: none !important;
}
}
@media (max-width: 1199.98px) {
.bv-d-lg-down-none {
    display: none !important;
}
}
.bv-d-xl-down-none {
  display: none !important;
}
.form-control.focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(153.9615384615, 207.2115384615, 249.5384615385);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}
.form-control.focus.is-valid {
  border-color: #4caf50;
  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.25);
}
.form-control.focus.is-invalid {
  border-color: #f44336;
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.25);
}
.b-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  flex-shrink: 0;
  width: 2.5rem;
  height: 2.5rem;
  font-size: inherit;
  font-weight: 400;
  line-height: 1;
  max-width: 100%;
  max-height: auto;
  text-align: center;
  overflow: visible;
  position: relative;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.b-avatar:focus {
  outline: 0;
}
.b-avatar.btn, .b-avatar[href] {
  padding: 0;
  border: 0;
}
.b-avatar.btn .b-avatar-img img, .b-avatar[href] .b-avatar-img img {
  transition: transform 0.15s ease-in-out;
}
.b-avatar.btn:not(:disabled):not(.disabled), .b-avatar[href]:not(:disabled):not(.disabled) {
  cursor: pointer;
}
.b-avatar.btn:not(:disabled):not(.disabled):hover .b-avatar-img img, .b-avatar[href]:not(:disabled):not(.disabled):hover .b-avatar-img img {
  transform: scale(1.15);
}
.b-avatar.disabled, .b-avatar:disabled, .b-avatar[disabled] {
  opacity: 0.65;
  pointer-events: none;
}
.b-avatar .b-avatar-custom,
.b-avatar .b-avatar-text,
.b-avatar .b-avatar-img {
  border-radius: inherit;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-mask-image: radial-gradient(white, black);
          mask-image: radial-gradient(white, black);
}
.b-avatar .b-avatar-text {
  text-transform: uppercase;
  white-space: nowrap;
}
.b-avatar[href] {
  text-decoration: none;
}
.b-avatar > .b-icon {
  width: 60%;
  height: auto;
  max-width: 100%;
}
.b-avatar .b-avatar-img img {
  width: 100%;
  height: 100%;
  max-height: auto;
  border-radius: inherit;
  -o-object-fit: cover;
     object-fit: cover;
}
.b-avatar .b-avatar-badge {
  position: absolute;
  min-height: 1.5em;
  min-width: 1.5em;
  padding: 0.25em;
  line-height: 1;
  border-radius: 10em;
  font-size: 70%;
  font-weight: 700;
  z-index: 1;
}
.b-avatar-sm {
  width: 1.5rem;
  height: 1.5rem;
}
.b-avatar-sm .b-avatar-text {
  font-size: calc(0.6rem);
}
.b-avatar-sm .b-avatar-badge {
  font-size: calc(0.42rem);
}
.b-avatar-lg {
  width: 3.5rem;
  height: 3.5rem;
}
.b-avatar-lg .b-avatar-text {
  font-size: calc(1.4rem);
}
.b-avatar-lg .b-avatar-badge {
  font-size: calc(0.98rem);
}
.b-avatar-group .b-avatar-group-inner {
  display: flex;
  flex-wrap: wrap;
}
.b-avatar-group .b-avatar {
  border: 1px solid #dee2e6;
}
.b-avatar-group a.b-avatar:hover:not(.disabled):not(disabled),
.b-avatar-group .btn.b-avatar:hover:not(.disabled):not(disabled) {
  z-index: 1;
}
.b-calendar {
  display: inline-flex;
}
.b-calendar .b-calendar-inner {
  min-width: 250px;
}
.b-calendar .b-calendar-header,
.b-calendar .b-calendar-nav {
  margin-bottom: 0.25rem;
}
.b-calendar .b-calendar-nav .btn {
  padding: 0.25rem;
}
.b-calendar output {
  padding: 0.25rem;
  font-size: 80%;
}
.b-calendar output.readonly {
  background-color: #e9ecef;
  opacity: 1;
}
.b-calendar .b-calendar-footer {
  margin-top: 0.5rem;
}
.b-calendar .b-calendar-grid {
  padding: 0;
  margin: 0;
  overflow: hidden;
}
.b-calendar .b-calendar-grid .row {
  flex-wrap: nowrap;
}
.b-calendar .b-calendar-grid-caption {
  padding: 0.25rem;
}
.b-calendar .b-calendar-grid-body .col[data-date] .btn {
  width: 32px;
  height: 32px;
  font-size: 14px;
  line-height: 1;
  margin: 3px auto;
  padding: 9px 0;
}
.b-calendar .btn:disabled, .b-calendar .btn.disabled, .b-calendar .btn[aria-disabled=true] {
  cursor: default;
  pointer-events: none;
}
.card-img-left {
  border-top-left-radius: calc(0.25rem - 1px);
  border-bottom-left-radius: calc(0.25rem - 1px);
}
.card-img-right {
  border-top-right-radius: calc(0.25rem - 1px);
  border-bottom-right-radius: calc(0.25rem - 1px);
}
.dropdown:not(.dropleft) .dropdown-toggle.dropdown-toggle-no-caret::after {
  display: none !important;
}
.dropdown.dropleft .dropdown-toggle.dropdown-toggle-no-caret::before {
  display: none !important;
}
.dropdown .dropdown-menu:focus {
  outline: none;
}
.b-dropdown-form {
  display: inline-block;
  padding: 0.25rem 1.5rem;
  width: 100%;
  clear: both;
  font-weight: 400;
}
.b-dropdown-form:focus {
  outline: 1px dotted !important;
  outline: 5px auto -webkit-focus-ring-color !important;
}
.b-dropdown-form.disabled, .b-dropdown-form:disabled {
  outline: 0 !important;
  color: #adb5bd;
  pointer-events: none;
}
.b-dropdown-text {
  display: inline-block;
  padding: 0.25rem 1.5rem;
  margin-bottom: 0;
  width: 100%;
  clear: both;
  font-weight: lighter;
}
.custom-checkbox.b-custom-control-lg,
.input-group-lg .custom-checkbox {
  font-size: 1.25rem;
  line-height: 1.5;
  padding-left: 1.875rem;
}
.custom-checkbox.b-custom-control-lg .custom-control-label::before,
.input-group-lg .custom-checkbox .custom-control-label::before {
  top: 0.3125rem;
  left: -1.875rem;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 0.5rem;
}
.custom-checkbox.b-custom-control-lg .custom-control-label::after,
.input-group-lg .custom-checkbox .custom-control-label::after {
  top: 0.3125rem;
  left: -1.875rem;
  width: 1.25rem;
  height: 1.25rem;
  background-size: 50% 50%;
}
.custom-checkbox.b-custom-control-sm,
.input-group-sm .custom-checkbox {
  font-size: 0.875rem;
  line-height: 1.5;
  padding-left: 1.3125rem;
}
.custom-checkbox.b-custom-control-sm .custom-control-label::before,
.input-group-sm .custom-checkbox .custom-control-label::before {
  top: 0.21875rem;
  left: -1.3125rem;
  width: 0.875rem;
  height: 0.875rem;
  border-radius: 0.15rem;
}
.custom-checkbox.b-custom-control-sm .custom-control-label::after,
.input-group-sm .custom-checkbox .custom-control-label::after {
  top: 0.21875rem;
  left: -1.3125rem;
  width: 0.875rem;
  height: 0.875rem;
  background-size: 50% 50%;
}
.custom-switch.b-custom-control-lg,
.input-group-lg .custom-switch {
  padding-left: 2.8125rem;
}
.custom-switch.b-custom-control-lg .custom-control-label,
.input-group-lg .custom-switch .custom-control-label {
  font-size: 1.25rem;
  line-height: 1.5;
}
.custom-switch.b-custom-control-lg .custom-control-label::before,
.input-group-lg .custom-switch .custom-control-label::before {
  top: 0.3125rem;
  height: 1.25rem;
  left: -2.8125rem;
  width: 2.1875rem;
  border-radius: 0.625rem;
}
.custom-switch.b-custom-control-lg .custom-control-label::after,
.input-group-lg .custom-switch .custom-control-label::after {
  top: calc(0.3125rem + 2px);
  left: calc(-2.8125rem + 2px);
  width: calc(1.25rem - 4px);
  height: calc(1.25rem - 4px);
  border-radius: 0.625rem;
  background-size: 50% 50%;
}
.custom-switch.b-custom-control-lg .custom-control-input:checked ~ .custom-control-label::after,
.input-group-lg .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(0.9375rem);
}
.custom-switch.b-custom-control-sm,
.input-group-sm .custom-switch {
  padding-left: 1.96875rem;
}
.custom-switch.b-custom-control-sm .custom-control-label,
.input-group-sm .custom-switch .custom-control-label {
  font-size: 0.875rem;
  line-height: 1.5;
}
.custom-switch.b-custom-control-sm .custom-control-label::before,
.input-group-sm .custom-switch .custom-control-label::before {
  top: 0.21875rem;
  left: -1.96875rem;
  width: 1.53125rem;
  height: 0.875rem;
  border-radius: 0.4375rem;
}
.custom-switch.b-custom-control-sm .custom-control-label::after,
.input-group-sm .custom-switch .custom-control-label::after {
  top: calc(0.21875rem + 2px);
  left: calc(-1.96875rem + 2px);
  width: calc(0.875rem - 4px);
  height: calc(0.875rem - 4px);
  border-radius: 0.4375rem;
  background-size: 50% 50%;
}
.custom-switch.b-custom-control-sm .custom-control-input:checked ~ .custom-control-label::after,
.input-group-sm .custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(0.65625rem);
}
.input-group > .input-group-prepend > .btn-group > .btn,
.input-group > .input-group-append:not(:last-child) > .btn-group > .btn,
.input-group > .input-group-append:last-child > .btn-group:not(:last-child):not(.dropdown-toggle) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .input-group-append > .btn-group > .btn,
.input-group > .input-group-prepend:not(:first-child) > .btn-group > .btn,
.input-group > .input-group-prepend:first-child > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.b-form-btn-label-control.form-control {
  display: flex;
  align-items: stretch;
  height: auto;
  padding: 0;
  background-image: none;
}
.input-group .b-form-btn-label-control.form-control {
  padding: 0;
}
[dir=rtl] .b-form-btn-label-control.form-control, .b-form-btn-label-control.form-control[dir=rtl] {
  flex-direction: row-reverse;
}
[dir=rtl] .b-form-btn-label-control.form-control > label, .b-form-btn-label-control.form-control[dir=rtl] > label {
  text-align: right;
}
.b-form-btn-label-control.form-control > .btn {
  line-height: 1;
  font-size: inherit;
  box-shadow: none !important;
  border: 0;
}
.b-form-btn-label-control.form-control > .btn:disabled {
  pointer-events: none;
}
.b-form-btn-label-control.form-control.is-valid > .btn {
  color: #4caf50;
}
.b-form-btn-label-control.form-control.is-invalid > .btn {
  color: #f44336;
}
.b-form-btn-label-control.form-control > .dropdown-menu {
  padding: 0.5rem;
}
.b-form-btn-label-control.form-control > .form-control {
  height: auto;
  min-height: calc(calc(1.2em + 0.75rem + 2px) - 2px);
  padding-left: 0.25rem;
  margin: 0;
  border: 0;
  outline: 0;
  background: transparent;
  word-break: break-word;
  font-size: inherit;
  white-space: normal;
  cursor: pointer;
}
.b-form-btn-label-control.form-control > .form-control.form-control-sm {
  min-height: calc(calc(1.5em + 0.5rem + 2px) - 2px);
}
.b-form-btn-label-control.form-control > .form-control.form-control-lg {
  min-height: calc(calc(1.5em + 1rem + 2px) - 2px);
}
.input-group.input-group-sm .b-form-btn-label-control.form-control > .form-control {
  min-height: calc(calc(1.5em + 0.5rem + 2px) - 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.input-group.input-group-lg .b-form-btn-label-control.form-control > .form-control {
  min-height: calc(calc(1.5em + 1rem + 2px) - 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.b-form-btn-label-control.form-control[aria-disabled=true], .b-form-btn-label-control.form-control[aria-readonly=true] {
  background-color: #e9ecef;
  opacity: 1;
}
.b-form-btn-label-control.form-control[aria-disabled=true] {
  pointer-events: none;
}
.b-form-btn-label-control.form-control[aria-disabled=true] > label {
  cursor: default;
}
.b-form-btn-label-control.btn-group > .dropdown-menu {
  padding: 0.5rem;
}
.custom-file-label {
  white-space: nowrap;
  overflow-x: hidden;
}
.b-custom-control-lg.custom-file,
.b-custom-control-lg .custom-file-input,
.b-custom-control-lg .custom-file-label,
.input-group-lg.custom-file,
.input-group-lg .custom-file-input,
.input-group-lg .custom-file-label {
  font-size: 1.25rem;
  height: calc(1.5em + 1rem + 2px);
}
.b-custom-control-lg .custom-file-label,
.b-custom-control-lg .custom-file-label:after,
.input-group-lg .custom-file-label,
.input-group-lg .custom-file-label:after {
  padding: 0.5rem 1rem;
  line-height: 1.5;
}
.b-custom-control-lg .custom-file-label,
.input-group-lg .custom-file-label {
  border-radius: 0.5rem;
}
.b-custom-control-lg .custom-file-label::after,
.input-group-lg .custom-file-label::after {
  font-size: inherit;
  height: calc(1.5em + 1rem);
  border-radius: 0 0.5rem 0.5rem 0;
}
.b-custom-control-sm.custom-file,
.b-custom-control-sm .custom-file-input,
.b-custom-control-sm .custom-file-label,
.input-group-sm.custom-file,
.input-group-sm .custom-file-input,
.input-group-sm .custom-file-label {
  font-size: 0.875rem;
  height: calc(1.5em + 0.5rem + 2px);
}
.b-custom-control-sm .custom-file-label,
.b-custom-control-sm .custom-file-label:after,
.input-group-sm .custom-file-label,
.input-group-sm .custom-file-label:after {
  padding: 0.25rem 0.5rem;
  line-height: 1.5;
}
.b-custom-control-sm .custom-file-label,
.input-group-sm .custom-file-label {
  border-radius: 0.15rem;
}
.b-custom-control-sm .custom-file-label::after,
.input-group-sm .custom-file-label::after {
  font-size: inherit;
  height: calc(1.5em + 0.5rem);
  border-radius: 0 0.15rem 0.15rem 0;
}
.was-validated .form-control:invalid, .was-validated .form-control:valid, .form-control.is-invalid, .form-control.is-valid {
  background-position: right calc(0.3em + 0.1875rem) center;
}
input[type=color].form-control {
  height: calc(1.2em + 0.75rem + 2px);
  padding: 0.125rem 0.25rem;
}
input[type=color].form-control.form-control-sm,
.input-group-sm input[type=color].form-control {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.125rem 0.25rem;
}
input[type=color].form-control.form-control-lg,
.input-group-lg input[type=color].form-control {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.125rem 0.25rem;
}
input[type=color].form-control:disabled {
  background-color: #adb5bd;
  opacity: 0.65;
}
.input-group > .custom-range {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  margin-bottom: 0;
}
.input-group > .custom-range + .form-control,
.input-group > .custom-range + .form-control-plaintext,
.input-group > .custom-range + .custom-select,
.input-group > .custom-range + .custom-range,
.input-group > .custom-range + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control + .custom-range,
.input-group > .form-control-plaintext + .custom-range,
.input-group > .custom-select + .custom-range,
.input-group > .custom-range + .custom-range,
.input-group > .custom-file + .custom-range {
  margin-left: -1px;
}
.input-group > .custom-range:focus {
  z-index: 3;
}
.input-group > .custom-range:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-range:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-range {
  height: calc(1.2em + 0.75rem + 2px);
  padding: 0 0.75rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  height: calc(1.2em + 0.75rem + 2px);
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
.input-group > .custom-range {
    transition: none;
}
}
.input-group > .custom-range:focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(153.9615384615, 207.2115384615, 249.5384615385);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}
.input-group > .custom-range:disabled, .input-group > .custom-range[readonly] {
  background-color: #e9ecef;
}
.input-group-lg > .custom-range {
  height: calc(1.5em + 1rem + 2px);
  padding: 0 1rem;
  border-radius: 0.5rem;
}
.input-group-sm > .custom-range {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0 0.5rem;
  border-radius: 0.15rem;
}
.was-validated .input-group .custom-range:valid, .input-group .custom-range.is-valid {
  border-color: #4caf50;
}
.was-validated .input-group .custom-range:valid:focus, .input-group .custom-range.is-valid:focus {
  border-color: #4caf50;
  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.25);
}
.was-validated .custom-range:valid:focus::-webkit-slider-thumb, .custom-range.is-valid:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f0f2f4, 0 0 0 0.2rem rgb(198.874501992, 230.625498008, 200.1573705179);
}
.was-validated .custom-range:valid:focus::-moz-range-thumb, .custom-range.is-valid:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f0f2f4, 0 0 0 0.2rem rgb(198.874501992, 230.625498008, 200.1573705179);
}
.was-validated .custom-range:valid:focus::-ms-thumb, .custom-range.is-valid:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #f0f2f4, 0 0 0 0.2rem rgb(198.874501992, 230.625498008, 200.1573705179);
}
.was-validated .custom-range:valid::-webkit-slider-thumb, .custom-range.is-valid::-webkit-slider-thumb {
  background-color: #4caf50;
  background-image: none;
}
.was-validated .custom-range:valid::-webkit-slider-thumb:active, .custom-range.is-valid::-webkit-slider-thumb:active {
  background-color: rgb(198.874501992, 230.625498008, 200.1573705179);
  background-image: none;
}
.was-validated .custom-range:valid::-webkit-slider-runnable-track, .custom-range.is-valid::-webkit-slider-runnable-track {
  background-color: rgba(76, 175, 80, 0.35);
}
.was-validated .custom-range:valid::-moz-range-thumb, .custom-range.is-valid::-moz-range-thumb {
  background-color: #4caf50;
  background-image: none;
}
.was-validated .custom-range:valid::-moz-range-thumb:active, .custom-range.is-valid::-moz-range-thumb:active {
  background-color: rgb(198.874501992, 230.625498008, 200.1573705179);
  background-image: none;
}
.was-validated .custom-range:valid::-moz-range-track, .custom-range.is-valid::-moz-range-track {
  background: rgba(76, 175, 80, 0.35);
}
.was-validated .custom-range:valid ~ .valid-feedback,
.was-validated .custom-range:valid ~ .valid-tooltip, .custom-range.is-valid ~ .valid-feedback,
.custom-range.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-range:valid::-ms-thumb, .custom-range.is-valid::-ms-thumb {
  background-color: #4caf50;
  background-image: none;
}
.was-validated .custom-range:valid::-ms-thumb:active, .custom-range.is-valid::-ms-thumb:active {
  background-color: rgb(198.874501992, 230.625498008, 200.1573705179);
  background-image: none;
}
.was-validated .custom-range:valid::-ms-track-lower, .custom-range.is-valid::-ms-track-lower {
  background: rgba(76, 175, 80, 0.35);
}
.was-validated .custom-range:valid::-ms-track-upper, .custom-range.is-valid::-ms-track-upper {
  background: rgba(76, 175, 80, 0.35);
}
.was-validated .input-group .custom-range:invalid, .input-group .custom-range.is-invalid {
  border-color: #f44336;
}
.was-validated .input-group .custom-range:invalid:focus, .input-group .custom-range.is-invalid:focus {
  border-color: #f44336;
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.25);
}
.was-validated .custom-range:invalid:focus::-webkit-slider-thumb, .custom-range.is-invalid:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f0f2f4, 0 0 0 0.2rem rgb(253.2617924528, 225.2924528302, 223.2382075472);
}
.was-validated .custom-range:invalid:focus::-moz-range-thumb, .custom-range.is-invalid:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f0f2f4, 0 0 0 0.2rem rgb(253.2617924528, 225.2924528302, 223.2382075472);
}
.was-validated .custom-range:invalid:focus::-ms-thumb, .custom-range.is-invalid:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #f0f2f4, 0 0 0 0.2rem rgb(253.2617924528, 225.2924528302, 223.2382075472);
}
.was-validated .custom-range:invalid::-webkit-slider-thumb, .custom-range.is-invalid::-webkit-slider-thumb {
  background-color: #f44336;
  background-image: none;
}
.was-validated .custom-range:invalid::-webkit-slider-thumb:active, .custom-range.is-invalid::-webkit-slider-thumb:active {
  background-color: rgb(253.2617924528, 225.2924528302, 223.2382075472);
  background-image: none;
}
.was-validated .custom-range:invalid::-webkit-slider-runnable-track, .custom-range.is-invalid::-webkit-slider-runnable-track {
  background-color: rgba(244, 67, 54, 0.35);
}
.was-validated .custom-range:invalid::-moz-range-thumb, .custom-range.is-invalid::-moz-range-thumb {
  background-color: #f44336;
  background-image: none;
}
.was-validated .custom-range:invalid::-moz-range-thumb:active, .custom-range.is-invalid::-moz-range-thumb:active {
  background-color: rgb(253.2617924528, 225.2924528302, 223.2382075472);
  background-image: none;
}
.was-validated .custom-range:invalid::-moz-range-track, .custom-range.is-invalid::-moz-range-track {
  background: rgba(244, 67, 54, 0.35);
}
.was-validated .custom-range:invalid ~ .invalid-feedback,
.was-validated .custom-range:invalid ~ .invalid-tooltip, .custom-range.is-invalid ~ .invalid-feedback,
.custom-range.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-range:invalid::-ms-thumb, .custom-range.is-invalid::-ms-thumb {
  background-color: #f44336;
  background-image: none;
}
.was-validated .custom-range:invalid::-ms-thumb:active, .custom-range.is-invalid::-ms-thumb:active {
  background-color: rgb(253.2617924528, 225.2924528302, 223.2382075472);
  background-image: none;
}
.was-validated .custom-range:invalid::-ms-track-lower, .custom-range.is-invalid::-ms-track-lower {
  background: rgba(244, 67, 54, 0.35);
}
.was-validated .custom-range:invalid::-ms-track-upper, .custom-range.is-invalid::-ms-track-upper {
  background: rgba(244, 67, 54, 0.35);
}
.custom-radio.b-custom-control-lg,
.input-group-lg .custom-radio {
  font-size: 1.25rem;
  line-height: 1.5;
  padding-left: 1.875rem;
}
.custom-radio.b-custom-control-lg .custom-control-label::before,
.input-group-lg .custom-radio .custom-control-label::before {
  top: 0.3125rem;
  left: -1.875rem;
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50%;
}
.custom-radio.b-custom-control-lg .custom-control-label::after,
.input-group-lg .custom-radio .custom-control-label::after {
  top: 0.3125rem;
  left: -1.875rem;
  width: 1.25rem;
  height: 1.25rem;
  background: no-repeat 50%/50% 50%;
}
.custom-radio.b-custom-control-sm,
.input-group-sm .custom-radio {
  font-size: 0.875rem;
  line-height: 1.5;
  padding-left: 1.3125rem;
}
.custom-radio.b-custom-control-sm .custom-control-label::before,
.input-group-sm .custom-radio .custom-control-label::before {
  top: 0.21875rem;
  left: -1.3125rem;
  width: 0.875rem;
  height: 0.875rem;
  border-radius: 50%;
}
.custom-radio.b-custom-control-sm .custom-control-label::after,
.input-group-sm .custom-radio .custom-control-label::after {
  top: 0.21875rem;
  left: -1.3125rem;
  width: 0.875rem;
  height: 0.875rem;
  background: no-repeat 50%/50% 50%;
}
.b-rating {
  text-align: center;
}
.b-rating.d-inline-flex {
  width: auto;
}
.b-rating .b-rating-star,
.b-rating .b-rating-value {
  padding: 0 0.25em;
}
.b-rating .b-rating-value {
  min-width: 2.5em;
}
.b-rating .b-rating-star {
  display: inline-flex;
  justify-content: center;
  outline: 0;
}
.b-rating .b-rating-star .b-rating-icon {
  display: inline-flex;
  transition: all 0.15s ease-in-out;
}
.b-rating.disabled, .b-rating:disabled {
  background-color: #e9ecef;
  color: #6c757d;
}
.b-rating:not(.disabled):not(.readonly) .b-rating-star {
  cursor: pointer;
}
.b-rating:not(.disabled):not(.readonly):focus:not(:hover) .b-rating-star.focused .b-rating-icon,
.b-rating:not(.disabled):not(.readonly) .b-rating-star:hover .b-rating-icon {
  transform: scale(1.5);
}
.b-rating[dir=rtl] .b-rating-star-half {
  transform: scale(-1, 1);
}
.b-form-spinbutton {
  text-align: center;
  overflow: hidden;
  background-image: none;
  padding: 0;
}
[dir=rtl] .b-form-spinbutton:not(.flex-column), .b-form-spinbutton[dir=rtl]:not(.flex-column) {
  flex-direction: row-reverse;
}
.b-form-spinbutton output {
  font-size: inherit;
  outline: 0;
  border: 0;
  background-color: transparent;
  width: auto;
  margin: 0;
  padding: 0 0.25rem;
}
.b-form-spinbutton output > div,
.b-form-spinbutton output > bdi {
  display: block;
  min-width: 2.25em;
  height: 1.2em;
}
.b-form-spinbutton.flex-column {
  height: auto;
  width: auto;
}
.b-form-spinbutton.flex-column output {
  margin: 0 0.25rem;
  padding: 0.25rem 0;
}
.b-form-spinbutton:not(.d-inline-flex):not(.flex-column) {
  output-width: 100%;
}
.b-form-spinbutton.d-inline-flex:not(.flex-column) {
  width: auto;
}
.b-form-spinbutton .btn {
  line-height: 1;
  box-shadow: none !important;
}
.b-form-spinbutton .btn:disabled {
  pointer-events: none;
}
.b-form-spinbutton .btn:hover:not(:disabled) > div > .b-icon {
  transform: scale(1.25);
}
.b-form-spinbutton.disabled, .b-form-spinbutton.readonly {
  background-color: #e9ecef;
}
.b-form-spinbutton.disabled {
  pointer-events: none;
}
.b-form-tags.focus {
  color: #495057;
  background-color: #fff;
  border-color: rgb(153.9615384615, 207.2115384615, 249.5384615385);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(33, 150, 243, 0.25);
}
.b-form-tags.focus.is-valid {
  border-color: #4caf50;
  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.25);
}
.b-form-tags.focus.is-invalid {
  border-color: #f44336;
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.25);
}
.b-form-tags.disabled {
  background-color: #e9ecef;
}
.b-form-tags-list {
  margin-top: -0.25rem;
}
.b-form-tags-list .b-form-tags-field,
.b-form-tags-list .b-form-tag {
  margin-top: 0.25rem;
}
.b-form-tags-input {
  color: #495057;
}
.b-form-tag {
  font-size: 75%;
  font-weight: normal;
  line-height: 1.2;
  margin-right: 0.25rem;
}
.b-form-tag.disabled {
  opacity: 0.75;
}
.b-form-tag > button.b-form-tag-remove {
  color: inherit;
  font-size: 125%;
  line-height: 1;
  float: none;
  margin-left: 0.25rem;
}
.form-control-sm .b-form-tag {
  line-height: 1.5;
}
.form-control-lg .b-form-tag {
  line-height: 1.5;
}
.media-aside {
  display: flex;
  margin-right: 1rem;
}
.media-aside-right {
  margin-right: 0;
  margin-left: 1rem;
}
.modal-backdrop {
  opacity: 0.5;
}
.b-pagination-pills .page-item .page-link {
  border-radius: 50rem !important;
  margin-left: 0.25rem;
  line-height: 1;
}
.b-pagination-pills .page-item:first-child .page-link {
  margin-left: 0;
}
.popover.b-popover {
  display: block;
  opacity: 1;
  outline: 0;
}
.popover.b-popover.fade:not(.show) {
  opacity: 0;
}
.popover.b-popover.show {
  opacity: 1;
}
.b-popover-primary.popover {
  background-color: rgb(210.6, 234, 252.6);
  border-color: rgb(192.84, 225.6, 251.64);
}
.b-popover-primary.bs-popover-top > .arrow::before, .b-popover-primary.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(192.84, 225.6, 251.64);
}
.b-popover-primary.bs-popover-top > .arrow::after, .b-popover-primary.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(210.6, 234, 252.6);
}
.b-popover-primary.bs-popover-right > .arrow::before, .b-popover-primary.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(192.84, 225.6, 251.64);
}
.b-popover-primary.bs-popover-right > .arrow::after, .b-popover-primary.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(210.6, 234, 252.6);
}
.b-popover-primary.bs-popover-bottom > .arrow::before, .b-popover-primary.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(192.84, 225.6, 251.64);
}
.b-popover-primary.bs-popover-bottom > .arrow::after, .b-popover-primary.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(196.0846153846, 227.1346153846, 251.8153846154);
}
.b-popover-primary.bs-popover-bottom .popover-header::before, .b-popover-primary.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(196.0846153846, 227.1346153846, 251.8153846154);
}
.b-popover-primary.bs-popover-left > .arrow::before, .b-popover-primary.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(192.84, 225.6, 251.64);
}
.b-popover-primary.bs-popover-left > .arrow::after, .b-popover-primary.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(210.6, 234, 252.6);
}
.b-popover-primary .popover-header {
  color: #212529;
  background-color: rgb(196.0846153846, 227.1346153846, 251.8153846154);
  border-bottom-color: rgb(171.8923076923, 215.6923076923, 250.5076923077);
}
.b-popover-primary .popover-body {
  color: rgb(17.16, 78, 126.36);
}
.b-popover-secondary.popover {
  background-color: rgb(225.6, 227.4, 229);
  border-color: rgb(213.84, 216.36, 218.6);
}
.b-popover-secondary.bs-popover-top > .arrow::before, .b-popover-secondary.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(213.84, 216.36, 218.6);
}
.b-popover-secondary.bs-popover-top > .arrow::after, .b-popover-secondary.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(225.6, 227.4, 229);
}
.b-popover-secondary.bs-popover-right > .arrow::before, .b-popover-secondary.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(213.84, 216.36, 218.6);
}
.b-popover-secondary.bs-popover-right > .arrow::after, .b-popover-secondary.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(225.6, 227.4, 229);
}
.b-popover-secondary.bs-popover-bottom > .arrow::before, .b-popover-secondary.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(213.84, 216.36, 218.6);
}
.b-popover-secondary.bs-popover-bottom > .arrow::after, .b-popover-secondary.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(217.4805054152, 219.7776173285, 221.8194945848);
}
.b-popover-secondary.bs-popover-bottom .popover-header::before, .b-popover-secondary.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(217.4805054152, 219.7776173285, 221.8194945848);
}
.b-popover-secondary.bs-popover-left > .arrow::before, .b-popover-secondary.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(213.84, 216.36, 218.6);
}
.b-popover-secondary.bs-popover-left > .arrow::after, .b-popover-secondary.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(225.6, 227.4, 229);
}
.b-popover-secondary .popover-header {
  color: #212529;
  background-color: rgb(217.4805054152, 219.7776173285, 221.8194945848);
  border-bottom-color: rgb(203.9480144404, 207.0736462094, 209.8519855596);
}
.b-popover-secondary .popover-body {
  color: rgb(56.16, 60.84, 65);
}
.b-popover-success.popover {
  background-color: rgb(219.2, 239, 220);
  border-color: rgb(204.88, 232.6, 206);
}
.b-popover-success.bs-popover-top > .arrow::before, .b-popover-success.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(204.88, 232.6, 206);
}
.b-popover-success.bs-popover-top > .arrow::after, .b-popover-success.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(219.2, 239, 220);
}
.b-popover-success.bs-popover-right > .arrow::before, .b-popover-success.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(204.88, 232.6, 206);
}
.b-popover-success.bs-popover-right > .arrow::after, .b-popover-success.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(219.2, 239, 220);
}
.b-popover-success.bs-popover-bottom > .arrow::before, .b-popover-success.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(204.88, 232.6, 206);
}
.b-popover-success.bs-popover-bottom > .arrow::after, .b-popover-success.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(208.6258687259, 234.2741312741, 209.6621621622);
}
.b-popover-success.bs-popover-bottom .popover-header::before, .b-popover-success.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(208.6258687259, 234.2741312741, 209.6621621622);
}
.b-popover-success.bs-popover-left > .arrow::before, .b-popover-success.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(204.88, 232.6, 206);
}
.b-popover-success.bs-popover-left > .arrow::after, .b-popover-success.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(219.2, 239, 220);
}
.b-popover-success .popover-header {
  color: #212529;
  background-color: rgb(208.6258687259, 234.2741312741, 209.6621621622);
  border-bottom-color: rgb(191.0023166023, 226.3976833977, 192.4324324324);
}
.b-popover-success .popover-body {
  color: rgb(39.52, 91, 41.6);
}
.b-popover-info.popover {
  background-color: rgb(210.6, 234, 252.6);
  border-color: rgb(192.84, 225.6, 251.64);
}
.b-popover-info.bs-popover-top > .arrow::before, .b-popover-info.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(192.84, 225.6, 251.64);
}
.b-popover-info.bs-popover-top > .arrow::after, .b-popover-info.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(210.6, 234, 252.6);
}
.b-popover-info.bs-popover-right > .arrow::before, .b-popover-info.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(192.84, 225.6, 251.64);
}
.b-popover-info.bs-popover-right > .arrow::after, .b-popover-info.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(210.6, 234, 252.6);
}
.b-popover-info.bs-popover-bottom > .arrow::before, .b-popover-info.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(192.84, 225.6, 251.64);
}
.b-popover-info.bs-popover-bottom > .arrow::after, .b-popover-info.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(196.0846153846, 227.1346153846, 251.8153846154);
}
.b-popover-info.bs-popover-bottom .popover-header::before, .b-popover-info.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(196.0846153846, 227.1346153846, 251.8153846154);
}
.b-popover-info.bs-popover-left > .arrow::before, .b-popover-info.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(192.84, 225.6, 251.64);
}
.b-popover-info.bs-popover-left > .arrow::after, .b-popover-info.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(210.6, 234, 252.6);
}
.b-popover-info .popover-header {
  color: #212529;
  background-color: rgb(196.0846153846, 227.1346153846, 251.8153846154);
  border-bottom-color: rgb(171.8923076923, 215.6923076923, 250.5076923077);
}
.b-popover-info .popover-body {
  color: rgb(17.16, 78, 126.36);
}
.b-popover-warning.popover {
  background-color: rgb(255, 242.6, 205.4);
  border-color: rgb(255, 237.64, 185.56);
}
.b-popover-warning.bs-popover-top > .arrow::before, .b-popover-warning.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(255, 237.64, 185.56);
}
.b-popover-warning.bs-popover-top > .arrow::after, .b-popover-warning.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(255, 242.6, 205.4);
}
.b-popover-warning.bs-popover-right > .arrow::before, .b-popover-warning.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(255, 237.64, 185.56);
}
.b-popover-warning.bs-popover-right > .arrow::after, .b-popover-warning.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(255, 242.6, 205.4);
}
.b-popover-warning.bs-popover-bottom > .arrow::before, .b-popover-warning.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(255, 237.64, 185.56);
}
.b-popover-warning.bs-popover-bottom > .arrow::after, .b-popover-warning.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(255, 238.775, 190.1);
}
.b-popover-warning.bs-popover-bottom .popover-header::before, .b-popover-warning.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(255, 238.775, 190.1);
}
.b-popover-warning.bs-popover-left > .arrow::before, .b-popover-warning.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(255, 237.64, 185.56);
}
.b-popover-warning.bs-popover-left > .arrow::after, .b-popover-warning.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(255, 242.6, 205.4);
}
.b-popover-warning .popover-header {
  color: #212529;
  background-color: rgb(255, 238.775, 190.1);
  border-bottom-color: rgb(255, 232.4, 164.6);
}
.b-popover-warning .popover-body {
  color: rgb(132.6, 100.36, 3.64);
}
.b-popover-danger.popover {
  background-color: rgb(252.8, 217.4, 214.8);
  border-color: rgb(251.92, 202.36, 198.72);
}
.b-popover-danger.bs-popover-top > .arrow::before, .b-popover-danger.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(251.92, 202.36, 198.72);
}
.b-popover-danger.bs-popover-top > .arrow::after, .b-popover-danger.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(252.8, 217.4, 214.8);
}
.b-popover-danger.bs-popover-right > .arrow::before, .b-popover-danger.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(251.92, 202.36, 198.72);
}
.b-popover-danger.bs-popover-right > .arrow::after, .b-popover-danger.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(252.8, 217.4, 214.8);
}
.b-popover-danger.bs-popover-bottom > .arrow::before, .b-popover-danger.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(251.92, 202.36, 198.72);
}
.b-popover-danger.bs-popover-bottom > .arrow::after, .b-popover-danger.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(252.0061320755, 203.8320754717, 200.2938679245);
}
.b-popover-danger.bs-popover-bottom .popover-header::before, .b-popover-danger.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(252.0061320755, 203.8320754717, 200.2938679245);
}
.b-popover-danger.bs-popover-left > .arrow::before, .b-popover-danger.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(251.92, 202.36, 198.72);
}
.b-popover-danger.bs-popover-left > .arrow::after, .b-popover-danger.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(252.8, 217.4, 214.8);
}
.b-popover-danger .popover-header {
  color: #212529;
  background-color: rgb(252.0061320755, 203.8320754717, 200.2938679245);
  border-bottom-color: rgb(250.6830188679, 181.2188679245, 176.1169811321);
}
.b-popover-danger .popover-body {
  color: rgb(126.88, 34.84, 28.08);
}
.b-popover-light.popover {
  background-color: rgb(253.6, 253.8, 254);
  border-color: rgb(253.04, 253.32, 253.6);
}
.b-popover-light.bs-popover-top > .arrow::before, .b-popover-light.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(253.04, 253.32, 253.6);
}
.b-popover-light.bs-popover-top > .arrow::after, .b-popover-light.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(253.6, 253.8, 254);
}
.b-popover-light.bs-popover-right > .arrow::before, .b-popover-light.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(253.04, 253.32, 253.6);
}
.b-popover-light.bs-popover-right > .arrow::after, .b-popover-light.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(253.6, 253.8, 254);
}
.b-popover-light.bs-popover-bottom > .arrow::before, .b-popover-light.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(253.04, 253.32, 253.6);
}
.b-popover-light.bs-popover-bottom > .arrow::after, .b-popover-light.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(244.675, 246.15, 247.625);
}
.b-popover-light.bs-popover-bottom .popover-header::before, .b-popover-light.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(244.675, 246.15, 247.625);
}
.b-popover-light.bs-popover-left > .arrow::before, .b-popover-light.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(253.04, 253.32, 253.6);
}
.b-popover-light.bs-popover-left > .arrow::after, .b-popover-light.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(253.6, 253.8, 254);
}
.b-popover-light .popover-header {
  color: #212529;
  background-color: rgb(244.675, 246.15, 247.625);
  border-bottom-color: rgb(229.8, 233.4, 237);
}
.b-popover-light .popover-body {
  color: rgb(128.96, 129.48, 130);
}
.b-popover-dark.popover {
  background-color: rgb(214.4, 215.6, 216.8);
  border-color: rgb(198.16, 199.84, 201.52);
}
.b-popover-dark.bs-popover-top > .arrow::before, .b-popover-dark.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(198.16, 199.84, 201.52);
}
.b-popover-dark.bs-popover-top > .arrow::after, .b-popover-dark.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(214.4, 215.6, 216.8);
}
.b-popover-dark.bs-popover-right > .arrow::before, .b-popover-dark.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(198.16, 199.84, 201.52);
}
.b-popover-dark.bs-popover-right > .arrow::after, .b-popover-dark.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(214.4, 215.6, 216.8);
}
.b-popover-dark.bs-popover-bottom > .arrow::before, .b-popover-dark.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(198.16, 199.84, 201.52);
}
.b-popover-dark.bs-popover-bottom > .arrow::after, .b-popover-dark.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(206.5170050761, 207.95, 209.3829949239);
}
.b-popover-dark.bs-popover-bottom .popover-header::before, .b-popover-dark.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(206.5170050761, 207.95, 209.3829949239);
}
.b-popover-dark.bs-popover-left > .arrow::before, .b-popover-dark.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(198.16, 199.84, 201.52);
}
.b-popover-dark.bs-popover-left > .arrow::after, .b-popover-dark.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(214.4, 215.6, 216.8);
}
.b-popover-dark .popover-header {
  color: #212529;
  background-color: rgb(206.5170050761, 207.95, 209.3829949239);
  border-bottom-color: rgb(193.378680203, 195.2, 197.021319797);
}
.b-popover-dark .popover-body {
  color: rgb(27.04, 30.16, 33.28);
}
.b-popover-infinity.popover {
  background-color: rgb(250.2, 214.2, 231.4);
  border-color: rgb(248.28, 197.88, 221.96);
}
.b-popover-infinity.bs-popover-top > .arrow::before, .b-popover-infinity.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(248.28, 197.88, 221.96);
}
.b-popover-infinity.bs-popover-top > .arrow::after, .b-popover-infinity.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(250.2, 214.2, 231.4);
}
.b-popover-infinity.bs-popover-right > .arrow::before, .b-popover-infinity.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(248.28, 197.88, 221.96);
}
.b-popover-infinity.bs-popover-right > .arrow::after, .b-popover-infinity.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(250.2, 214.2, 231.4);
}
.b-popover-infinity.bs-popover-bottom > .arrow::before, .b-popover-infinity.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(248.28, 197.88, 221.96);
}
.b-popover-infinity.bs-popover-bottom > .arrow::after, .b-popover-infinity.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(248.5894736842, 200.5105263158, 223.4815789474);
}
.b-popover-infinity.bs-popover-bottom .popover-header::before, .b-popover-infinity.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(248.5894736842, 200.5105263158, 223.4815789474);
}
.b-popover-infinity.bs-popover-left > .arrow::before, .b-popover-infinity.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(248.28, 197.88, 221.96);
}
.b-popover-infinity.bs-popover-left > .arrow::after, .b-popover-infinity.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(250.2, 214.2, 231.4);
}
.b-popover-infinity .popover-header {
  color: #212529;
  background-color: rgb(248.5894736842, 200.5105263158, 223.4815789474);
  border-bottom-color: rgb(245.9052631579, 177.6947368421, 210.2842105263);
}
.b-popover-infinity .popover-body {
  color: rgb(120.12, 26.52, 71.24);
}
.b-popover-infinityDark.popover {
  background-color: rgb(239, 211.8, 225);
  border-color: rgb(232.6, 194.52, 213);
}
.b-popover-infinityDark.bs-popover-top > .arrow::before, .b-popover-infinityDark.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(232.6, 194.52, 213);
}
.b-popover-infinityDark.bs-popover-top > .arrow::after, .b-popover-infinityDark.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(239, 211.8, 225);
}
.b-popover-infinityDark.bs-popover-right > .arrow::before, .b-popover-infinityDark.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(232.6, 194.52, 213);
}
.b-popover-infinityDark.bs-popover-right > .arrow::after, .b-popover-infinityDark.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(239, 211.8, 225);
}
.b-popover-infinityDark.bs-popover-bottom > .arrow::before, .b-popover-infinityDark.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(232.6, 194.52, 213);
}
.b-popover-infinityDark.bs-popover-bottom > .arrow::after, .b-popover-infinityDark.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(234.8648648649, 200.6351351351, 217.2466216216);
}
.b-popover-infinityDark.bs-popover-bottom .popover-header::before, .b-popover-infinityDark.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(234.8648648649, 200.6351351351, 217.2466216216);
}
.b-popover-infinityDark.bs-popover-left > .arrow::before, .b-popover-infinityDark.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(232.6, 194.52, 213);
}
.b-popover-infinityDark.bs-popover-left > .arrow::after, .b-popover-infinityDark.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(239, 211.8, 225);
}
.b-popover-infinityDark .popover-header {
  color: #212529;
  background-color: rgb(234.8648648649, 200.6351351351, 217.2466216216);
  border-bottom-color: rgb(227.972972973, 182.027027027, 204.3243243243);
}
.b-popover-infinityDark .popover-body {
  color: rgb(91, 20.28, 54.6);
}
.b-popover-silver.popover {
  background-color: rgb(241.4, 241.4, 241.4);
  border-color: rgb(235.96, 235.96, 235.96);
}
.b-popover-silver.bs-popover-top > .arrow::before, .b-popover-silver.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(235.96, 235.96, 235.96);
}
.b-popover-silver.bs-popover-top > .arrow::after, .b-popover-silver.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(241.4, 241.4, 241.4);
}
.b-popover-silver.bs-popover-right > .arrow::before, .b-popover-silver.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(235.96, 235.96, 235.96);
}
.b-popover-silver.bs-popover-right > .arrow::after, .b-popover-silver.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(241.4, 241.4, 241.4);
}
.b-popover-silver.bs-popover-bottom > .arrow::before, .b-popover-silver.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(235.96, 235.96, 235.96);
}
.b-popover-silver.bs-popover-bottom > .arrow::after, .b-popover-silver.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(233.75, 233.75, 233.75);
}
.b-popover-silver.bs-popover-bottom .popover-header::before, .b-popover-silver.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(233.75, 233.75, 233.75);
}
.b-popover-silver.bs-popover-left > .arrow::before, .b-popover-silver.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(235.96, 235.96, 235.96);
}
.b-popover-silver.bs-popover-left > .arrow::after, .b-popover-silver.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(241.4, 241.4, 241.4);
}
.b-popover-silver .popover-header {
  color: #212529;
  background-color: rgb(233.75, 233.75, 233.75);
  border-bottom-color: #dddddd;
}
.b-popover-silver .popover-body {
  color: rgb(97.24, 97.24, 97.24);
}
.b-popover-whale.popover {
  background-color: rgb(206, 215, 218.6);
  border-color: rgb(186.4, 199, 204.04);
}
.b-popover-whale.bs-popover-top > .arrow::before, .b-popover-whale.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(186.4, 199, 204.04);
}
.b-popover-whale.bs-popover-top > .arrow::after, .b-popover-whale.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(206, 215, 218.6);
}
.b-popover-whale.bs-popover-right > .arrow::before, .b-popover-whale.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(186.4, 199, 204.04);
}
.b-popover-whale.bs-popover-right > .arrow::after, .b-popover-whale.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(206, 215, 218.6);
}
.b-popover-whale.bs-popover-bottom > .arrow::before, .b-popover-whale.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(186.4, 199, 204.04);
}
.b-popover-whale.bs-popover-bottom > .arrow::after, .b-popover-whale.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(197.2213114754, 207.8337236534, 212.0786885246);
}
.b-popover-whale.bs-popover-bottom .popover-header::before, .b-popover-whale.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(197.2213114754, 207.8337236534, 212.0786885246);
}
.b-popover-whale.bs-popover-left > .arrow::before, .b-popover-whale.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(186.4, 199, 204.04);
}
.b-popover-whale.bs-popover-left > .arrow::after, .b-popover-whale.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(206, 215, 218.6);
}
.b-popover-whale .popover-header {
  color: #212529;
  background-color: rgb(197.2213114754, 207.8337236534, 212.0786885246);
  border-bottom-color: rgb(182.5901639344, 195.8899297424, 201.2098360656);
}
.b-popover-whale .popover-body {
  color: rgb(5.2, 28.6, 37.96);
}
.b-popover-cello.popover {
  background-color: rgb(215, 218.8, 221.6);
  border-color: rgb(199, 204.32, 208.24);
}
.b-popover-cello.bs-popover-top > .arrow::before, .b-popover-cello.bs-popover-auto[x-placement^=top] > .arrow::before {
  border-top-color: rgb(199, 204.32, 208.24);
}
.b-popover-cello.bs-popover-top > .arrow::after, .b-popover-cello.bs-popover-auto[x-placement^=top] > .arrow::after {
  border-top-color: rgb(215, 218.8, 221.6);
}
.b-popover-cello.bs-popover-right > .arrow::before, .b-popover-cello.bs-popover-auto[x-placement^=right] > .arrow::before {
  border-right-color: rgb(199, 204.32, 208.24);
}
.b-popover-cello.bs-popover-right > .arrow::after, .b-popover-cello.bs-popover-auto[x-placement^=right] > .arrow::after {
  border-right-color: rgb(215, 218.8, 221.6);
}
.b-popover-cello.bs-popover-bottom > .arrow::before, .b-popover-cello.bs-popover-auto[x-placement^=bottom] > .arrow::before {
  border-bottom-color: rgb(199, 204.32, 208.24);
}
.b-popover-cello.bs-popover-bottom > .arrow::after, .b-popover-cello.bs-popover-auto[x-placement^=bottom] > .arrow::after {
  border-bottom-color: rgb(206.6621253406, 211.2542234332, 214.6378746594);
}
.b-popover-cello.bs-popover-bottom .popover-header::before, .b-popover-cello.bs-popover-auto[x-placement^=bottom] .popover-header::before {
  border-bottom-color: rgb(206.6621253406, 211.2542234332, 214.6378746594);
}
.b-popover-cello.bs-popover-left > .arrow::before, .b-popover-cello.bs-popover-auto[x-placement^=left] > .arrow::before {
  border-left-color: rgb(199, 204.32, 208.24);
}
.b-popover-cello.bs-popover-left > .arrow::after, .b-popover-cello.bs-popover-auto[x-placement^=left] > .arrow::after {
  border-left-color: rgb(215, 218.8, 221.6);
}
.b-popover-cello .popover-header {
  color: #212529;
  background-color: rgb(206.6621253406, 211.2542234332, 214.6378746594);
  border-bottom-color: rgb(192.7656675749, 198.6779291553, 203.0343324251);
}
.b-popover-cello .popover-body {
  color: rgb(28.6, 38.48, 45.76);
}
.b-sidebar-outer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 0;
  overflow: visible;
  z-index: calc(1030 + 5);
}
.b-sidebar-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100vw;
  height: 100vh;
  opacity: 0.6;
}
.b-sidebar {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  width: 320px;
  max-width: 100%;
  height: 100vh;
  max-height: 100%;
  margin: 0;
  outline: 0;
  transform: translateX(0);
}
.b-sidebar.slide {
  transition: transform 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
.b-sidebar.slide {
    transition: none;
}
}
.b-sidebar:not(.b-sidebar-right) {
  left: 0;
  right: auto;
}
.b-sidebar:not(.b-sidebar-right).slide:not(.show) {
  transform: translateX(-100%);
}
.b-sidebar:not(.b-sidebar-right) > .b-sidebar-header .close {
  margin-left: auto;
}
.b-sidebar.b-sidebar-right {
  left: auto;
  right: 0;
}
.b-sidebar.b-sidebar-right.slide:not(.show) {
  transform: translateX(100%);
}
.b-sidebar.b-sidebar-right > .b-sidebar-header .close {
  margin-right: auto;
}
.b-sidebar > .b-sidebar-header {
  font-size: 1.5rem;
  padding: 0.5rem 1rem;
  display: flex;
  flex-direction: row;
  flex-grow: 0;
  align-items: center;
}
[dir=rtl] .b-sidebar > .b-sidebar-header {
  flex-direction: row-reverse;
}
.b-sidebar > .b-sidebar-header .close {
  float: none;
  font-size: 1.5rem;
}
.b-sidebar > .b-sidebar-body {
  flex-grow: 1;
  height: 100%;
  overflow-y: auto;
}
.b-sidebar > .b-sidebar-footer {
  flex-grow: 0;
}
.b-skeleton-wrapper {
  cursor: wait;
}
.b-skeleton {
  position: relative;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.12);
  cursor: wait;
  -webkit-mask-image: radial-gradient(white, black);
          mask-image: radial-gradient(white, black);
}
.b-skeleton::before {
  content: " ";
}
.b-skeleton-text {
  height: 1rem;
  margin-bottom: 0.25rem;
  border-radius: 0.25rem;
}
.b-skeleton-button {
  width: 75px;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.2;
  border-radius: 0.25rem;
}
.b-skeleton-avatar {
  width: 2.5em;
  height: 2.5em;
  border-radius: 50%;
}
.b-skeleton-input {
  height: calc(1.2em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  line-height: 1.2;
  border: #ced4da solid 1px;
  border-radius: 0.25rem;
}
.b-skeleton-icon-wrapper svg {
  color: rgba(0, 0, 0, 0.12);
}
.b-skeleton-img {
  height: 100%;
  width: 100%;
}
.b-skeleton-animate-wave::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  background: linear-gradient(90deg, transparent, hsla(0, 0%, 100%, 0.4), transparent);
  animation: b-skeleton-animate-wave 1.75s linear infinite;
}
@media (prefers-reduced-motion: reduce) {
.b-skeleton-animate-wave::after {
    background: none;
    animation: none;
}
}
@keyframes b-skeleton-animate-wave {
from {
    transform: translateX(-100%);
}
to {
    transform: translateX(100%);
}
}
.b-skeleton-animate-fade {
  animation: b-skeleton-animate-fade 0.875s ease-in-out alternate infinite;
}
@media (prefers-reduced-motion: reduce) {
.b-skeleton-animate-fade {
    animation: none;
}
}
@keyframes b-skeleton-animate-fade {
0% {
    opacity: 1;
}
100% {
    opacity: 0.4;
}
}
.b-skeleton-animate-throb {
  animation: b-skeleton-animate-throb 0.875s ease-in alternate infinite;
}
@media (prefers-reduced-motion: reduce) {
.b-skeleton-animate-throb {
    animation: none;
}
}
@keyframes b-skeleton-animate-throb {
0% {
    transform: scale(1);
}
100% {
    transform: scale(0.975);
}
}
.table.b-table.b-table-fixed {
  table-layout: fixed;
}
.table.b-table.b-table-no-border-collapse {
  border-collapse: separate;
  border-spacing: 0;
}
.table.b-table[aria-busy=true] {
  opacity: 0.55;
}
.table.b-table > tbody > tr.b-table-details > td {
  border-top: none !important;
}
.table.b-table > caption {
  caption-side: bottom;
}
.table.b-table.b-table-caption-top > caption {
  caption-side: top !important;
}
.table.b-table > tbody > .table-active,
.table.b-table > tbody > .table-active > th,
.table.b-table > tbody > .table-active > td {
  background-color: rgba(0, 0, 0, 0.075);
}
.table.b-table.table-hover > tbody > tr.table-active:hover td,
.table.b-table.table-hover > tbody > tr.table-active:hover th {
  color: #6c8892;
  background-image: linear-gradient(rgba(0, 0, 0, 0.075), rgba(0, 0, 0, 0.075));
  background-repeat: no-repeat;
}
.table.b-table > tbody > .bg-active,
.table.b-table > tbody > .bg-active > th,
.table.b-table > tbody > .bg-active > td {
  background-color: rgba(255, 255, 255, 0.075) !important;
}
.table.b-table.table-hover.table-dark > tbody > tr.bg-active:hover td,
.table.b-table.table-hover.table-dark > tbody > tr.bg-active:hover th {
  color: #fff;
  background-image: linear-gradient(rgba(255, 255, 255, 0.075), rgba(255, 255, 255, 0.075));
  background-repeat: no-repeat;
}
.b-table-sticky-header,
.table-responsive,
[class*=table-responsive-] {
  margin-bottom: 1rem;
}
.b-table-sticky-header > .table,
.table-responsive > .table,
[class*=table-responsive-] > .table {
  margin-bottom: 0;
}
.b-table-sticky-header {
  overflow-y: auto;
  max-height: 300px;
}
@media print {
.b-table-sticky-header {
    overflow-y: visible !important;
    max-height: none !important;
}
}
@supports (position: sticky) {
.b-table-sticky-header > .table.b-table > thead > tr > th {
    position: sticky;
    top: 0;
    z-index: 2;
}
.b-table-sticky-header > .table.b-table > thead > tr > .b-table-sticky-column,
  .b-table-sticky-header > .table.b-table > tbody > tr > .b-table-sticky-column,
  .b-table-sticky-header > .table.b-table > tfoot > tr > .b-table-sticky-column,
  .table-responsive > .table.b-table > thead > tr > .b-table-sticky-column,
  .table-responsive > .table.b-table > tbody > tr > .b-table-sticky-column,
  .table-responsive > .table.b-table > tfoot > tr > .b-table-sticky-column,
  [class*=table-responsive-] > .table.b-table > thead > tr > .b-table-sticky-column,
  [class*=table-responsive-] > .table.b-table > tbody > tr > .b-table-sticky-column,
  [class*=table-responsive-] > .table.b-table > tfoot > tr > .b-table-sticky-column {
    position: sticky;
    left: 0;
}
.b-table-sticky-header > .table.b-table > thead > tr > .b-table-sticky-column,
  .table-responsive > .table.b-table > thead > tr > .b-table-sticky-column,
  [class*=table-responsive-] > .table.b-table > thead > tr > .b-table-sticky-column {
    z-index: 5;
}
.b-table-sticky-header > .table.b-table > tbody > tr > .b-table-sticky-column,
  .b-table-sticky-header > .table.b-table > tfoot > tr > .b-table-sticky-column,
  .table-responsive > .table.b-table > tbody > tr > .b-table-sticky-column,
  .table-responsive > .table.b-table > tfoot > tr > .b-table-sticky-column,
  [class*=table-responsive-] > .table.b-table > tbody > tr > .b-table-sticky-column,
  [class*=table-responsive-] > .table.b-table > tfoot > tr > .b-table-sticky-column {
    z-index: 2;
}
.table.b-table > thead > tr > .table-b-table-default,
  .table.b-table > tbody > tr > .table-b-table-default,
  .table.b-table > tfoot > tr > .table-b-table-default {
    color: #6c8892;
    background-color: #f0f2f4;
}
.table.b-table.table-dark > thead > tr > .bg-b-table-default,
  .table.b-table.table-dark > tbody > tr > .bg-b-table-default,
  .table.b-table.table-dark > tfoot > tr > .bg-b-table-default {
    color: #fff;
    background-color: #343a40;
}
.table.b-table.table-striped > tbody > tr:nth-of-type(odd) > .table-b-table-default {
    background-image: linear-gradient(rgba(0, 0, 0, 0.05), rgba(0, 0, 0, 0.05));
    background-repeat: no-repeat;
}
.table.b-table.table-striped.table-dark > tbody > tr:nth-of-type(odd) > .bg-b-table-default {
    background-image: linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05));
    background-repeat: no-repeat;
}
.table.b-table.table-hover > tbody > tr:hover > .table-b-table-default {
    color: #6c8892;
    background-image: linear-gradient(rgba(0, 0, 0, 0.075), rgba(0, 0, 0, 0.075));
    background-repeat: no-repeat;
}
.table.b-table.table-hover.table-dark > tbody > tr:hover > .bg-b-table-default {
    color: #fff;
    background-image: linear-gradient(rgba(255, 255, 255, 0.075), rgba(255, 255, 255, 0.075));
    background-repeat: no-repeat;
}
}
.table.b-table > thead > tr > [aria-sort],
.table.b-table > tfoot > tr > [aria-sort] {
  cursor: pointer;
  background-image: none;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
}
.table.b-table > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table > tfoot > tr > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(0.75rem / 2) center;
  padding-right: calc(0.75rem + 0.65em);
}
.table.b-table > thead > tr > [aria-sort].b-table-sort-icon-left,
.table.b-table > tfoot > tr > [aria-sort].b-table-sort-icon-left {
  background-position: left calc(0.75rem / 2) center;
  padding-left: calc(0.75rem + 0.65em);
}
.table.b-table > thead > tr > [aria-sort=none],
.table.b-table > tfoot > tr > [aria-sort=none] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.table.b-table > thead > tr > [aria-sort=ascending],
.table.b-table > tfoot > tr > [aria-sort=ascending] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}
.table.b-table > thead > tr > [aria-sort=descending],
.table.b-table > tfoot > tr > [aria-sort=descending] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}
.table.b-table.table-dark > thead > tr > [aria-sort=none], .table.b-table.table-dark > tfoot > tr > [aria-sort=none],
.table.b-table > .thead-dark > tr > [aria-sort=none] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.table.b-table.table-dark > thead > tr > [aria-sort=ascending], .table.b-table.table-dark > tfoot > tr > [aria-sort=ascending],
.table.b-table > .thead-dark > tr > [aria-sort=ascending] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.table.b-table.table-dark > thead > tr > [aria-sort=descending], .table.b-table.table-dark > tfoot > tr > [aria-sort=descending],
.table.b-table > .thead-dark > tr > [aria-sort=descending] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.table.b-table > thead > tr > .table-dark[aria-sort=none],
.table.b-table > tfoot > tr > .table-dark[aria-sort=none] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}
.table.b-table > thead > tr > .table-dark[aria-sort=ascending],
.table.b-table > tfoot > tr > .table-dark[aria-sort=ascending] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}
.table.b-table > thead > tr > .table-dark[aria-sort=descending],
.table.b-table > tfoot > tr > .table-dark[aria-sort=descending] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm > tfoot > tr > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(0.3rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
.table.b-table.table-sm > thead > tr > [aria-sort].b-table-sort-icon-left,
.table.b-table.table-sm > tfoot > tr > [aria-sort].b-table-sort-icon-left {
  background-position: left calc(0.3rem / 2) center;
  padding-left: calc(0.3rem + 0.65em);
}
.table.b-table.b-table-selectable:not(.b-table-selectable-no-click) > tbody > tr {
  cursor: pointer;
}
.table.b-table.b-table-selectable:not(.b-table-selectable-no-click).b-table-selecting.b-table-select-range > tbody > tr {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
@media (max-width: 575.98px) {
.table.b-table.b-table-stacked-sm {
    display: block;
    width: 100%;
}
.table.b-table.b-table-stacked-sm > caption,
  .table.b-table.b-table-stacked-sm > tbody,
  .table.b-table.b-table-stacked-sm > tbody > tr,
  .table.b-table.b-table-stacked-sm > tbody > tr > td,
  .table.b-table.b-table-stacked-sm > tbody > tr > th {
    display: block;
}
.table.b-table.b-table-stacked-sm > thead,
  .table.b-table.b-table-stacked-sm > tfoot {
    display: none;
}
.table.b-table.b-table-stacked-sm > thead > tr.b-table-top-row,
  .table.b-table.b-table-stacked-sm > thead > tr.b-table-bottom-row,
  .table.b-table.b-table-stacked-sm > tfoot > tr.b-table-top-row,
  .table.b-table.b-table-stacked-sm > tfoot > tr.b-table-bottom-row {
    display: none;
}
.table.b-table.b-table-stacked-sm > caption {
    caption-side: top !important;
}
.table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::before {
    content: attr(data-label);
    width: 40%;
    float: left;
    text-align: right;
    overflow-wrap: break-word;
    font-weight: bold;
    font-style: normal;
    padding: 0 calc(1rem / 2) 0 0;
    margin: 0;
}
.table.b-table.b-table-stacked-sm > tbody > tr > [data-label]::after {
    display: block;
    clear: both;
    content: "";
}
.table.b-table.b-table-stacked-sm > tbody > tr > [data-label] > div {
    display: inline-block;
    width: calc(100% - 40%);
    padding: 0 0 0 calc(1rem / 2);
    margin: 0;
}
.table.b-table.b-table-stacked-sm > tbody > tr.top-row, .table.b-table.b-table-stacked-sm > tbody > tr.bottom-row {
    display: none;
}
.table.b-table.b-table-stacked-sm > tbody > tr > :first-child {
    border-top-width: 3px;
}
.table.b-table.b-table-stacked-sm > tbody > tr > [rowspan] + td,
  .table.b-table.b-table-stacked-sm > tbody > tr > [rowspan] + th {
    border-top-width: 3px;
}
}
@media (max-width: 767.98px) {
.table.b-table.b-table-stacked-md {
    display: block;
    width: 100%;
}
.table.b-table.b-table-stacked-md > caption,
  .table.b-table.b-table-stacked-md > tbody,
  .table.b-table.b-table-stacked-md > tbody > tr,
  .table.b-table.b-table-stacked-md > tbody > tr > td,
  .table.b-table.b-table-stacked-md > tbody > tr > th {
    display: block;
}
.table.b-table.b-table-stacked-md > thead,
  .table.b-table.b-table-stacked-md > tfoot {
    display: none;
}
.table.b-table.b-table-stacked-md > thead > tr.b-table-top-row,
  .table.b-table.b-table-stacked-md > thead > tr.b-table-bottom-row,
  .table.b-table.b-table-stacked-md > tfoot > tr.b-table-top-row,
  .table.b-table.b-table-stacked-md > tfoot > tr.b-table-bottom-row {
    display: none;
}
.table.b-table.b-table-stacked-md > caption {
    caption-side: top !important;
}
.table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {
    content: attr(data-label);
    width: 40%;
    float: left;
    text-align: right;
    overflow-wrap: break-word;
    font-weight: bold;
    font-style: normal;
    padding: 0 calc(1rem / 2) 0 0;
    margin: 0;
}
.table.b-table.b-table-stacked-md > tbody > tr > [data-label]::after {
    display: block;
    clear: both;
    content: "";
}
.table.b-table.b-table-stacked-md > tbody > tr > [data-label] > div {
    display: inline-block;
    width: calc(100% - 40%);
    padding: 0 0 0 calc(1rem / 2);
    margin: 0;
}
.table.b-table.b-table-stacked-md > tbody > tr.top-row, .table.b-table.b-table-stacked-md > tbody > tr.bottom-row {
    display: none;
}
.table.b-table.b-table-stacked-md > tbody > tr > :first-child {
    border-top-width: 3px;
}
.table.b-table.b-table-stacked-md > tbody > tr > [rowspan] + td,
  .table.b-table.b-table-stacked-md > tbody > tr > [rowspan] + th {
    border-top-width: 3px;
}
}
@media (max-width: 991.98px) {
.table.b-table.b-table-stacked-lg {
    display: block;
    width: 100%;
}
.table.b-table.b-table-stacked-lg > caption,
  .table.b-table.b-table-stacked-lg > tbody,
  .table.b-table.b-table-stacked-lg > tbody > tr,
  .table.b-table.b-table-stacked-lg > tbody > tr > td,
  .table.b-table.b-table-stacked-lg > tbody > tr > th {
    display: block;
}
.table.b-table.b-table-stacked-lg > thead,
  .table.b-table.b-table-stacked-lg > tfoot {
    display: none;
}
.table.b-table.b-table-stacked-lg > thead > tr.b-table-top-row,
  .table.b-table.b-table-stacked-lg > thead > tr.b-table-bottom-row,
  .table.b-table.b-table-stacked-lg > tfoot > tr.b-table-top-row,
  .table.b-table.b-table-stacked-lg > tfoot > tr.b-table-bottom-row {
    display: none;
}
.table.b-table.b-table-stacked-lg > caption {
    caption-side: top !important;
}
.table.b-table.b-table-stacked-lg > tbody > tr > [data-label]::before {
    content: attr(data-label);
    width: 40%;
    float: left;
    text-align: right;
    overflow-wrap: break-word;
    font-weight: bold;
    font-style: normal;
    padding: 0 calc(1rem / 2) 0 0;
    margin: 0;
}
.table.b-table.b-table-stacked-lg > tbody > tr > [data-label]::after {
    display: block;
    clear: both;
    content: "";
}
.table.b-table.b-table-stacked-lg > tbody > tr > [data-label] > div {
    display: inline-block;
    width: calc(100% - 40%);
    padding: 0 0 0 calc(1rem / 2);
    margin: 0;
}
.table.b-table.b-table-stacked-lg > tbody > tr.top-row, .table.b-table.b-table-stacked-lg > tbody > tr.bottom-row {
    display: none;
}
.table.b-table.b-table-stacked-lg > tbody > tr > :first-child {
    border-top-width: 3px;
}
.table.b-table.b-table-stacked-lg > tbody > tr > [rowspan] + td,
  .table.b-table.b-table-stacked-lg > tbody > tr > [rowspan] + th {
    border-top-width: 3px;
}
}
@media (max-width: 1199.98px) {
.table.b-table.b-table-stacked-xl {
    display: block;
    width: 100%;
}
.table.b-table.b-table-stacked-xl > caption,
  .table.b-table.b-table-stacked-xl > tbody,
  .table.b-table.b-table-stacked-xl > tbody > tr,
  .table.b-table.b-table-stacked-xl > tbody > tr > td,
  .table.b-table.b-table-stacked-xl > tbody > tr > th {
    display: block;
}
.table.b-table.b-table-stacked-xl > thead,
  .table.b-table.b-table-stacked-xl > tfoot {
    display: none;
}
.table.b-table.b-table-stacked-xl > thead > tr.b-table-top-row,
  .table.b-table.b-table-stacked-xl > thead > tr.b-table-bottom-row,
  .table.b-table.b-table-stacked-xl > tfoot > tr.b-table-top-row,
  .table.b-table.b-table-stacked-xl > tfoot > tr.b-table-bottom-row {
    display: none;
}
.table.b-table.b-table-stacked-xl > caption {
    caption-side: top !important;
}
.table.b-table.b-table-stacked-xl > tbody > tr > [data-label]::before {
    content: attr(data-label);
    width: 40%;
    float: left;
    text-align: right;
    overflow-wrap: break-word;
    font-weight: bold;
    font-style: normal;
    padding: 0 calc(1rem / 2) 0 0;
    margin: 0;
}
.table.b-table.b-table-stacked-xl > tbody > tr > [data-label]::after {
    display: block;
    clear: both;
    content: "";
}
.table.b-table.b-table-stacked-xl > tbody > tr > [data-label] > div {
    display: inline-block;
    width: calc(100% - 40%);
    padding: 0 0 0 calc(1rem / 2);
    margin: 0;
}
.table.b-table.b-table-stacked-xl > tbody > tr.top-row, .table.b-table.b-table-stacked-xl > tbody > tr.bottom-row {
    display: none;
}
.table.b-table.b-table-stacked-xl > tbody > tr > :first-child {
    border-top-width: 3px;
}
.table.b-table.b-table-stacked-xl > tbody > tr > [rowspan] + td,
  .table.b-table.b-table-stacked-xl > tbody > tr > [rowspan] + th {
    border-top-width: 3px;
}
}
.table.b-table.b-table-stacked {
  display: block;
  width: 100%;
}
.table.b-table.b-table-stacked > caption,
.table.b-table.b-table-stacked > tbody,
.table.b-table.b-table-stacked > tbody > tr,
.table.b-table.b-table-stacked > tbody > tr > td,
.table.b-table.b-table-stacked > tbody > tr > th {
  display: block;
}
.table.b-table.b-table-stacked > thead,
.table.b-table.b-table-stacked > tfoot {
  display: none;
}
.table.b-table.b-table-stacked > thead > tr.b-table-top-row,
.table.b-table.b-table-stacked > thead > tr.b-table-bottom-row,
.table.b-table.b-table-stacked > tfoot > tr.b-table-top-row,
.table.b-table.b-table-stacked > tfoot > tr.b-table-bottom-row {
  display: none;
}
.table.b-table.b-table-stacked > caption {
  caption-side: top !important;
}
.table.b-table.b-table-stacked > tbody > tr > [data-label]::before {
  content: attr(data-label);
  width: 40%;
  float: left;
  text-align: right;
  overflow-wrap: break-word;
  font-weight: bold;
  font-style: normal;
  padding: 0 calc(1rem / 2) 0 0;
  margin: 0;
}
.table.b-table.b-table-stacked > tbody > tr > [data-label]::after {
  display: block;
  clear: both;
  content: "";
}
.table.b-table.b-table-stacked > tbody > tr > [data-label] > div {
  display: inline-block;
  width: calc(100% - 40%);
  padding: 0 0 0 calc(1rem / 2);
  margin: 0;
}
.table.b-table.b-table-stacked > tbody > tr.top-row, .table.b-table.b-table-stacked > tbody > tr.bottom-row {
  display: none;
}
.table.b-table.b-table-stacked > tbody > tr > :first-child {
  border-top-width: 3px;
}
.table.b-table.b-table-stacked > tbody > tr > [rowspan] + td,
.table.b-table.b-table-stacked > tbody > tr > [rowspan] + th {
  border-top-width: 3px;
}
.b-time {
  min-width: 150px;
}
.b-time[aria-disabled=true] output, .b-time[aria-readonly=true] output,
.b-time output.disabled {
  background-color: #e9ecef;
  opacity: 1;
}
.b-time[aria-disabled=true] output {
  pointer-events: none;
}
[dir=rtl] .b-time > .d-flex:not(.flex-column) {
  flex-direction: row-reverse;
}
.b-time .b-time-header {
  margin-bottom: 0.5rem;
}
.b-time .b-time-header output {
  padding: 0.25rem;
  font-size: 80%;
}
.b-time .b-time-footer {
  margin-top: 0.5rem;
}
.b-time .b-time-ampm {
  margin-left: 0.5rem;
}
.b-toast {
  display: block;
  position: relative;
  max-width: 350px;
  backface-visibility: hidden;
  background-clip: padding-box;
  z-index: 1;
  border-radius: 0.25rem;
}
.b-toast .toast {
  background-color: rgba(255, 255, 255, 0.85);
}
.b-toast:not(:last-child) {
  margin-bottom: 0.75rem;
}
.b-toast.b-toast-solid .toast {
  background-color: white;
}
.b-toast .toast {
  opacity: 1;
}
.b-toast .toast.fade:not(.show) {
  opacity: 0;
}
.b-toast .toast .toast-body {
  display: block;
}
.b-toast-primary .toast {
  background-color: rgba(234.7923076923, 245.4423076923, 253.9076923077, 0.85);
  border-color: rgba(192.84, 225.6, 251.64, 0.85);
  color: rgb(17.16, 78, 126.36);
}
.b-toast-primary .toast .toast-header {
  color: rgb(17.16, 78, 126.36);
  background-color: rgba(210.6, 234, 252.6, 0.85);
  border-bottom-color: rgba(192.84, 225.6, 251.64, 0.85);
}
.b-toast-primary.b-toast-solid .toast {
  background-color: rgb(234.7923076923, 245.4423076923, 253.9076923077);
}
.b-toast-secondary .toast {
  background-color: rgba(239.1324909747, 240.1039711191, 240.9675090253, 0.85);
  border-color: rgba(213.84, 216.36, 218.6, 0.85);
  color: rgb(56.16, 60.84, 65);
}
.b-toast-secondary .toast .toast-header {
  color: rgb(56.16, 60.84, 65);
  background-color: rgba(225.6, 227.4, 229, 0.85);
  border-bottom-color: rgba(213.84, 216.36, 218.6, 0.85);
}
.b-toast-secondary.b-toast-solid .toast {
  background-color: rgb(239.1324909747, 240.1039711191, 240.9675090253);
}
.b-toast-success .toast {
  background-color: rgba(236.8235521236, 246.8764478764, 237.2297297297, 0.85);
  border-color: rgba(204.88, 232.6, 206, 0.85);
  color: rgb(39.52, 91, 41.6);
}
.b-toast-success .toast .toast-header {
  color: rgb(39.52, 91, 41.6);
  background-color: rgba(219.2, 239, 220, 0.85);
  border-bottom-color: rgba(204.88, 232.6, 206, 0.85);
}
.b-toast-success.b-toast-solid .toast {
  background-color: rgb(236.8235521236, 246.8764478764, 237.2297297297);
}
.b-toast-info .toast {
  background-color: rgba(234.7923076923, 245.4423076923, 253.9076923077, 0.85);
  border-color: rgba(192.84, 225.6, 251.64, 0.85);
  color: rgb(17.16, 78, 126.36);
}
.b-toast-info .toast .toast-header {
  color: rgb(17.16, 78, 126.36);
  background-color: rgba(210.6, 234, 252.6, 0.85);
  border-bottom-color: rgba(192.84, 225.6, 251.64, 0.85);
}
.b-toast-info.b-toast-solid .toast {
  background-color: rgb(234.7923076923, 245.4423076923, 253.9076923077);
}
.b-toast-warning .toast {
  background-color: rgba(255, 248.975, 230.9, 0.85);
  border-color: rgba(255, 237.64, 185.56, 0.85);
  color: rgb(132.6, 100.36, 3.64);
}
.b-toast-warning .toast .toast-header {
  color: rgb(132.6, 100.36, 3.64);
  background-color: rgba(255, 242.6, 205.4, 0.85);
  border-bottom-color: rgba(255, 237.64, 185.56, 0.85);
}
.b-toast-warning.b-toast-solid .toast {
  background-color: rgb(255, 248.975, 230.9);
}
.b-toast-danger .toast {
  background-color: rgba(254.1231132075, 240.0132075472, 238.9768867925, 0.85);
  border-color: rgba(251.92, 202.36, 198.72, 0.85);
  color: rgb(126.88, 34.84, 28.08);
}
.b-toast-danger .toast .toast-header {
  color: rgb(126.88, 34.84, 28.08);
  background-color: rgba(252.8, 217.4, 214.8, 0.85);
  border-bottom-color: rgba(251.92, 202.36, 198.72, 0.85);
}
.b-toast-danger.b-toast-solid .toast {
  background-color: rgb(254.1231132075, 240.0132075472, 238.9768867925);
}
.b-toast-light .toast {
  background-color: rgba(255, 255, 255, 0.85);
  border-color: rgba(253.04, 253.32, 253.6, 0.85);
  color: rgb(128.96, 129.48, 130);
}
.b-toast-light .toast .toast-header {
  color: rgb(128.96, 129.48, 130);
  background-color: rgba(253.6, 253.8, 254, 0.85);
  border-bottom-color: rgba(253.04, 253.32, 253.6, 0.85);
}
.b-toast-light.b-toast-solid .toast {
  background-color: white;
}
.b-toast-dark .toast {
  background-color: rgba(227.5383248731, 228.35, 229.1616751269, 0.85);
  border-color: rgba(198.16, 199.84, 201.52, 0.85);
  color: rgb(27.04, 30.16, 33.28);
}
.b-toast-dark .toast .toast-header {
  color: rgb(27.04, 30.16, 33.28);
  background-color: rgba(214.4, 215.6, 216.8, 0.85);
  border-bottom-color: rgba(198.16, 199.84, 201.52, 0.85);
}
.b-toast-dark.b-toast-solid .toast {
  background-color: rgb(227.5383248731, 228.35, 229.1616751269);
}
.b-toast-infinity .toast {
  background-color: rgba(252.8842105263, 237.0157894737, 244.5973684211, 0.85);
  border-color: rgba(248.28, 197.88, 221.96, 0.85);
  color: rgb(120.12, 26.52, 71.24);
}
.b-toast-infinity .toast .toast-header {
  color: rgb(120.12, 26.52, 71.24);
  background-color: rgba(250.2, 214.2, 231.4, 0.85);
  border-bottom-color: rgba(248.28, 197.88, 221.96, 0.85);
}
.b-toast-infinity.b-toast-solid .toast {
  background-color: rgb(252.8842105263, 237.0157894737, 244.5973684211);
}
.b-toast-infinityDark .toast {
  background-color: rgba(245.8918918919, 230.4081081081, 237.9222972973, 0.85);
  border-color: rgba(232.6, 194.52, 213, 0.85);
  color: rgb(91, 20.28, 54.6);
}
.b-toast-infinityDark .toast .toast-header {
  color: rgb(91, 20.28, 54.6);
  background-color: rgba(239, 211.8, 225, 0.85);
  border-bottom-color: rgba(232.6, 194.52, 213, 0.85);
}
.b-toast-infinityDark.b-toast-solid .toast {
  background-color: rgb(245.8918918919, 230.4081081081, 237.9222972973);
}
.b-toast-silver .toast {
  background-color: rgba(254.15, 254.15, 254.15, 0.85);
  border-color: rgba(235.96, 235.96, 235.96, 0.85);
  color: rgb(97.24, 97.24, 97.24);
}
.b-toast-silver .toast .toast-header {
  color: rgb(97.24, 97.24, 97.24);
  background-color: rgba(241.4, 241.4, 241.4, 0.85);
  border-bottom-color: rgba(235.96, 235.96, 235.96, 0.85);
}
.b-toast-silver.b-toast-solid .toast {
  background-color: rgb(254.15, 254.15, 254.15);
}
.b-toast-whale .toast {
  background-color: rgba(220.631147541, 226.943793911, 229.468852459, 0.85);
  border-color: rgba(186.4, 199, 204.04, 0.85);
  color: rgb(5.2, 28.6, 37.96);
}
.b-toast-whale .toast .toast-header {
  color: rgb(5.2, 28.6, 37.96);
  background-color: rgba(206, 215, 218.6, 0.85);
  border-bottom-color: rgba(186.4, 199, 204.04, 0.85);
}
.b-toast-whale.b-toast-solid .toast {
  background-color: rgb(220.631147541, 226.943793911, 229.468852459);
}
.b-toast-cello .toast {
  background-color: rgba(228.8964577657, 231.3762942779, 233.2035422343, 0.85);
  border-color: rgba(199, 204.32, 208.24, 0.85);
  color: rgb(28.6, 38.48, 45.76);
}
.b-toast-cello .toast .toast-header {
  color: rgb(28.6, 38.48, 45.76);
  background-color: rgba(215, 218.8, 221.6, 0.85);
  border-bottom-color: rgba(199, 204.32, 208.24, 0.85);
}
.b-toast-cello.b-toast-solid .toast {
  background-color: rgb(228.8964577657, 231.3762942779, 233.2035422343);
}
.b-toaster {
  z-index: 1100;
}
.b-toaster .b-toaster-slot {
  position: relative;
  display: block;
}
.b-toaster .b-toaster-slot:empty {
  display: none !important;
}
.b-toaster.b-toaster-top-right, .b-toaster.b-toaster-top-left, .b-toaster.b-toaster-top-center, .b-toaster.b-toaster-top-full, .b-toaster.b-toaster-bottom-right, .b-toaster.b-toaster-bottom-left, .b-toaster.b-toaster-bottom-center, .b-toaster.b-toaster-bottom-full {
  position: fixed;
  left: 0.5rem;
  right: 0.5rem;
  margin: 0;
  padding: 0;
  height: 0;
  overflow: visible;
}
.b-toaster.b-toaster-top-right .b-toaster-slot, .b-toaster.b-toaster-top-left .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-top-full .b-toaster-slot, .b-toaster.b-toaster-bottom-right .b-toaster-slot, .b-toaster.b-toaster-bottom-left .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot, .b-toaster.b-toaster-bottom-full .b-toaster-slot {
  position: absolute;
  max-width: 350px;
  width: 100%; /* IE 11 fix */
  left: 0;
  right: 0;
  padding: 0;
  margin: 0;
}
.b-toaster.b-toaster-top-full .b-toaster-slot, .b-toaster.b-toaster-bottom-full .b-toaster-slot {
  width: 100%;
  max-width: 100%;
}
.b-toaster.b-toaster-top-full .b-toaster-slot .b-toast,
.b-toaster.b-toaster-top-full .b-toaster-slot .toast, .b-toaster.b-toaster-bottom-full .b-toaster-slot .b-toast,
.b-toaster.b-toaster-bottom-full .b-toaster-slot .toast {
  width: 100%;
  max-width: 100%;
}
.b-toaster.b-toaster-top-right, .b-toaster.b-toaster-top-left, .b-toaster.b-toaster-top-center, .b-toaster.b-toaster-top-full {
  top: 0;
}
.b-toaster.b-toaster-top-right .b-toaster-slot, .b-toaster.b-toaster-top-left .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-top-full .b-toaster-slot {
  top: 0.5rem;
}
.b-toaster.b-toaster-bottom-right, .b-toaster.b-toaster-bottom-left, .b-toaster.b-toaster-bottom-center, .b-toaster.b-toaster-bottom-full {
  bottom: 0;
}
.b-toaster.b-toaster-bottom-right .b-toaster-slot, .b-toaster.b-toaster-bottom-left .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot, .b-toaster.b-toaster-bottom-full .b-toaster-slot {
  bottom: 0.5rem;
}
.b-toaster.b-toaster-top-right .b-toaster-slot, .b-toaster.b-toaster-bottom-right .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot {
  margin-left: auto;
}
.b-toaster.b-toaster-top-left .b-toaster-slot, .b-toaster.b-toaster-bottom-left .b-toaster-slot, .b-toaster.b-toaster-top-center .b-toaster-slot, .b-toaster.b-toaster-bottom-center .b-toaster-slot {
  margin-right: auto;
}
.b-toaster.b-toaster-top-right .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-top-right .b-toast.b-toaster-move, .b-toaster.b-toaster-top-left .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-top-left .b-toast.b-toaster-move, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-move, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-enter-active, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-move {
  transition: transform 0.175s;
}
.b-toaster.b-toaster-top-right .b-toast.b-toaster-enter-to .toast.fade, .b-toaster.b-toaster-top-right .b-toast.b-toaster-enter-active .toast.fade, .b-toaster.b-toaster-top-left .b-toast.b-toaster-enter-to .toast.fade, .b-toaster.b-toaster-top-left .b-toast.b-toaster-enter-active .toast.fade, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-enter-to .toast.fade, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-enter-active .toast.fade, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-enter-to .toast.fade, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-enter-active .toast.fade {
  transition-delay: 0.175s;
}
.b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active {
  position: absolute;
  transition-delay: 0.175s;
}
.b-toaster.b-toaster-top-right .b-toast.b-toaster-leave-active .toast.fade, .b-toaster.b-toaster-top-left .b-toast.b-toaster-leave-active .toast.fade, .b-toaster.b-toaster-bottom-right .b-toast.b-toaster-leave-active .toast.fade, .b-toaster.b-toaster-bottom-left .b-toast.b-toaster-leave-active .toast.fade {
  transition-delay: 0s;
}
.tooltip.b-tooltip {
  display: block;
  opacity: 0.9;
  outline: 0;
}
.tooltip.b-tooltip.fade:not(.show) {
  opacity: 0;
}
.tooltip.b-tooltip.show {
  opacity: 0.9;
}
.tooltip.b-tooltip.noninteractive {
  pointer-events: none;
}
.tooltip.b-tooltip .arrow {
  margin: 0 0.25rem;
}
.tooltip.b-tooltip.bs-tooltip-right .arrow, .tooltip.b-tooltip.b-tooltip-cello.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.b-tooltip-whale.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.b-tooltip-silver.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.b-tooltip-infinityDark.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.b-tooltip-infinity.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^=right] .arrow, .tooltip.b-tooltip.bs-tooltip-left .arrow, .tooltip.b-tooltip.b-tooltip-cello.bs-tooltip-auto[x-placement^=left] .arrow, .tooltip.b-tooltip.b-tooltip-whale.bs-tooltip-auto[x-placement^=left] .arrow, .tooltip.b-tooltip.b-tooltip-silver.bs-tooltip-auto[x-placement^=left] .arrow, .tooltip.b-tooltip.b-tooltip-infinityDark.bs-tooltip-auto[x-placement^=left] .arrow, .tooltip.b-tooltip.b-tooltip-infinity.bs-tooltip-auto[x-placement^=left] .arrow, .tooltip.b-tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^=left] .arrow, .tooltip.b-tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^=left] .arrow, .tooltip.b-tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^=left] .arrow, .tooltip.b-tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^=left] .arrow, .tooltip.b-tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^=left] .arrow, .tooltip.b-tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^=left] .arrow, .tooltip.b-tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^=left] .arrow, .tooltip.b-tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^=left] .arrow {
  margin: 0.25rem 0;
}
.tooltip.b-tooltip-primary.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #2196f3;
}
.tooltip.b-tooltip-primary.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #2196f3;
}
.tooltip.b-tooltip-primary.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #2196f3;
}
.tooltip.b-tooltip-primary.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-primary.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #2196f3;
}
.tooltip.b-tooltip-primary .tooltip-inner {
  color: #fff;
  background-color: #2196f3;
}
.tooltip.b-tooltip-secondary.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #6c757d;
}
.tooltip.b-tooltip-secondary.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #6c757d;
}
.tooltip.b-tooltip-secondary.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #6c757d;
}
.tooltip.b-tooltip-secondary.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-secondary.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #6c757d;
}
.tooltip.b-tooltip-secondary .tooltip-inner {
  color: #fff;
  background-color: #6c757d;
}
.tooltip.b-tooltip-success.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #4caf50;
}
.tooltip.b-tooltip-success.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #4caf50;
}
.tooltip.b-tooltip-success.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #4caf50;
}
.tooltip.b-tooltip-success.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-success.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #4caf50;
}
.tooltip.b-tooltip-success .tooltip-inner {
  color: #fff;
  background-color: #4caf50;
}
.tooltip.b-tooltip-info.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #2196f3;
}
.tooltip.b-tooltip-info.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #2196f3;
}
.tooltip.b-tooltip-info.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #2196f3;
}
.tooltip.b-tooltip-info.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-info.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #2196f3;
}
.tooltip.b-tooltip-info .tooltip-inner {
  color: #fff;
  background-color: #2196f3;
}
.tooltip.b-tooltip-warning.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #ffc107;
}
.tooltip.b-tooltip-warning.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #ffc107;
}
.tooltip.b-tooltip-warning.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #ffc107;
}
.tooltip.b-tooltip-warning.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-warning.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #ffc107;
}
.tooltip.b-tooltip-warning .tooltip-inner {
  color: #212529;
  background-color: #ffc107;
}
.tooltip.b-tooltip-danger.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #f44336;
}
.tooltip.b-tooltip-danger.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #f44336;
}
.tooltip.b-tooltip-danger.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #f44336;
}
.tooltip.b-tooltip-danger.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-danger.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #f44336;
}
.tooltip.b-tooltip-danger .tooltip-inner {
  color: #fff;
  background-color: #f44336;
}
.tooltip.b-tooltip-light.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #f8f9fa;
}
.tooltip.b-tooltip-light.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #f8f9fa;
}
.tooltip.b-tooltip-light.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #f8f9fa;
}
.tooltip.b-tooltip-light.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-light.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #f8f9fa;
}
.tooltip.b-tooltip-light .tooltip-inner {
  color: #212529;
  background-color: #f8f9fa;
}
.tooltip.b-tooltip-dark.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #343a40;
}
.tooltip.b-tooltip-dark.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #343a40;
}
.tooltip.b-tooltip-dark.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #343a40;
}
.tooltip.b-tooltip-dark.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-dark.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #343a40;
}
.tooltip.b-tooltip-dark .tooltip-inner {
  color: #fff;
  background-color: #343a40;
}
.tooltip.b-tooltip-infinity.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-infinity.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #e73389;
}
.tooltip.b-tooltip-infinity.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-infinity.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #e73389;
}
.tooltip.b-tooltip-infinity.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-infinity.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #e73389;
}
.tooltip.b-tooltip-infinity.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-infinity.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #e73389;
}
.tooltip.b-tooltip-infinity .tooltip-inner {
  color: #fff;
  background-color: #e73389;
}
.tooltip.b-tooltip-infinityDark.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-infinityDark.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #af2769;
}
.tooltip.b-tooltip-infinityDark.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-infinityDark.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #af2769;
}
.tooltip.b-tooltip-infinityDark.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-infinityDark.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #af2769;
}
.tooltip.b-tooltip-infinityDark.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-infinityDark.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #af2769;
}
.tooltip.b-tooltip-infinityDark .tooltip-inner {
  color: #fff;
  background-color: #af2769;
}
.tooltip.b-tooltip-silver.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-silver.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #bbbbbb;
}
.tooltip.b-tooltip-silver.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-silver.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #bbbbbb;
}
.tooltip.b-tooltip-silver.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-silver.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #bbbbbb;
}
.tooltip.b-tooltip-silver.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-silver.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #bbbbbb;
}
.tooltip.b-tooltip-silver .tooltip-inner {
  color: #212529;
  background-color: #bbbbbb;
}
.tooltip.b-tooltip-whale.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-whale.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #0a3749;
}
.tooltip.b-tooltip-whale.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-whale.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #0a3749;
}
.tooltip.b-tooltip-whale.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-whale.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #0a3749;
}
.tooltip.b-tooltip-whale.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-whale.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #0a3749;
}
.tooltip.b-tooltip-whale .tooltip-inner {
  color: #fff;
  background-color: #0a3749;
}
.tooltip.b-tooltip-cello.bs-tooltip-top .arrow::before, .tooltip.b-tooltip-cello.bs-tooltip-auto[x-placement^=top] .arrow::before {
  border-top-color: #374a58;
}
.tooltip.b-tooltip-cello.bs-tooltip-right .arrow::before, .tooltip.b-tooltip-cello.bs-tooltip-auto[x-placement^=right] .arrow::before {
  border-right-color: #374a58;
}
.tooltip.b-tooltip-cello.bs-tooltip-bottom .arrow::before, .tooltip.b-tooltip-cello.bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  border-bottom-color: #374a58;
}
.tooltip.b-tooltip-cello.bs-tooltip-left .arrow::before, .tooltip.b-tooltip-cello.bs-tooltip-auto[x-placement^=left] .arrow::before {
  border-left-color: #374a58;
}
.tooltip.b-tooltip-cello .tooltip-inner {
  color: #fff;
  background-color: #374a58;
}
.b-icon.bi {
  display: inline-block;
  overflow: visible;
  vertical-align: -0.15em;
}
.b-icon.b-icon-animation-cylon, .b-icon.b-iconstack .b-icon-animation-cylon > g {
  transform-origin: center;
  animation: 0.75s infinite ease-in-out alternate b-icon-animation-cylon;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-cylon, .b-icon.b-iconstack .b-icon-animation-cylon > g {
    animation: none;
}
}
.b-icon.b-icon-animation-cylon-vertical, .b-icon.b-iconstack .b-icon-animation-cylon-vertical > g {
  transform-origin: center;
  animation: 0.75s infinite ease-in-out alternate b-icon-animation-cylon-vertical;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-cylon-vertical, .b-icon.b-iconstack .b-icon-animation-cylon-vertical > g {
    animation: none;
}
}
.b-icon.b-icon-animation-fade, .b-icon.b-iconstack .b-icon-animation-fade > g {
  transform-origin: center;
  animation: 0.75s infinite ease-in-out alternate b-icon-animation-fade;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-fade, .b-icon.b-iconstack .b-icon-animation-fade > g {
    animation: none;
}
}
.b-icon.b-icon-animation-spin, .b-icon.b-iconstack .b-icon-animation-spin > g {
  transform-origin: center;
  animation: 2s infinite linear normal b-icon-animation-spin;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-spin, .b-icon.b-iconstack .b-icon-animation-spin > g {
    animation: none;
}
}
.b-icon.b-icon-animation-spin-reverse, .b-icon.b-iconstack .b-icon-animation-spin-reverse > g {
  transform-origin: center;
  animation: 2s infinite linear reverse b-icon-animation-spin;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-spin-reverse, .b-icon.b-iconstack .b-icon-animation-spin-reverse > g {
    animation: none;
}
}
.b-icon.b-icon-animation-spin-pulse, .b-icon.b-iconstack .b-icon-animation-spin-pulse > g {
  transform-origin: center;
  animation: 1s infinite steps(8) normal b-icon-animation-spin;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-spin-pulse, .b-icon.b-iconstack .b-icon-animation-spin-pulse > g {
    animation: none;
}
}
.b-icon.b-icon-animation-spin-reverse-pulse, .b-icon.b-iconstack .b-icon-animation-spin-reverse-pulse > g {
  transform-origin: center;
  animation: 1s infinite steps(8) reverse b-icon-animation-spin;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-spin-reverse-pulse, .b-icon.b-iconstack .b-icon-animation-spin-reverse-pulse > g {
    animation: none;
}
}
.b-icon.b-icon-animation-throb, .b-icon.b-iconstack .b-icon-animation-throb > g {
  transform-origin: center;
  animation: 0.75s infinite ease-in-out alternate b-icon-animation-throb;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-throb, .b-icon.b-iconstack .b-icon-animation-throb > g {
    animation: none;
}
}
@keyframes b-icon-animation-cylon {
0% {
    transform: translateX(-25%);
}
100% {
    transform: translateX(25%);
}
}
@keyframes b-icon-animation-cylon-vertical {
0% {
    transform: translateY(25%);
}
100% {
    transform: translateY(-25%);
}
}
@keyframes b-icon-animation-fade {
0% {
    opacity: 0.1;
}
100% {
    opacity: 1;
}
}
@keyframes b-icon-animation-spin {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(359deg);
}
}
@keyframes b-icon-animation-throb {
0% {
    opacity: 0.5;
    transform: scale(0.5);
}
100% {
    opacity: 1;
    transform: scale(1);
}
}
.btn .b-icon.bi,
.nav-link .b-icon.bi,
.dropdown-toggle .b-icon.bi,
.dropdown-item .b-icon.bi,
.input-group-text .b-icon.bi {
  font-size: 125%;
  vertical-align: text-bottom;
}
.b-icon.bi {
  display: inline-block;
  overflow: visible;
  vertical-align: -0.15em;
}
.b-icon.b-icon-animation-cylon, .b-icon.b-iconstack .b-icon-animation-cylon > g {
  transform-origin: center;
  animation: 0.75s infinite ease-in-out alternate b-icon-animation-cylon;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-cylon, .b-icon.b-iconstack .b-icon-animation-cylon > g {
    animation: none;
}
}
.b-icon.b-icon-animation-cylon-vertical, .b-icon.b-iconstack .b-icon-animation-cylon-vertical > g {
  transform-origin: center;
  animation: 0.75s infinite ease-in-out alternate b-icon-animation-cylon-vertical;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-cylon-vertical, .b-icon.b-iconstack .b-icon-animation-cylon-vertical > g {
    animation: none;
}
}
.b-icon.b-icon-animation-fade, .b-icon.b-iconstack .b-icon-animation-fade > g {
  transform-origin: center;
  animation: 0.75s infinite ease-in-out alternate b-icon-animation-fade;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-fade, .b-icon.b-iconstack .b-icon-animation-fade > g {
    animation: none;
}
}
.b-icon.b-icon-animation-spin, .b-icon.b-iconstack .b-icon-animation-spin > g {
  transform-origin: center;
  animation: 2s infinite linear normal b-icon-animation-spin;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-spin, .b-icon.b-iconstack .b-icon-animation-spin > g {
    animation: none;
}
}
.b-icon.b-icon-animation-spin-reverse, .b-icon.b-iconstack .b-icon-animation-spin-reverse > g {
  transform-origin: center;
  animation: 2s infinite linear reverse b-icon-animation-spin;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-spin-reverse, .b-icon.b-iconstack .b-icon-animation-spin-reverse > g {
    animation: none;
}
}
.b-icon.b-icon-animation-spin-pulse, .b-icon.b-iconstack .b-icon-animation-spin-pulse > g {
  transform-origin: center;
  animation: 1s infinite steps(8) normal b-icon-animation-spin;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-spin-pulse, .b-icon.b-iconstack .b-icon-animation-spin-pulse > g {
    animation: none;
}
}
.b-icon.b-icon-animation-spin-reverse-pulse, .b-icon.b-iconstack .b-icon-animation-spin-reverse-pulse > g {
  transform-origin: center;
  animation: 1s infinite steps(8) reverse b-icon-animation-spin;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-spin-reverse-pulse, .b-icon.b-iconstack .b-icon-animation-spin-reverse-pulse > g {
    animation: none;
}
}
.b-icon.b-icon-animation-throb, .b-icon.b-iconstack .b-icon-animation-throb > g {
  transform-origin: center;
  animation: 0.75s infinite ease-in-out alternate b-icon-animation-throb;
}
@media (prefers-reduced-motion: reduce) {
.b-icon.b-icon-animation-throb, .b-icon.b-iconstack .b-icon-animation-throb > g {
    animation: none;
}
}
@keyframes b-icon-animation-cylon {
0% {
    transform: translateX(-25%);
}
100% {
    transform: translateX(25%);
}
}
@keyframes b-icon-animation-cylon-vertical {
0% {
    transform: translateY(25%);
}
100% {
    transform: translateY(-25%);
}
}
@keyframes b-icon-animation-fade {
0% {
    opacity: 0.1;
}
100% {
    opacity: 1;
}
}
@keyframes b-icon-animation-spin {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(359deg);
}
}
@keyframes b-icon-animation-throb {
0% {
    opacity: 0.5;
    transform: scale(0.5);
}
100% {
    opacity: 1;
    transform: scale(1);
}
}
.btn .b-icon.bi,
.nav-link .b-icon.bi,
.dropdown-toggle .b-icon.bi,
.dropdown-item .b-icon.bi,
.input-group-text .b-icon.bi {
  font-size: 125%;
  vertical-align: text-bottom;
}

/*!
 * vue2-animate
 * (c) 2018 Pavel Savushkin
 * Released under the MIT License.
 * Documentation: https://github.com/asika32764/vue2-animate
 */
@keyframes bounceIn {
from, 20%, 40%, 60%, 80%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}
0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
}
20% {
    transform: scale3d(1.1, 1.1, 1.1);
}
40% {
    transform: scale3d(0.9, 0.9, 0.9);
}
60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
}
80% {
    transform: scale3d(0.97, 0.97, 0.97);
}
to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
}
}
@keyframes bounceOut {
20% {
    transform: scale3d(0.9, 0.9, 0.9);
}
50%, 55% {
    opacity: 1;
    transform: scale3d(1.1, 1.1, 1.1);
}
to {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
}
}
@keyframes bounceInDown {
from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}
0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0);
}
60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0);
}
75% {
    transform: translate3d(0, -10px, 0);
}
90% {
    transform: translate3d(0, 5px, 0);
}
to {
    transform: none;
}
}
@keyframes bounceOutDown {
20% {
    transform: translate3d(0, 10px, 0);
}
40%, 45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
}
to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
}
}
@keyframes bounceInLeft {
from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}
0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
}
60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
}
75% {
    transform: translate3d(-10px, 0, 0);
}
90% {
    transform: translate3d(5px, 0, 0);
}
to {
    transform: none;
}
}
@keyframes bounceOutLeft {
20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0);
}
to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
}
}
@keyframes bounceInRight {
from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}
from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
}
60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
}
75% {
    transform: translate3d(10px, 0, 0);
}
90% {
    transform: translate3d(-5px, 0, 0);
}
to {
    transform: none;
}
}
@keyframes bounceOutRight {
20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0);
}
to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
}
}
@keyframes bounceInUp {
from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}
from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
}
60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
}
75% {
    transform: translate3d(0, 10px, 0);
}
90% {
    transform: translate3d(0, -5px, 0);
}
to {
    transform: translate3d(0, 0, 0);
}
}
@keyframes bounceOutUp {
20% {
    transform: translate3d(0, -10px, 0);
}
40%, 45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0);
}
to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
}
}
.bounce-enter-active, .bounceIn,
.bounce-leave-active, .bounceOut {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.bounce-enter-active, .bounceIn {
  animation-name: bounceIn;
}
.bounce-leave-active, .bounceOut {
  animation-name: bounceOut;
}
.bounceDown-enter-active, .bounceInDown,
.bounceDown-leave-active, .bounceOutDown {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.bounceDown-enter-active, .bounceInDown {
  animation-name: bounceInDown;
}
.bounceDown-leave-active, .bounceOutDown {
  animation-name: bounceOutDown;
}
.bounceLeft-enter-active, .bounceInLeft,
.bounceLeft-leave-active, .bounceOutLeft {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.bounceLeft-enter-active, .bounceInLeft {
  animation-name: bounceInLeft;
}
.bounceLeft-leave-active, .bounceOutLeft {
  animation-name: bounceOutLeft;
}
.bounceRight-enter-active, .bounceInRight,
.bounceRight-leave-active, .bounceOutRight {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.bounceRight-enter-active, .bounceInRight {
  animation-name: bounceInRight;
}
.bounceRight-leave-active, .bounceOutRight {
  animation-name: bounceOutRight;
}
.bounceUp-enter-active, .bounceInUp,
.bounceUp-leave-active, .bounceOutUp {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.bounceUp-enter-active, .bounceInUp {
  animation-name: bounceInUp;
}
.bounceUp-leave-active, .bounceOutUp {
  animation-name: bounceOutUp;
}
@keyframes fadeIn {
from {
    opacity: 0;
}
to {
    opacity: 1;
}
}
@keyframes fadeOut {
from {
    opacity: 1;
}
to {
    opacity: 0;
}
}
@keyframes fadeInDown {
from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
}
to {
    opacity: 1;
    transform: none;
}
}
@keyframes fadeOutDown {
from {
    opacity: 1;
}
to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
}
}
@keyframes fadeInDownBig {
from {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
}
to {
    opacity: 1;
    transform: none;
}
}
@keyframes fadeOutDownBig {
from {
    opacity: 1;
}
to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
}
}
@keyframes fadeInLeft {
from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}
to {
    opacity: 1;
    transform: none;
}
}
@keyframes fadeOutLeft {
from {
    opacity: 1;
}
to {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
}
}
@keyframes fadeInLeftBig {
from {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
}
to {
    opacity: 1;
    transform: none;
}
}
@keyframes fadeOutLeftBig {
from {
    opacity: 1;
}
to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
}
}
@keyframes fadeInRight {
from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
to {
    opacity: 1;
    transform: none;
}
}
@keyframes fadeOutRight {
from {
    opacity: 1;
}
to {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
}
}
@keyframes fadeInRightBig {
from {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
}
to {
    opacity: 1;
    transform: none;
}
}
@keyframes fadeOutRightBig {
from {
    opacity: 1;
}
to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
}
}
@keyframes fadeInUp {
from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
}
to {
    opacity: 1;
    transform: none;
}
}
@keyframes fadeOutUp {
from {
    opacity: 1;
}
to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
}
}
@keyframes fadeInUpBig {
from {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
}
to {
    opacity: 1;
    transform: none;
}
}
@keyframes fadeOutUpBig {
from {
    opacity: 1;
}
to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
}
}
.fade-enter-active, .fadeIn,
.fade-leave-active, .fadeOut {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.fade-enter-active, .fadeIn {
  animation-name: fadeIn;
}
.fade-leave-active, .fadeOut {
  animation-name: fadeOut;
}
.fadeDown-enter-active, .fadeInDown,
.fadeDown-leave-active, .fadeOutDown {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.fadeDown-enter-active, .fadeInDown {
  animation-name: fadeInDown;
}
.fadeDown-leave-active, .fadeOutDown {
  animation-name: fadeOutDown;
}
.fadeDownBig-enter-active, .fadeInDownBig,
.fadeDownBig-leave-active, .fadeOutDownBig {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.fadeDownBig-enter-active, .fadeInDownBig {
  animation-name: fadeInDownBig;
}
.fadeDownBig-leave-active, .fadeOutDownBig {
  animation-name: fadeOutDownBig;
}
.fadeLeft-enter-active, .fadeInLeft,
.fadeLeft-leave-active, .fadeOutLeft {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.fadeLeft-enter-active, .fadeInLeft {
  animation-name: fadeInLeft;
}
.fadeLeft-leave-active, .fadeOutLeft {
  animation-name: fadeOutLeft;
}
.fadeLeftBig-enter-active, .fadeInLeftBig,
.fadeLeftBig-leave-active, .fadeOutLeftBig {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.fadeLeftBig-enter-active, .fadeInLeftBig {
  animation-name: fadeInLeftBig;
}
.fadeLeftBig-leave-active, .fadeOutLeftBig {
  animation-name: fadeOutLeftBig;
}
.fadeRight-enter-active, .fadeInRight,
.fadeRight-leave-active, .fadeOutRight {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.fadeRight-enter-active, .fadeInRight {
  animation-name: fadeInRight;
}
.fadeRight-leave-active, .fadeOutRight {
  animation-name: fadeOutRight;
}
.fadeRightBig-enter-active, .fadeInRightBig,
.fadeRightBig-leave-active, .fadeOutRightBig {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.fadeRightBig-enter-active, .fadeInRightBig {
  animation-name: fadeInRightBig;
}
.fadeRightBig-leave-active, .fadeOutRightBig {
  animation-name: fadeOutRightBig;
}
.fadeUp-enter-active, .fadeInUp,
.fadeUp-leave-active, .fadeOutUp {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.fadeUp-enter-active, .fadeInUp {
  animation-name: fadeInUp;
}
.fadeUp-leave-active, .fadeOutUp {
  animation-name: fadeOutUp;
}
.fadeUpBig-enter-active, .fadeInUpBig,
.fadeUpBig-leave-active, .fadeOutUpBig {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.fadeUpBig-enter-active, .fadeInUpBig {
  animation-name: fadeInUpBig;
}
.fadeUpBig-leave-active, .fadeOutUpBig {
  animation-name: fadeOutUpBig;
}
@keyframes rotateIn {
from {
    transform-origin: center;
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
}
to {
    transform-origin: center;
    transform: none;
    opacity: 1;
}
}
@keyframes rotateOut {
from {
    transform-origin: center;
    opacity: 1;
}
to {
    transform-origin: center;
    transform: rotate3d(0, 0, 1, 200deg);
    opacity: 0;
}
}
@keyframes rotateInDownLeft {
from {
    transform-origin: left bottom;
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
}
to {
    transform-origin: left bottom;
    transform: none;
    opacity: 1;
}
}
@keyframes rotateOutDownLeft {
from {
    transform-origin: left bottom;
    opacity: 1;
}
to {
    transform-origin: left bottom;
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
}
}
@keyframes rotateInDownRight {
from {
    transform-origin: right bottom;
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
}
to {
    transform-origin: right bottom;
    transform: none;
    opacity: 1;
}
}
@keyframes rotateOutDownRight {
from {
    transform-origin: right bottom;
    opacity: 1;
}
to {
    transform-origin: right bottom;
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
}
}
@keyframes rotateInUpLeft {
from {
    transform-origin: left bottom;
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
}
to {
    transform-origin: left bottom;
    transform: none;
    opacity: 1;
}
}
@keyframes rotateOutUpLeft {
from {
    transform-origin: left bottom;
    opacity: 1;
}
to {
    transform-origin: left bottom;
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
}
}
@keyframes rotateInUpRight {
from {
    transform-origin: right bottom;
    transform: rotate3d(0, 0, 1, -90deg);
    opacity: 0;
}
to {
    transform-origin: right bottom;
    transform: none;
    opacity: 1;
}
}
@keyframes rotateOutUpRight {
from {
    transform-origin: right bottom;
    opacity: 1;
}
to {
    transform-origin: right bottom;
    transform: rotate3d(0, 0, 1, 90deg);
    opacity: 0;
}
}
.rotate-enter-active, .rotateIn,
.rotate-leave-active, .rotateOut {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.rotate-enter-active, .rotateIn {
  animation-name: rotateIn;
}
.rotate-leave-active, .rotateOut {
  animation-name: rotateOut;
}
.rotateDownLeft-enter-active, .rotateInDownLeft,
.rotateDownLeft-leave-active, .rotateOutDownLeft {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.rotateDownLeft-enter-active, .rotateInDownLeft {
  animation-name: rotateInDownLeft;
}
.rotateDownLeft-leave-active, .rotateOutDownLeft {
  animation-name: rotateOutDownLeft;
}
.rotateDownRight-enter-active, .rotateInDownRight,
.rotateDownRight-leave-active, .rotateOutDownRight {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.rotateDownRight-enter-active, .rotateInDownRight {
  animation-name: rotateInDownRight;
}
.rotateDownRight-leave-active, .rotateOutDownRight {
  animation-name: rotateOutDownRight;
}
.rotateUpLeft-enter-active, .rotateInUpLeft,
.rotateUpLeft-leave-active, .rotateOutUpLeft {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.rotateUpLeft-enter-active, .rotateInUpLeft {
  animation-name: rotateInUpLeft;
}
.rotateUpLeft-leave-active, .rotateOutUpLeft {
  animation-name: rotateOutUpLeft;
}
.rotateUpRight-enter-active, .rotateInUpRight,
.rotateUpRight-leave-active, .rotateOutUpRight {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.rotateUpRight-enter-active, .rotateInUpRight {
  animation-name: rotateInUpRight;
}
.rotateUpRight-leave-active, .rotateOutUpRight {
  animation-name: rotateOutUpRight;
}
@keyframes slideInDown {
from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
}
to {
    transform: translate3d(0, 0, 0);
}
}
@keyframes slideOutDown {
from {
    transform: translate3d(0, 0, 0);
}
to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
}
}
@keyframes slideInLeft {
from {
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
}
to {
    transform: translate3d(0, 0, 0);
}
}
@keyframes slideOutLeft {
from {
    transform: translate3d(0, 0, 0);
}
to {
    visibility: hidden;
    transform: translate3d(-100%, 0, 0);
}
}
@keyframes slideInRight {
from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
}
to {
    transform: translate3d(0, 0, 0);
}
}
@keyframes slideOutRight {
from {
    transform: translate3d(0, 0, 0);
}
to {
    visibility: hidden;
    transform: translate3d(100%, 0, 0);
}
}
@keyframes slideInUp {
from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
}
to {
    transform: translate3d(0, 0, 0);
}
}
@keyframes slideOutUp {
from {
    transform: translate3d(0, 0, 0);
}
to {
    visibility: hidden;
    transform: translate3d(0, -100%, 0);
}
}
.slide-enter-active, .slideIn,
.slide-leave-active, .slideOut {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.slide-enter-active, .slideIn {
  animation-name: slideIn;
}
.slide-leave-active, .slideOut {
  animation-name: slideOut;
}
.slideDown-enter-active, .slideInDown,
.slideDown-leave-active, .slideOutDown {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.slideDown-enter-active, .slideInDown {
  animation-name: slideInDown;
}
.slideDown-leave-active, .slideOutDown {
  animation-name: slideOutDown;
}
.slideLeft-enter-active, .slideInLeft,
.slideLeft-leave-active, .slideOutLeft {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.slideLeft-enter-active, .slideInLeft {
  animation-name: slideInLeft;
}
.slideLeft-leave-active, .slideOutLeft {
  animation-name: slideOutLeft;
}
.slideRight-enter-active, .slideInRight,
.slideRight-leave-active, .slideOutRight {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.slideRight-enter-active, .slideInRight {
  animation-name: slideInRight;
}
.slideRight-leave-active, .slideOutRight {
  animation-name: slideOutRight;
}
.slideUp-enter-active, .slideInUp,
.slideUp-leave-active, .slideOutUp {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.slideUp-enter-active, .slideInUp {
  animation-name: slideInUp;
}
.slideUp-leave-active, .slideOutUp {
  animation-name: slideOutUp;
}
@keyframes zoomIn {
from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
}
50% {
    opacity: 1;
}
}
@keyframes zoomOut {
from {
    opacity: 1;
}
50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
}
to {
    opacity: 0;
}
}
@keyframes zoomInDown {
from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
}
}
@keyframes zoomOutDown {
40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
to {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    transform-origin: center bottom;
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
}
}
@keyframes zoomInLeft {
from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
}
}
@keyframes zoomOutLeft {
40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
}
to {
    opacity: 0;
    transform: scale(0.1) translate3d(-2000px, 0, 0);
    transform-origin: left center;
}
}
@keyframes zoomInRight {
from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
}
}
@keyframes zoomOutRight {
40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
}
to {
    opacity: 0;
    transform: scale(0.1) translate3d(2000px, 0, 0);
    transform-origin: right center;
}
}
@keyframes zoomInUp {
from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
}
}
@keyframes zoomOutUp {
40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
to {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    transform-origin: center bottom;
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
}
}
.zoom-enter-active, .zoomIn,
.zoom-leave-active, .zoomOut {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.zoom-enter-active, .zoomIn {
  animation-name: zoomIn;
}
.zoom-leave-active, .zoomOut {
  animation-name: zoomOut;
}
.zoomDown-enter-active, .zoomInDown,
.zoomDown-leave-active, .zoomOutDown {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.zoomDown-enter-active, .zoomInDown {
  animation-name: zoomInDown;
}
.zoomDown-leave-active, .zoomOutDown {
  animation-name: zoomOutDown;
}
.zoomLeft-enter-active, .zoomInLeft,
.zoomLeft-leave-active, .zoomOutLeft {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.zoomLeft-enter-active, .zoomInLeft {
  animation-name: zoomInLeft;
}
.zoomLeft-leave-active, .zoomOutLeft {
  animation-name: zoomOutLeft;
}
.zoomRight-enter-active, .zoomInRight,
.zoomRight-leave-active, .zoomOutRight {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.zoomRight-enter-active, .zoomInRight {
  animation-name: zoomInRight;
}
.zoomRight-leave-active, .zoomOutRight {
  animation-name: zoomOutRight;
}
.zoomUp-enter-active, .zoomInUp,
.zoomUp-leave-active, .zoomOutUp {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.zoomUp-enter-active, .zoomInUp {
  animation-name: zoomInUp;
}
.zoomUp-leave-active, .zoomOutUp {
  animation-name: zoomOutUp;
}
@keyframes flipIn {
from {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);
    animation-timing-function: ease-out;
    opacity: 0;
}
40% {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);
    animation-timing-function: ease-out;
    opacity: 0.4;
}
50% {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);
    animation-timing-function: ease-in;
    opacity: 0.5;
}
80% {
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);
    animation-timing-function: ease-in;
    opacity: 0.8;
}
to {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);
    animation-timing-function: ease-in;
    opacity: 1;
}
}
@keyframes flipOut {
from {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);
    animation-timing-function: ease-in;
    opacity: 1;
}
40% {
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);
    animation-timing-function: ease-in;
    opacity: 0.6;
}
50% {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -170deg);
    animation-timing-function: ease-in;
    opacity: 0.5;
}
80% {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px) rotate3d(0, 1, 0, -190deg);
    animation-timing-function: ease-out;
    opacity: 0.2;
}
to {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);
    animation-timing-function: ease-out;
    opacity: 0;
}
}
@keyframes flipInX {
from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
}
40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
}
60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
}
80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
}
to {
    transform: perspective(400px);
}
}
@keyframes flipInY {
from {
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
}
40% {
    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
    animation-timing-function: ease-in;
}
60% {
    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
    opacity: 1;
}
80% {
    transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
}
to {
    transform: perspective(400px);
}
}
@keyframes flipOutX {
from {
    transform: perspective(400px);
}
30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
}
to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
}
}
@keyframes flipOutY {
from {
    transform: perspective(400px);
}
30% {
    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
    opacity: 1;
}
to {
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    opacity: 0;
}
}
.flip-enter-active, .flipIn,
.flip-leave-active, .flipOut {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.flip-enter-active, .flipIn {
  animation-name: flipIn;
}
.flip-leave-active, .flipOut {
  animation-name: flipOut;
}
.flipX-enter-active, .flipInX,
.flipX-leave-active, .flipOutX {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.flipX-enter-active, .flipInX {
  animation-name: flipInX;
}
.flipX-leave-active, .flipOutX {
  animation-name: flipOutX;
}
.flipY-enter-active, .flipInY,
.flipY-leave-active, .flipOutY {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.flipY-enter-active, .flipInY {
  animation-name: flipInY;
}
.flipY-leave-active, .flipOutY {
  animation-name: flipOutY;
}
@keyframes lightSpeedIn {
from {
    transform: translate3d(100%, 0, 0) skewX(-30deg);
    opacity: 0;
}
60% {
    transform: skewX(20deg);
    opacity: 1;
}
80% {
    transform: skewX(-5deg);
}
to {
    transform: translate3d(0, 0, 0);
}
}
@keyframes lightSpeedOut {
from {
    opacity: 1;
}
to {
    transform: translate3d(100%, 0, 0) skewX(30deg);
    opacity: 0;
}
}
.lightSpeed-enter-active, .lightSpeedIn,
.lightSpeed-leave-active, .lightSpeedOut {
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.lightSpeed-enter-active, .lightSpeedIn {
  animation-name: lightSpeedIn;
}
.lightSpeed-leave-active, .lightSpeedOut {
  animation-name: lightSpeedOut;
}
#app {
  min-height: 100%;
  letter-spacing: 0.3px;
  fill: currentColor;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
